/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Agroevidence API
 * OpenAPI spec version: 1.0.0
 */
import axios from 'axios';
import type {
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

export interface InternalCenterCreateTo {
  key: string;
  name: string;
}

export interface InternalCenterTo {
  id: string;
  key: string;
  name: string;
}

export interface JsonNullableDouble {
  present?: boolean;
}

export interface SeedApplicationV2UpdateTo {
  /** @nullable */
  seedId?: string | null;
  /** @nullable */
  dateStart?: string | null;
  /** @nullable */
  dateEnd?: string | null;
  /**
     * @maximum 100000
     * @nullable
     */
  areaHa?: number | null;
  /** @nullable */
  cropUseTypeId?: string | null;
  /** @nullable */
  isCatchCrop?: boolean | null;
  /** @nullable */
  mainHarvestableProduct?: string | null;
  expectedYieldTonnesHa?: JsonNullableDouble;
}

export type CatalogueRole = typeof CatalogueRole[keyof typeof CatalogueRole];


export const CatalogueRole = {
  OWNER: 'OWNER',
  EDITOR: 'EDITOR',
  VIEWER: 'VIEWER',
} as const;

export type CatalogueType = typeof CatalogueType[keyof typeof CatalogueType];


export const CatalogueType = {
  EAGRI: 'EAGRI',
  PPA_SK: 'PPA_SK',
  PRIVATE: 'PRIVATE',
} as const;

export interface CatalogueTo {
  id: string;
  type: CatalogueType;
  role: CatalogueRole;
  canUpdate: boolean;
}

export interface ColorTo {
  red: number;
  green: number;
  blue: number;
  asDecimal: number;
}

export interface CropGroupTo {
  /** Crop group legislative id / external id */
  id: string;
  externalId: string;
  /** @nullable */
  name?: string | null;
  /**
     * Will be removed after with CFD-3673
     * @deprecated
     */
  legislativeCode: string;
}

export type CropLifespan = typeof CropLifespan[keyof typeof CropLifespan];


export const CropLifespan = {
  ANNUAL: 'ANNUAL',
  PERENNIAL: 'PERENNIAL',
} as const;

export interface CropProductTo {
  id: string;
  description: string;
  isMain: boolean;
  /** @nullable */
  externalId?: string | null;
}

export interface CropTo {
  id: string;
  name: string;
  externalId: number;
  catalogueType: CatalogueType;
  group?: CropGroupTo | null;
  /** @nullable */
  validFrom?: string | null;
  /** @nullable */
  validTo?: string | null;
  color: ColorTo;
  textColor: ColorTo;
  isNoCrop: boolean;
  /** @nullable */
  isWinterCrop?: boolean | null;
  /** @nullable */
  isSpringCrop?: boolean | null;
  lifespan?: CropLifespan | null;
  varieties: string[];
  mainProducts: string[];
  secondaryProducts: string[];
  cropUseTypes: string[];
}

export interface CropSeedTo {
  id: string;
  catalogue: CatalogueTo;
  isHidden: boolean;
  isFavorite: boolean;
  /** @nullable */
  varietyName?: string | null;
  crop: CropTo;
  name: string;
}

export interface CropUseTypeTo {
  id: string;
  description: string;
}

export type SeedApplicationType = typeof SeedApplicationType[keyof typeof SeedApplicationType];


export const SeedApplicationType = {
  CATCH_CROP: 'CATCH_CROP',
  MAIN_CROP: 'MAIN_CROP',
} as const;

/**
 * Seed applications overlapping the season date range; one application can appear in multiple seasons. Grouped seed applications (megaosevy) are collapsed into a single group with aggregated start/end dates
 */
export interface SeedApplicationV2ResultTo {
  type: SeedApplicationType;
  seed?: CropSeedTo;
  expectedYieldTonnesHa?: number;
  cropUse?: CropUseTypeTo;
  cropProduct?: CropProductTo;
  startDate: string;
  endDate?: string;
  firstSowingDate?: string;
  lastHarvestDate?: string;
  isHarvestable: boolean;
  totalArea: number;
  resultType: string;
}

export type SeedApplicationV2To = SeedApplicationV2ResultTo & ({
  id: string;
  seed?: CropSeedTo | null;
  /** @nullable */
  endDate?: string | null;
  sownArea: number;
  parcelId: string;
  /** @nullable */
  groupId?: string | null;
  cropUse?: CropUseTypeTo | null;
  cropProduct?: CropProductTo | null;
  /** @nullable */
  firstSowingDate?: string | null;
  /** @nullable */
  lastHarvestDate?: string | null;
  /** @nullable */
  expectedYieldTonnesHa?: number | null;
});

export interface SeedApplicationV2MemberUpdateTo {
  id: string;
  /** @nullable */
  dateStart?: string | null;
  /** @nullable */
  dateEnd?: string | null;
  /** @nullable */
  areaHa?: number | null;
  /** @nullable */
  groupId?: string | null;
  deleted: boolean;
  /** @nullable */
  expectedYieldTonnesHa?: number | null;
}

export interface SeedApplicationV2GroupUpdateTo {
  /** @nullable */
  seedId?: string | null;
  /** @nullable */
  cropUseTypeId?: string | null;
  /** @nullable */
  isCatchCrop?: boolean | null;
  /** @nullable */
  mainHarvestableProduct?: string | null;
  /** @nullable */
  seedApplications?: SeedApplicationV2MemberUpdateTo[] | null;
}

export type SeedApplicationGroupPosition = typeof SeedApplicationGroupPosition[keyof typeof SeedApplicationGroupPosition];


export const SeedApplicationGroupPosition = {
  FIRST: 'FIRST',
  MIDDLE: 'MIDDLE',
  LAST: 'LAST',
  MULTIPLE: 'MULTIPLE',
} as const;

export type SeedApplicationV2GroupToV2 = SeedApplicationV2ResultTo & ({
  groupId: string;
  seedApplications: SeedApplicationV2To[];
  seed?: CropSeedTo | null;
  /** @nullable */
  endDate?: string | null;
  cropUse?: CropUseTypeTo | null;
  cropProduct?: CropProductTo | null;
  parcelIds: string[];
  /** @nullable */
  firstSowingDate?: string | null;
  /** @nullable */
  lastHarvestDate?: string | null;
  /** @nullable */
  expectedYieldTonnesHa?: number | null;
  positionInGroup?: SeedApplicationGroupPosition | null;
});

export type EagriServiceEnvironment = typeof EagriServiceEnvironment[keyof typeof EagriServiceEnvironment];


export const EagriServiceEnvironment = {
  PRODUCTION: 'PRODUCTION',
  TEST: 'TEST',
} as const;

export interface EagriAuthDataValidationRequestTo {
  login: string;
  secret: string;
  szrid: string;
  environment?: EagriServiceEnvironment | null;
}

export type HttpStatus = typeof HttpStatus[keyof typeof HttpStatus];


export const HttpStatus = {
  '100_CONTINUE': '100 CONTINUE',
  '101_SWITCHING_PROTOCOLS': '101 SWITCHING_PROTOCOLS',
  '102_PROCESSING': '102 PROCESSING',
  '103_EARLY_HINTS': '103 EARLY_HINTS',
  '200_OK': '200 OK',
  '201_CREATED': '201 CREATED',
  '202_ACCEPTED': '202 ACCEPTED',
  '203_NON_AUTHORITATIVE_INFORMATION': '203 NON_AUTHORITATIVE_INFORMATION',
  '204_NO_CONTENT': '204 NO_CONTENT',
  '205_RESET_CONTENT': '205 RESET_CONTENT',
  '206_PARTIAL_CONTENT': '206 PARTIAL_CONTENT',
  '207_MULTI_STATUS': '207 MULTI_STATUS',
  '208_ALREADY_REPORTED': '208 ALREADY_REPORTED',
  '226_IM_USED': '226 IM_USED',
  '300_MULTIPLE_CHOICES': '300 MULTIPLE_CHOICES',
  '301_MOVED_PERMANENTLY': '301 MOVED_PERMANENTLY',
  '302_FOUND': '302 FOUND',
  '303_SEE_OTHER': '303 SEE_OTHER',
  '304_NOT_MODIFIED': '304 NOT_MODIFIED',
  '307_TEMPORARY_REDIRECT': '307 TEMPORARY_REDIRECT',
  '308_PERMANENT_REDIRECT': '308 PERMANENT_REDIRECT',
  '400_BAD_REQUEST': '400 BAD_REQUEST',
  '401_UNAUTHORIZED': '401 UNAUTHORIZED',
  '402_PAYMENT_REQUIRED': '402 PAYMENT_REQUIRED',
  '403_FORBIDDEN': '403 FORBIDDEN',
  '404_NOT_FOUND': '404 NOT_FOUND',
  '405_METHOD_NOT_ALLOWED': '405 METHOD_NOT_ALLOWED',
  '406_NOT_ACCEPTABLE': '406 NOT_ACCEPTABLE',
  '407_PROXY_AUTHENTICATION_REQUIRED': '407 PROXY_AUTHENTICATION_REQUIRED',
  '408_REQUEST_TIMEOUT': '408 REQUEST_TIMEOUT',
  '409_CONFLICT': '409 CONFLICT',
  '410_GONE': '410 GONE',
  '411_LENGTH_REQUIRED': '411 LENGTH_REQUIRED',
  '412_PRECONDITION_FAILED': '412 PRECONDITION_FAILED',
  '413_CONTENT_TOO_LARGE': '413 CONTENT_TOO_LARGE',
  '413_PAYLOAD_TOO_LARGE': '413 PAYLOAD_TOO_LARGE',
  '414_URI_TOO_LONG': '414 URI_TOO_LONG',
  '415_UNSUPPORTED_MEDIA_TYPE': '415 UNSUPPORTED_MEDIA_TYPE',
  '416_REQUESTED_RANGE_NOT_SATISFIABLE': '416 REQUESTED_RANGE_NOT_SATISFIABLE',
  '417_EXPECTATION_FAILED': '417 EXPECTATION_FAILED',
  '418_I_AM_A_TEAPOT': '418 I_AM_A_TEAPOT',
  '421_MISDIRECTED_REQUEST': '421 MISDIRECTED_REQUEST',
  '422_UNPROCESSABLE_CONTENT': '422 UNPROCESSABLE_CONTENT',
  '422_UNPROCESSABLE_ENTITY': '422 UNPROCESSABLE_ENTITY',
  '423_LOCKED': '423 LOCKED',
  '424_FAILED_DEPENDENCY': '424 FAILED_DEPENDENCY',
  '425_TOO_EARLY': '425 TOO_EARLY',
  '426_UPGRADE_REQUIRED': '426 UPGRADE_REQUIRED',
  '428_PRECONDITION_REQUIRED': '428 PRECONDITION_REQUIRED',
  '429_TOO_MANY_REQUESTS': '429 TOO_MANY_REQUESTS',
  '431_REQUEST_HEADER_FIELDS_TOO_LARGE': '431 REQUEST_HEADER_FIELDS_TOO_LARGE',
  '451_UNAVAILABLE_FOR_LEGAL_REASONS': '451 UNAVAILABLE_FOR_LEGAL_REASONS',
  '500_INTERNAL_SERVER_ERROR': '500 INTERNAL_SERVER_ERROR',
  '501_NOT_IMPLEMENTED': '501 NOT_IMPLEMENTED',
  '502_BAD_GATEWAY': '502 BAD_GATEWAY',
  '503_SERVICE_UNAVAILABLE': '503 SERVICE_UNAVAILABLE',
  '504_GATEWAY_TIMEOUT': '504 GATEWAY_TIMEOUT',
  '505_HTTP_VERSION_NOT_SUPPORTED': '505 HTTP_VERSION_NOT_SUPPORTED',
  '506_VARIANT_ALSO_NEGOTIATES': '506 VARIANT_ALSO_NEGOTIATES',
  '507_INSUFFICIENT_STORAGE': '507 INSUFFICIENT_STORAGE',
  '508_LOOP_DETECTED': '508 LOOP_DETECTED',
  '509_BANDWIDTH_LIMIT_EXCEEDED': '509 BANDWIDTH_LIMIT_EXCEEDED',
  '510_NOT_EXTENDED': '510 NOT_EXTENDED',
  '511_NETWORK_AUTHENTICATION_REQUIRED': '511 NETWORK_AUTHENTICATION_REQUIRED',
} as const;

export type EagriUpdateErrorType = typeof EagriUpdateErrorType[keyof typeof EagriUpdateErrorType];


export const EagriUpdateErrorType = {
  EAGRI_AUTH_NOT_FOUND: 'EAGRI_AUTH_NOT_FOUND',
  SERVICE_BLOCKED: 'SERVICE_BLOCKED',
  SERVICE_WRONG_ACCESS_KEY_HASH: 'SERVICE_WRONG_ACCESS_KEY_HASH',
  TOO_MANY_UPDATES: 'TOO_MANY_UPDATES',
  TOO_MANY_SEARCHES: 'TOO_MANY_SEARCHES',
  UPDATE_ALREADY_IN_PROGRESS: 'UPDATE_ALREADY_IN_PROGRESS',
  UNEXPECTED_EAGRI_ERROR_WITHOUT_CODE: 'UNEXPECTED_EAGRI_ERROR_WITHOUT_CODE',
  UNEXPECTED_EAGRI_ERROR_WITH_CODE: 'UNEXPECTED_EAGRI_ERROR_WITH_CODE',
  NONPERMISSIBLE_DATE: 'NONPERMISSIBLE_DATE',
  NONEAGRI_FARM: 'NONEAGRI_FARM',
} as const;

export interface EagriAuthValidationResultTo {
  /** @nullable */
  farmName?: string | null;
  status: HttpStatus;
  errorCode?: EagriUpdateErrorType | null;
  /** @nullable */
  eagriCode?: string | null;
  /** @nullable */
  eagriMessage?: string | null;
  success: boolean;
}

export interface EagriAuthDataValidationResponseTo {
  /** @nullable */
  login?: string | null;
  /** @nullable */
  szrid?: string | null;
  environment?: EagriServiceEnvironment | null;
  validation: EagriAuthValidationResultTo;
}

export type EagriFullFarmUpdateMode = typeof EagriFullFarmUpdateMode[keyof typeof EagriFullFarmUpdateMode];


export const EagriFullFarmUpdateMode = {
  DRY: 'DRY',
  BLOCKS: 'BLOCKS',
  BLOCKS_AND_PARCELS: 'BLOCKS_AND_PARCELS',
  SEED_APPS_V2: 'SEED_APPS_V2',
  BLOCKS_AND_PARCELS_V2: 'BLOCKS_AND_PARCELS_V2',
} as const;

export interface ParcelRetirement {
  parcelId: string;
  retireTo: string;
}

export interface IdentityRotationResolution {
  parcelRetirements: ParcelRetirement[];
}

export interface EagriUpdateRequestBody {
  identityRotationResolution?: IdentityRotationResolution | null;
}

export type FacilityType = typeof FacilityType[keyof typeof FacilityType];


export const FacilityType = {
  STORAGE: 'STORAGE',
  SEED_TREATMENT_STATION: 'SEED_TREATMENT_STATION',
  GREENHOUSE: 'GREENHOUSE',
  OTHER: 'OTHER',
} as const;

export type FacilityUnit = typeof FacilityUnit[keyof typeof FacilityUnit];


export const FacilityUnit = {
  M2: 'M2',
  M3: 'M3',
  KG: 'KG',
  T: 'T',
} as const;

/**
 * Facility update. Type and unit of a used facility cannot change.
 */
export interface FacilityUpdateTo {
  type: FacilityType;
  /**
     * Unique within the farm regardless of case
     * @maxLength 255
     */
  name: string;
  unit: FacilityUnit;
}

/**
 * Farm facility a non-field action is applied in
 */
export interface FacilityTo {
  id: string;
  type: FacilityType;
  name: string;
  unit: FacilityUnit;
  /** The facility has at least one action. A used facility cannot be deleted and only its name can change. */
  isUsed: boolean;
}

export interface PlantProtectionActiveSubstanceCreateTo {
  activeSubstanceId: string;
  /** @nullable */
  amountPerArea?: string | null;
  /** @nullable */
  unit?: string | null;
}

export interface PlantProtectionCreateUpdateTo {
  name: string;
  /** @nullable */
  usableUntil?: string | null;
  /** @nullable */
  bioFunction?: string | null;
  isEco: boolean;
  /** @nullable */
  activeSubstances?: PlantProtectionActiveSubstanceCreateTo[] | null;
  /** @nullable */
  notes?: string | null;
  isFavorite: boolean;
  /** @nullable */
  externalId?: string | null;
}

export interface ActiveSubstanceTo {
  id: string;
  /** @nullable */
  externalId?: string | null;
  name: string;
  /** @nullable */
  nameEn?: string | null;
  catalogue: CatalogueTo;
  isIntegratedProductionVineyard: boolean;
  isIntegratedProductionOrchard: boolean;
  isIntegratedProductionVegetable: boolean;
}

export interface PlantProtectionRegistrationDataTo {
  id: string;
  /** @nullable */
  externalId?: string | null;
  /** @nullable */
  registrationHolder?: string | null;
}

export interface PlantProtectionDetailTo {
  id: string;
  name: string;
  isEco: boolean;
  /** @nullable */
  externalId?: string | null;
  /** @nullable */
  usableUntil?: string | null;
  /** @nullable */
  note?: string | null;
  catalogue: CatalogueTo;
  /** @nullable */
  bioFunction?: string | null;
  /** @nullable */
  registrations?: PlantProtectionRegistrationDataTo[] | null;
  /** @nullable */
  activeSubstances?: ActiveSubstanceTo[] | null;
  isFavorite: boolean;
}

export interface PlantProtectionRegistrationCreateUpdateTo {
  /** @nullable */
  authorizationHolder?: string | null;
  /** @nullable */
  externalRegistrationId?: string | null;
  /** @nullable */
  registrationNumber?: string | null;
  /** @nullable */
  usableUntil?: string | null;
}

export interface PlantProtectionRegistrationTo {
  id: string;
  /** @nullable */
  authorizationHolder?: string | null;
  /** @nullable */
  externalRegistrationId?: string | null;
  /** @nullable */
  registrationNumber?: string | null;
  /** @nullable */
  usableUntil?: string | null;
  isValid: boolean;
}

export type ApplicationBufferType = typeof ApplicationBufferType[keyof typeof ApplicationBufferType];


export const ApplicationBufferType = {
  Boundary: 'Boundary',
  BoundarySpring: 'BoundarySpring',
  BoundaryAutumn: 'BoundaryAutumn',
  BoundaryPreEmergent: 'BoundaryPreEmergent',
  BoundaryPostEmergent: 'BoundaryPostEmergent',
  Water: 'Water',
  WaterSpring: 'WaterSpring',
  WaterAutumn: 'WaterAutumn',
  WaterPreEmergent: 'WaterPreEmergent',
  WaterPostEmergent: 'WaterPostEmergent',
  SlopeWater: 'SlopeWater',
  SlopeVegetationStrip: 'SlopeVegetationStrip',
  Other: 'Other',
  SurfaceWaterProtectionZones: 'SurfaceWaterProtectionZones',
  SurfaceWaterProtectionZonesSpring: 'SurfaceWaterProtectionZonesSpring',
  SurfaceWaterProtectionZonesAutumn: 'SurfaceWaterProtectionZonesAutumn',
  GroundWaterProtectionZones: 'GroundWaterProtectionZones',
  GroundWaterProtectionZonesSpring: 'GroundWaterProtectionZonesSpring',
  GroundWaterProtectionZonesAutumn: 'GroundWaterProtectionZonesAutumn',
  PopulationProtectionZones: 'PopulationProtectionZones',
  Landscape: 'Landscape',
} as const;

export type Season = typeof Season[keyof typeof Season];


export const Season = {
  SPRING: 'SPRING',
  AUTUMN: 'AUTUMN',
} as const;

export type DoseMode = typeof DoseMode[keyof typeof DoseMode];


export const DoseMode = {
  PREVENTIVE: 'PREVENTIVE',
  CURATIVE: 'CURATIVE',
} as const;

export type Emergence = typeof Emergence[keyof typeof Emergence];


export const Emergence = {
  PRE: 'PRE',
  POST: 'POST',
} as const;

export interface DosageTo {
  ordinal: number;
  /** @nullable */
  minDose?: number | null;
  /** @nullable */
  maxDose?: number | null;
  /** @nullable */
  unit?: string | null;
  /** @nullable */
  minDoseWater?: number | null;
  /** @nullable */
  maxDoseWater?: number | null;
  /** @nullable */
  unitWater?: string | null;
  /** @nullable */
  minBbch?: number | null;
  /** @nullable */
  maxBbch?: number | null;
  season?: Season | null;
  mode?: DoseMode | null;
  emergence?: Emergence | null;
  /** @nullable */
  conditionText?: string | null;
  /** @nullable */
  allowedApplications?: number | null;
  /** @nullable */
  minInterval?: number | null;
  /** @nullable */
  maxInterval?: number | null;
  /** @nullable */
  protectionPeriod?: number | null;
  /** @nullable */
  protectionPeriodIsApplicationTerm?: boolean | null;
}

/**
 * SZU population category for PopulationProtectionZones buffers — which group of people the protection distance protects (VULNERABLE_GROUPS / RESIDENTS / PUBLIC). Null for non-population buffer types and for legacy rows synced before DEV-199.
 */
export type PopulationCategory = typeof PopulationCategory[keyof typeof PopulationCategory];


export const PopulationCategory = {
  VULNERABLE_GROUPS: 'VULNERABLE_GROUPS',
  RESIDENTS: 'RESIDENTS',
  PUBLIC: 'PUBLIC',
} as const;

export interface PlantProtectionRegistrationApplicationBufferTo {
  type: ApplicationBufferType;
  /** @nullable */
  driftReduction?: number | null;
  isAllowed: boolean;
  /** @nullable */
  buffer?: number | null;
  /** @nullable */
  protectionLevel?: number | null;
  populationCategory?: PopulationCategory | null;
}

export interface PlantProtectionApplicationCreateTo {
  /** @nullable */
  id?: string | null;
  /** @nullable */
  maxDose?: number | null;
  /** @nullable */
  minDose?: number | null;
  /** @nullable */
  unit?: string | null;
  /** @nullable */
  maxDoseWater?: number | null;
  /** @nullable */
  minDoseWater?: number | null;
  /** @nullable */
  unitWater?: string | null;
  /** @nullable */
  minBbch?: number | null;
  /** @nullable */
  maxBbch?: number | null;
  /** @nullable */
  allowedApplications?: number | null;
  /** @nullable */
  minInterval?: number | null;
  /** @nullable */
  maxInterval?: number | null;
  /** @nullable */
  protectionPeriod?: number | null;
  /** @nullable */
  protectionPeriodIsApplicationTerm?: boolean | null;
  /** @nullable */
  isAerialApplication?: boolean | null;
  /** @nullable */
  isSeedTreatment?: boolean | null;
  /** @nullable */
  cropId?: string | null;
  /** @nullable */
  cropGroupId?: string | null;
  /** @nullable */
  organismId?: string | null;
  buffers: PlantProtectionRegistrationApplicationBufferTo[];
  /** @nullable */
  notes?: string | null;
  /** @nullable */
  dosages?: DosageTo[] | null;
}

export interface EagriFertilizerKindTo {
  id: number;
  /** @nullable */
  name?: string | null;
}

export type EagriFertilizerNitrogenCategory = typeof EagriFertilizerNitrogenCategory[keyof typeof EagriFertilizerNitrogenCategory];


export const EagriFertilizerNitrogenCategory = {
  NON_NITROUS: 'NON_NITROUS',
  MINERAL: 'MINERAL',
  QUICK_RELEASE: 'QUICK_RELEASE',
  SLOW_RELEASE: 'SLOW_RELEASE',
  SLUDGE: 'SLUDGE',
  PLANT_RESIDUES: 'PLANT_RESIDUES',
  SEDIMENTS: 'SEDIMENTS',
  EXCIPIENTS: 'EXCIPIENTS',
} as const;

export interface EagriFertilizerNitrogenCategoryTo {
  code: EagriFertilizerNitrogenCategory;
  /** @nullable */
  name?: string | null;
}

export interface EagriFertilizerRegistrationTypeTo {
  code: string;
  /** @nullable */
  name?: string | null;
}

export interface EagriFertilizerPropertiesCreateTo {
  /** @nullable */
  eagriId?: number | null;
  registrationNumber: string;
  evidenceNumber: string;
  /** @nullable */
  applicantTradeName?: string | null;
  isExcrement: boolean;
  nitrogenCategory: EagriFertilizerNitrogenCategoryTo;
  nitrogenCoefficient: number;
  /** @nullable */
  sort?: string | null;
  registrationType: EagriFertilizerRegistrationTypeTo;
  /** @nullable */
  price?: number | null;
  fertilizerKind: EagriFertilizerKindTo;
  isEco: boolean;
  /** @nullable */
  validFrom?: string | null;
  /** @nullable */
  validTo?: string | null;
  /** @nullable */
  ordinance?: string | null;
}

export type UnitType = typeof UnitType[keyof typeof UnitType];


export const UnitType = {
  WEIGHT: 'WEIGHT',
  VOLUME: 'VOLUME',
} as const;

export interface FertilizerCreateTo {
  name: string;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  producerTradeName?: string | null;
  isHidden: boolean;
  isOrganic: boolean;
  n: number;
  p2o5: number;
  k2o: number;
  mgo: number;
  cao: number;
  na2o: number;
  s: number;
  chlorides: number;
  combustibleContent: number;
  zn: number;
  cu: number;
  fe: number;
  b: number;
  mn: number;
  mo: number;
  se: number;
  phFrom: number;
  phTo: number;
  electricConductivity: number;
  unitType: UnitType;
  /** Volume to mass conversion coefficient, used only when unit is in volume units (m3, l) */
  unitConversionCoefficient: number;
  eagriProperties?: EagriFertilizerPropertiesCreateTo | null;
}

export interface EagriFertilizerPropertiesDetailTo {
  /** @nullable */
  eagriId?: number | null;
  /** @nullable */
  registrationNumber?: string | null;
  /** @nullable */
  evidenceNumber?: string | null;
  /** @nullable */
  applicantTradeName?: string | null;
  isExcrement: boolean;
  nitrogenCategory: EagriFertilizerNitrogenCategoryTo;
  nitrogenCoefficient: number;
  /** @nullable */
  sort?: string | null;
  isValid: boolean;
  registrationType?: EagriFertilizerRegistrationTypeTo | null;
  /** @nullable */
  price?: number | null;
  /** @nullable */
  fertilizerType?: string | null;
  fertilizerKind?: EagriFertilizerKindTo | null;
  isEco: boolean;
  /** @nullable */
  validFrom?: string | null;
  /** @nullable */
  validTo?: string | null;
  /** @nullable */
  ordinance?: string | null;
}

export interface FertilizerDetailTo {
  id: string;
  name: string;
  catalogue: CatalogueTo;
  isHidden: boolean;
  isFavorite: boolean;
  /** @nullable */
  producerTradeName?: string | null;
  /** @nullable */
  description?: string | null;
  isOrganic: boolean;
  n: number;
  p2o5: number;
  k2o: number;
  mgo: number;
  cao: number;
  na2o: number;
  s: number;
  chlorides: number;
  combustibleContent: number;
  zn: number;
  cu: number;
  fe: number;
  b: number;
  mn: number;
  mo: number;
  se: number;
  phFrom: number;
  phTo: number;
  electricConductivity: number;
  unitType: UnitType;
  unitConversionCoefficient: number;
  eagriProperties?: EagriFertilizerPropertiesDetailTo | null;
}

export type NutrientType = typeof NutrientType[keyof typeof NutrientType];


export const NutrientType = {
  NITROGEN: 'NITROGEN',
  PHOSPHORUS: 'PHOSPHORUS',
  POTASSIUM: 'POTASSIUM',
} as const;

export interface NutrientConsumptionTo {
  type: NutrientType;
  value: number;
}

export interface CropProductUseTypeUpdateTo {
  productId: string;
  /** @nullable */
  isMainProduct?: boolean | null;
  /** @nullable */
  cropUseTypeId?: string | null;
  /** @nullable */
  dryMatter?: number | null;
  /** @nullable */
  nutrientConsumption?: NutrientConsumptionTo[] | null;
  /** @nullable */
  secondaryProductRatio?: number | null;
}

export interface CropProductUpdateTo {
  /** @nullable */
  externalId?: string | null;
  name: string;
  isMain: boolean;
  /** @nullable */
  validFrom?: string | null;
  /** @nullable */
  validTo?: string | null;
  /** @nullable */
  secondaryProductId?: string | null;
}

export interface CropUseTypeUpdateTo {
  /** @nullable */
  externalId?: string | null;
  name: string;
  /** @nullable */
  validFrom?: string | null;
  /** @nullable */
  validTo?: string | null;
}

export interface CropGroupResponseTo {
  id: string;
  /** @nullable */
  name?: string | null;
}

export interface CropGroupUpdateTo {
  name: string;
}

export interface SkeagisParcelUpdateResult {
  retiredParcels: string[];
  newParcels: string[];
  changedParcels: string[];
}

export interface SkeagisFarmUpdateResult {
  farmId: string;
  parcelUpdateResult: SkeagisParcelUpdateResult;
}

/**
 * @nullable
 */
export type AdminFarmUpdateToSettings = {[key: string]: boolean} | null;

export interface AdminFarmUpdateTo {
  /** @nullable */
  name?: string | null;
  isVisibleInPublicLayers: boolean;
  /** @nullable */
  companyNumber?: string | null;
  /** @nullable */
  businessCentralId?: string | null;
  /** @nullable */
  settings?: AdminFarmUpdateToSettings;
}

export interface AdminFarmSettingsTo {
  eagriSettingsEnabled: boolean;
  shpSettingsEnabled: boolean;
}

export type InternalFarmImportSource = typeof InternalFarmImportSource[keyof typeof InternalFarmImportSource];


export const InternalFarmImportSource = {
  EMPTY_FARM: 'EMPTY_FARM',
  EAGRI: 'EAGRI',
  SHP: 'SHP',
  UNKNOWN: 'UNKNOWN',
} as const;

export type FarmIntegrationSource = typeof FarmIntegrationSource[keyof typeof FarmIntegrationSource];


export const FarmIntegrationSource = {
  EAGRI: 'EAGRI',
  SKEAGIS: 'SKEAGIS',
} as const;

export interface AdminFarmTo {
  id: string;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  countryCode?: string | null;
  source: InternalFarmImportSource;
  integrationSource?: FarmIntegrationSource | null;
  isVisibleInPublicLayers: boolean;
  settings: AdminFarmSettingsTo;
  /** @nullable */
  companyNumber?: string | null;
  /** @nullable */
  businessCentralId?: string | null;
  /** @nullable */
  createdOn?: string | null;
  isDeleted: boolean;
}

export type IntegrationState = typeof IntegrationState[keyof typeof IntegrationState];


export const IntegrationState = {
  DISABLED: 'DISABLED',
  ACTIVE: 'ACTIVE',
} as const;

export interface FarmSkeagisUpdateRequest {
  /** @nullable */
  skeagisUserId?: string | null;
  state: IntegrationState;
  validFrom: string;
}

export type FarmManagementIntegrationSource = typeof FarmManagementIntegrationSource[keyof typeof FarmManagementIntegrationSource];


export const FarmManagementIntegrationSource = {
  SKEAGIS: 'SKEAGIS',
} as const;

export interface FarmIntegrationResponse {
  state: string;
  validFrom: string;
  source: FarmManagementIntegrationSource;
}

export type MockSubmissionOutcome = typeof MockSubmissionOutcome[keyof typeof MockSubmissionOutcome];


export const MockSubmissionOutcome = {
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  TRANSPORT_ERROR: 'TRANSPORT_ERROR',
} as const;

export type EagriReportStatusType = typeof EagriReportStatusType[keyof typeof EagriReportStatusType];


export const EagriReportStatusType = {
  OK: 'OK',
  WARNING: 'WARNING',
  ERROR: 'ERROR',
} as const;

/**
 * Behaviour of the mocked eAgri report endpoints. Development environments only.
 */
export interface EagriReportMockScenarioTo {
  submission: MockSubmissionOutcome;
  /** How many evaluation fetches answer 'nothing yet' before the outcome is returned. Exercises the retry backoff; a value above the number of configured attempts ends in GAVE_UP. */
  pollFailuresBeforeAnswer: number;
  /** Seconds the mock keeps saying 'nothing yet' after the submission, regardless of how many times it is asked. Lets a waiting UI be tested without touching the environment's backoff configuration. Both gates apply: the outcome comes at the first fetch past this delay that is also past pollFailuresBeforeAnswer. */
  evaluationDelaySeconds: number;
  evaluationStatus: EagriReportStatusType;
  errorsCount: number;
  warningsCount: number;
  /** Whether the evaluation carries the error report (chybnik) PDF. */
  includeErrorReport: boolean;
  /** Whether the evaluation carries the confirmation PDF - eAgri sometimes omits it. */
  includeConfirmation: boolean;
}

export interface EagriReportMockSubmissionTo {
  guid: string;
  evaluationFetches: number;
  secondsSinceSubmission: string;
}

export interface EagriReportMockStateTo {
  scenario: EagriReportMockScenarioTo;
  submissions: EagriReportMockSubmissionTo[];
}

export type CropGrowthStage = typeof CropGrowthStage[keyof typeof CropGrowthStage];


export const CropGrowthStage = {
  PREEMERGENT: 'PREEMERGENT',
  POSTEMERGENT: 'POSTEMERGENT',
  SPRING: 'SPRING',
  AUTUMN: 'AUTUMN',
} as const;

export interface ActionExpenseTo {
  /** @nullable */
  id?: string | null;
  amount: number;
  unit: string;
  dosePerUnit: number;
  /** @nullable */
  notes?: string | null;
  cropGrowthStage?: CropGrowthStage | null;
}

export type RestrictionType = typeof RestrictionType[keyof typeof RestrictionType];


export const RestrictionType = {
  Absolute: 'Absolute',
  Boundary: 'Boundary',
  BoundarySpring: 'BoundarySpring',
  BoundaryAutumn: 'BoundaryAutumn',
  BoundaryPreEmergent: 'BoundaryPreEmergent',
  BoundaryPostEmergent: 'BoundaryPostEmergent',
  Water: 'Water',
  WaterSpring: 'WaterSpring',
  WaterAutumn: 'WaterAutumn',
  WaterPreEmergent: 'WaterPreEmergent',
  WaterPostEmergent: 'WaterPostEmergent',
  SlopeVegetationStrip: 'SlopeVegetationStrip',
  GroundWaterProtectionZones: 'GroundWaterProtectionZones',
  SurfaceWaterProtectionZones: 'SurfaceWaterProtectionZones',
  PopulationProtectionZones: 'PopulationProtectionZones',
  Landscape: 'Landscape',
  SlopeWater: 'SlopeWater',
} as const;

export interface RestrictionTo {
  type: RestrictionType;
  /** @nullable */
  value?: number | null;
  /**
     * Protection level for ground water or surface water
     * @nullable
     */
  protectionLevel?: number | null;
  /** @nullable */
  isIgnored?: boolean | null;
}

export interface ActionParcelCreateTo {
  parcelId: string;
  /** @nullable */
  restrictions?: RestrictionTo[] | null;
}

export type ActionSource = typeof ActionSource[keyof typeof ActionSource];


export const ActionSource = {
  TELEMATICS: 'TELEMATICS',
  MANUAL: 'MANUAL',
  EAGRI: 'EAGRI',
  SKEAGIS: 'SKEAGIS',
  UNKNOWN: 'UNKNOWN',
} as const;

export interface SeedMat {
  /** @nullable */
  id?: string | null;
  materialId: string;
}

export interface Seed {
  actionMaterial: SeedMat;
  actionExpense?: ActionExpenseTo | null;
}

export interface ActionSowingCreateV2To {
  /** @nullable */
  id?: string | null;
  /** @nullable */
  note?: string | null;
  date: string;
  parcels: ActionParcelCreateTo[];
  seedExpense: Seed;
  seedApplicationType: SeedApplicationType;
  isDraft: boolean;
  source: ActionSource;
  /**
     * Time of the action in ISO-8601 format
     * @nullable
     */
  time?: string | null;
  /** @nullable */
  cropUseId?: string | null;
  /** @nullable */
  cropProductId?: string | null;
}

export interface ActionIdTo {
  actionId: string;
}

export type ActionType = typeof ActionType[keyof typeof ActionType];


export const ActionType = {
  PLOW: 'PLOW',
  TILLAGE: 'TILLAGE',
  SOWING: 'SOWING',
  SOWING_PERENNIAL: 'SOWING_PERENNIAL',
  MOWING: 'MOWING',
  HARVEST: 'HARVEST',
  SPRAY: 'SPRAY',
  SPREADING_PEST: 'SPREADING_PEST',
  NON_FIELD_PLANT_PROTECTION: 'NON_FIELD_PLANT_PROTECTION',
  FERT: 'FERT',
  LIMING: 'LIMING',
  FERT_ORG: 'FERT_ORG',
  FERT_IND: 'FERT_IND',
  TANKMIX: 'TANKMIX',
  HOE: 'HOE',
  TRANSPORT: 'TRANSPORT',
  PREP: 'PREP',
  PASTURE: 'PASTURE',
  DISK: 'DISK',
  HARROW: 'HARROW',
  ROLL: 'ROLL',
  IRRIG: 'IRRIG',
  HILL: 'HILL',
  CULTIV: 'CULTIV',
  FOLIAR: 'FOLIAR',
  MULCHING: 'MULCHING',
  SUBSOILING: 'SUBSOILING',
  RAKING: 'RAKING',
  REVERSAL: 'REVERSAL',
  CRUSHING: 'CRUSHING',
  SKIDDING: 'SKIDDING',
  SUB_PLOWING: 'SUB_PLOWING',
  PLOUGHING: 'PLOUGHING',
  COMPACTING: 'COMPACTING',
} as const;

export interface ActionOtherCreateTo {
  /** @nullable */
  id?: string | null;
  /** @nullable */
  note?: string | null;
  date: string;
  parcels: ActionParcelCreateTo[];
  actionType: ActionType;
  isDraft: boolean;
  source: ActionSource;
  /**
     * Time of the action in ISO-8601 format
     * @nullable
     */
  time?: string | null;
  /** When true, ends the ongoing seed application and shifts the start of the following seed application forward. */
  endSeedApplications: boolean;
}

export type PlantProtectionEffectiveness = typeof PlantProtectionEffectiveness[keyof typeof PlantProtectionEffectiveness];


export const PlantProtectionEffectiveness = {
  YES: 'YES',
  NO: 'NO',
  NOT_SPECIFIED: 'NOT_SPECIFIED',
} as const;

export interface NonFieldPlantProtectionCreateTo {
  /**
     * Id of the stored product of the action when updating it, null for a new one
     * @nullable
     */
  id?: string | null;
  materialId: string;
  /** Total amount applied, i.e. dosePerUnit x applicationExtent */
  amount: number;
  unit: string;
  /** Dose per unit of the facility (e.g. litres per tonne) */
  dosePerUnit: number;
  effectiveness: PlantProtectionEffectiveness;
  /** @nullable */
  notes?: string | null;
  targetOrganismsIds: string[];
}

/**
 * Non-field plant protection action - applied in a farm facility, not on parcels
 */
export interface ActionNonFieldCreateTo {
  /** @nullable */
  id?: string | null;
  /** @nullable */
  note?: string | null;
  date: string;
  /** Facility the products were applied in */
  facilityId: string;
  /** Extent of the application in the unit of the facility, more than zero, at most 2 decimal places */
  applicationExtent: number;
  /** Target crop. For a treatment of an empty space (e.g. a storage before harvest) the 'no crop' crop. */
  targetCropId: string;
  plantProtections: NonFieldPlantProtectionCreateTo[];
  isDraft: boolean;
  source: ActionSource;
  /**
     * Time of the action in ISO-8601 format
     * @nullable
     */
  time?: string | null;
}

export type YieldUnit = typeof YieldUnit[keyof typeof YieldUnit];


export const YieldUnit = {
  T: 'T',
} as const;

/**
 * Yield harvested on one parcel of the action (DEV-2766).
 */
export interface ParcelRevenueCreateTo {
  /** Parcel of the action the yield was harvested on. */
  parcelId: string;
  /** Absolute amount harvested on the parcel, in unit. */
  amount: number;
  isMainProduct: boolean;
  /**
     * Harvested product. Not required by the backend, the form asks for it.
     * @nullable
     */
  cropProductId?: string | null;
  unit: YieldUnit;
  /** Also set cropProductId as the main harvest product of the seed application active on the parcel at the action date. Same as changing the product in the sowing plan: a seed application in a group gets it on the whole group. Main yield only, needs a cropProductId. Not stored on the action, a draft applies it only once confirmed. */
  applyToSeedApplication: boolean;
}

/**
 * Yield of the whole action of the form before DEV-2770, spread over the parcels by area. Not sent together with parcelRevenues.
 * @deprecated
 */
export interface RevenueCreateTo {
  amount: number;
  isMainProduct: boolean;
  /**
     * Harvested product. Not required by the backend, the form asks for it.
     * @nullable
     */
  cropProductId?: string | null;
  unit: YieldUnit;
  /** Also set cropProductId as the main harvest product of the seed application active on the parcel at the action date. Same as changing the product in the sowing plan: a seed application in a group gets it on the whole group. Main yield only, needs a cropProductId. Not stored on the action, a draft applies it only once confirmed. */
  applyToSeedApplication: boolean;
}

export interface ActionMowingCreateV2To {
  /** @nullable */
  id?: string | null;
  /** @nullable */
  note?: string | null;
  date: string;
  parcels: ActionParcelCreateTo[];
  /** Yield per parcel of the action (DEV-2766), main product only; replaces all yields of the action. Every parcel needs its main yield (0 when nothing was harvested); only a draft may leave it out. Not sent together with revenue. */
  parcelRevenues: ParcelRevenueCreateTo[];
  isDraft: boolean;
  source: ActionSource;
  /**
     * Time of the action in ISO-8601 format
     * @nullable
     */
  time?: string | null;
  revenue?: RevenueCreateTo | null;
}

export interface ActionHarvestCreateV2To {
  /** @nullable */
  id?: string | null;
  /** @nullable */
  note?: string | null;
  date: string;
  parcels: ActionParcelCreateTo[];
  /** Yield per parcel of the action (DEV-2766), replaces all yields of the action. Every parcel needs its main yield (0 when nothing was harvested); only a draft may leave it out. Not sent together with revenues. */
  parcelRevenues: ParcelRevenueCreateTo[];
  isDraft: boolean;
  source: ActionSource;
  /**
     * Time of the action in ISO-8601 format
     * @nullable
     */
  time?: string | null;
  /** When true, ends the ongoing seed application and shifts the start of the following seed application forward. */
  endSeedApplications: boolean;
  /**
     * Yield of the whole action of the form before DEV-2770, spread over the parcels by area. Not sent together with parcelRevenues.
     * @deprecated
     * @nullable
     */
  revenues?: RevenueCreateTo[] | null;
}

export type DriftClass = typeof DriftClass[keyof typeof DriftClass];


export const DriftClass = {
  DRIFT_90: 'DRIFT_90',
  DRIFT_75: 'DRIFT_75',
  DRIFT_50: 'DRIFT_50',
  DRIFT_NONE: 'DRIFT_NONE',
} as const;

export interface EPHMat {
  /** @nullable */
  id?: string | null;
  materialId: string;
  /** @nullable */
  dateSoilIncorporation?: string | null;
  driftClass?: DriftClass | null;
}

export interface Eph {
  actionMaterial: EPHMat;
  actionExpense: ActionExpenseTo;
}

export interface ParcelPlantProtectionEffectivenessTo {
  parcelId: string;
  effectiveness: PlantProtectionEffectiveness;
}

export interface ExpensePlantProtectionCreateTo {
  actionMaterial: EPHMat;
  actionExpense: ActionExpenseTo;
  /** @nullable */
  targetOrganismsIds?: string[] | null;
  parcelPlantProtectionEffectiveness: ParcelPlantProtectionEffectivenessTo[];
}

export interface ActionEPHCreateV2To {
  /** @nullable */
  id?: string | null;
  /** @nullable */
  note?: string | null;
  date: string;
  parcels: ActionParcelCreateTo[];
  /**
     * Deprecated. Target crop is determined automatically from seed application. Will be removed in a future version.
     * @deprecated
     * @nullable
     */
  targetCropId?: string | null;
  isStrawDecay: boolean;
  fertilizers: Eph[];
  plantProtections: ExpensePlantProtectionCreateTo[];
  isDraft: boolean;
  source: ActionSource;
  /**
     * Time of the action in ISO-8601 format
     * @nullable
     */
  time?: string | null;
}

export interface InternalSeedApplicationCreateTo {
  /** Parcel version the seed application hangs on, retired versions included */
  parcelId: string;
  /**
     * Crop id; its base seed is used, null means the no-crop lifecycle
     * @nullable
     */
  cropId?: string | null;
  /** Clipped to the parcel version validity when it starts earlier */
  dateStart: string;
  /**
     * Null keeps the seed application open; on a retired version it closes with the version
     * @nullable
     */
  dateEnd?: string | null;
  /** @nullable */
  expectedYieldTonnesHa?: number | null;
  /**
     * Creates sharing a key form one group; a key equal to an existing group UUID joins that group
     * @nullable
     */
  groupKey?: string | null;
}

export interface InternalSeedApplicationYieldFillTo {
  seedApplicationId: string;
  /** @nullable */
  expectedYieldTonnesHa?: number | null;
}

export interface InternalSeedApplicationBatchTo {
  create: InternalSeedApplicationCreateTo[];
  fillYields: InternalSeedApplicationYieldFillTo[];
  /** When true nothing is written as soon as a single item is rejected; the rejections are still reported */
  atomic: boolean;
}

export interface InternalSeedApplicationBatchFailureTo {
  /**
     * Parcel of the rejected create, null for a rejected yield fill
     * @nullable
     */
  parcelId?: string | null;
  /**
     * Requested window of the rejected create, null for a rejected yield fill
     * @nullable
     */
  dateStart?: string | null;
  /** @nullable */
  dateEnd?: string | null;
  /**
     * Seed application of the rejected yield fill, null for a rejected create
     * @nullable
     */
  seedApplicationId?: string | null;
  message: string;
}

export interface InternalSeedApplicationBatchResultTo {
  created: string[];
  updated: string[];
  failed: InternalSeedApplicationBatchFailureTo[];
  /** Existing seed applications a create ran into; nothing was left to fill on them */
  alreadyPresent: string[];
}

/**
 * Which parcels and which seasons the sowing plan search should cover (DEV-2655), and the filters of the sowing plan screen to narrow them by (DEV-3046). Every filter is optional and they combine with AND; each one works exactly like its counterpart on `GET /api/sowing-plan/v2/parcels`.
 */
export interface InternalSowingPlanV3SearchRequest {
  /** Parcel ids the caller knows. Any version of a parcel may be given - the answer comes back on the row that stands for the whole parcel, whichever version that row is named after. */
  parcelIds: string[];
  /** First season, by start year: 2025 means 2025-07-01 - 2026-06-30. Inclusive. */
  seasonStartYearFrom: number;
  /** Last season, by start year. Inclusive. */
  seasonStartYearTo: number;
  /** Keeps only parcels with one of these crops (OR) in one of the filtered seasons. Empty means no crop filter. Same as `shown-crop`. */
  cropIds: string[];
  /** Keeps only parcels with a real crop of one of these kinds - main or catch crop (OR) - in one of the filtered seasons. Empty means no crop type filter. Same as `shown-crop-type`. */
  cropTypes: SeedApplicationType[];
  /** Keeps only parcels with no real crop in any of the filtered seasons. Same as `shown-no-crop`. */
  noCrop: boolean;
  /** The seasons, by start year, that `cropIds`, `cropTypes` and `noCrop` look at. Empty means every requested season. On its own it filters nothing. Same as `shown-season`. */
  seasonStartYears: number[];
  /** Keeps only parcels in one of these zones (OR, together with `withoutZone`). Same as `zones`. */
  zoneIds: string[];
  /** Keeps parcels in no zone at all (OR, together with `zoneIds`). Same as the `NONE` option of `zones`. */
  withoutZone: boolean;
  /**
     * Full-text search in the parcel name, the block number and the parcel id. Same as `search`.
     * @nullable
     */
  search?: string | null;
}

export interface CenterTo {
  id: string;
  key: string;
  name: string;
}

/**
 * One version of a parcel, as it stood between its own validity dates
 */
export interface ParcelVersionTo {
  id: string;
  localName: string;
  /** @nullable */
  validFrom?: string | null;
  /** @nullable */
  validTo?: string | null;
  area: number;
  blockNumber: string;
  lpisBlockArea: number;
  landUseName: string;
}

export interface ZoneTo {
  id: string;
  name: string;
}

/**
 * Agricultural season (July 1st - June 30th) with all seed applications overlapping its date range
 */
export interface SowingPlanSeasonV2To {
  startYear: number;
  endYear: number;
  dateStart: string;
  dateEnd: string;
  /** Seed applications overlapping the season date range; one application can appear in multiple seasons. Grouped seed applications (megaosevy) are collapsed into a single group with aggregated start/end dates */
  seedApplications: (SeedApplicationV2GroupToV2 | SeedApplicationV2To)[];
}

/**
 * Parcel list item with V2 seed applications mapped to agricultural seasons
 */
export interface ParcelWithSowingPlansV2To {
  id: string;
  blockNumber: string;
  localName: string;
  area: number;
  lpisBlockArea: number;
  landUseName: string;
  center?: CenterTo | null;
  /** @nullable */
  zones?: ZoneTo[] | null;
  /**
     * Date the parcel became valid; sowing plan dates outside [validFrom, validTo] are rejected (DEV-1144)
     * @nullable
     */
  validFrom?: string | null;
  /**
     * Date the parcel stops being valid; null for a still-open parcel (DEV-1144)
     * @nullable
     */
  validTo?: string | null;
  seedApplication?: SeedApplicationV2GroupToV2 | SeedApplicationV2To | null;
  /** True when more than one seed application is active on the parcel today - a data anomaly (two crops at once). The row shows the most recently started one; use this to flag the parcel. The season timeline still lists all overlapping crops (DEV-1398). */
  hasOverlappingSeedApplications: boolean;
  seasons: SowingPlanSeasonV2To[];
  /** Versions of the same parcel this row was merged from, oldest first - the row itself is named after the newest of them, so this is the only place the others are visible. Empty when the row stands for a single parcel (DEV-1786). */
  mergedVersions: ParcelVersionTo[];
}

export interface InternalSowingPlanSearchRequest {
  parcelIds: string[];
  seasonStartYearFrom: number;
  seasonStartYearTo: number;
  cropIds: string[];
}

export interface GetInternalPlantProtectionMaterialBody {
  /** @nullable */
  ids?: string[] | null;
  /** @nullable */
  name?: string | null;
}

export type MaterialType = typeof MaterialType[keyof typeof MaterialType];


export const MaterialType = {
  FERTILIZER: 'FERTILIZER',
  PLANT_PROTECTION: 'PLANT_PROTECTION',
  SEED: 'SEED',
} as const;

export interface InternalMaterialTo {
  name?: string;
  id: string;
  type: MaterialType;
  validFrom?: string;
  externalId?: number;
  validTo?: string;
  isFavourite: boolean;
}

export type InternalFertilizerTo = InternalMaterialTo & ({
  /** @nullable */
  name?: string | null;
  /** @nullable */
  externalId?: number | null;
  /** @nullable */
  validFrom?: string | null;
  /** @nullable */
  validTo?: string | null;
  volumeToWeightCoefficient: number;
  n: number;
  p2o5: number;
  k2o: number;
  mgo: number;
  cao: number;
  s: number;
});

export type InternalMaterialToBase = InternalMaterialTo & ({
  /** @nullable */
  name?: string | null;
  /** @nullable */
  externalId?: number | null;
  /** @nullable */
  validFrom?: string | null;
  /** @nullable */
  validTo?: string | null;
});

export type GeoJsonType = typeof GeoJsonType[keyof typeof GeoJsonType];


export const GeoJsonType = {
  Point: 'Point',
  PointZ: 'PointZ',
  MultiPoint: 'MultiPoint',
  LinearRing: 'LinearRing',
  LineString: 'LineString',
  MultiLineString: 'MultiLineString',
  Polygon: 'Polygon',
  MultiPolygon: 'MultiPolygon',
  GeometryCollection: 'GeometryCollection',
} as const;

export interface GeoJsonMultiPolygon {
  coordinates: number[][][][];
  type: GeoJsonType;
  isEmpty: boolean;
}

export interface InternalCropProductTo {
  id: string;
  externalId: number;
  description: string;
}

export type InternalLandUse = typeof InternalLandUse[keyof typeof InternalLandUse];


export const InternalLandUse = {
  ARABLE: 'ARABLE',
  HOPFIELD: 'HOPFIELD',
  VINEYARD: 'VINEYARD',
  OTHER_PERMANENT: 'OTHER_PERMANENT',
  ORCHARD: 'ORCHARD',
  GRASS: 'GRASS',
  OTHER: 'OTHER',
  SET_ASIDE: 'SET_ASIDE',
  FODDER: 'FODDER',
  UNPRODUCTIVE: 'UNPRODUCTIVE',
  MULTIPLE_CROPS: 'MULTIPLE_CROPS',
  TRUFFLES: 'TRUFFLES',
  CONTAINERS: 'CONTAINERS',
  NURSERY: 'NURSERY',
  VEGETABLES: 'VEGETABLES',
  POND: 'POND',
  FAST_GROW: 'FAST_GROW',
  WOODED: 'WOODED',
  UNKNOWN: 'UNKNOWN',
} as const;

export type InternalParcelStatus = typeof InternalParcelStatus[keyof typeof InternalParcelStatus];


export const InternalParcelStatus = {
  OPEN: 'OPEN',
  RETIRED: 'RETIRED',
} as const;

export type InternalSeedApplicationType = typeof InternalSeedApplicationType[keyof typeof InternalSeedApplicationType];


export const InternalSeedApplicationType = {
  CATCH_CROP: 'CATCH_CROP',
  MAIN_CROP: 'MAIN_CROP',
} as const;

export interface InternalParcelTo {
  id: string;
  name: string;
  blockNumber: string;
  /** @nullable */
  square?: string | null;
  geometry?: GeoJsonMultiPolygon | null;
  /** @nullable */
  area?: number | null;
  /** @nullable */
  countyUnitId?: number | null;
  /** @nullable */
  countyName?: string | null;
  /** @nullable */
  cropLegislativeCode?: number | null;
  /** @nullable */
  cropInternalId?: string | null;
  /** @nullable */
  cropName?: string | null;
  cropSeedAppType: InternalSeedApplicationType;
  harvestProduct?: InternalCropProductTo | null;
  /** @nullable */
  centerKey?: string | null;
  /** @nullable */
  validFrom?: string | null;
  /** @nullable */
  validTo?: string | null;
  landUse: InternalLandUse;
  status: InternalParcelStatus;
}

export interface InternalSuccessorCandidateTo {
  parcel: InternalParcelTo;
  intersectionAreaSqM: number;
  jaccardIndex: number;
}

export interface InternalParcelWithSuccessorsTo {
  parcel: InternalParcelTo;
  successors: InternalSuccessorCandidateTo[];
}

export type ParcelStatus = typeof ParcelStatus[keyof typeof ParcelStatus];


export const ParcelStatus = {
  OPEN: 'OPEN',
  RETIRED: 'RETIRED',
} as const;

export interface InternalParcelSearchRequest {
  ids: string[];
}

export interface GeoJsonMultiPoint {
  coordinates: number[][];
  type: GeoJsonType;
}

export interface InternalIntersectionParcelTo {
  parcelId: string;
  farmId: string;
  name: string;
  area: number;
  geometry: GeoJsonMultiPolygon;
}

export interface InternalParcelIntersectionRequest {
  parcelIds: string[];
  /** @nullable */
  minIntersectionAreaM2?: number | null;
  includeRetired: boolean;
}

export interface InternalSeedApplicationGroupTo {
  groupId: string;
  dateStart: string;
  /** @nullable */
  dateEnd?: string | null;
  parcelIds: string[];
}

export interface InternalSeedApplicationTo {
  dateStart: string;
  /** @nullable */
  dateEnd?: string | null;
  seedTo: CropSeedTo;
  seedApplicationType: InternalSeedApplicationType;
  harvestProduct?: InternalCropProductTo | null;
  group?: InternalSeedApplicationGroupTo | null;
}

export interface InternalIntersectingParcelTo {
  id: string;
  name: string;
  area: number;
  intersectionAreaSqM: number;
  jaccardIndex: number;
  geometry: GeoJsonMultiPolygon;
  seedApplication?: InternalSeedApplicationTo | null;
}

export interface InternalParcelIntersectionTo {
  inputParcelId: string;
  intersectingParcels: InternalIntersectingParcelTo[];
}

export interface InternalActionInfoRequestTo {
  actionId: string;
  materialId: string;
}

export interface InternalActionInfoRequestBodyTo {
  actionMaterials: InternalActionInfoRequestTo[];
}

export type LocalLanguage = typeof LocalLanguage[keyof typeof LocalLanguage];


export const LocalLanguage = {
  EN: 'EN',
  CZ: 'CZ',
  SRB: 'SRB',
  ES: 'ES',
  RU: 'RU',
  GR: 'GR',
  RO: 'RO',
  HU: 'HU',
  PL: 'PL',
  LT: 'LT',
  SK: 'SK',
} as const;

export interface InternalActionInfo {
  actionId: string;
  materialId: string;
  note: string;
  unitId: string;
  dosePerUnit: number;
  doseBaseUnitId: string;
}

export interface InternalActionParcelCreate {
  parcelId: string;
  /** @nullable */
  subtractionAreaHa?: number | null;
}

export type InternalActionType = typeof InternalActionType[keyof typeof InternalActionType];


export const InternalActionType = {
  PLOW: 'PLOW',
  TILLAGE: 'TILLAGE',
  SOWING: 'SOWING',
  SOWING_PERENNIAL: 'SOWING_PERENNIAL',
  MOWING: 'MOWING',
  HARVEST: 'HARVEST',
  SPRAY: 'SPRAY',
  SPREADING_PEST: 'SPREADING_PEST',
  FERT: 'FERT',
  LIMING: 'LIMING',
  FERT_ORG: 'FERT_ORG',
  FERT_IND: 'FERT_IND',
  TANKMIX: 'TANKMIX',
  HOE: 'HOE',
  TRANSPORT: 'TRANSPORT',
  PREP: 'PREP',
  PASTURE: 'PASTURE',
  DISK: 'DISK',
  HARROW: 'HARROW',
  ROLL: 'ROLL',
  IRRIG: 'IRRIG',
  HILL: 'HILL',
  CULTIV: 'CULTIV',
  FOLIAR: 'FOLIAR',
  MULCHING: 'MULCHING',
  SUBSOILING: 'SUBSOILING',
  RAKING: 'RAKING',
  REVERSAL: 'REVERSAL',
  CRUSHING: 'CRUSHING',
  SKIDDING: 'SKIDDING',
  SUB_PLOWING: 'SUB_PLOWING',
  PLOUGHING: 'PLOUGHING',
  COMPACTING: 'COMPACTING',
} as const;

export interface InternalTelematicsActionCreate {
  date: string;
  /** @nullable */
  time?: string | null;
  parcels: InternalActionParcelCreate[];
  actionType: InternalActionType;
  /** @nullable */
  targetCropExternalId?: string | null;
}

export interface InternalActionIdResponse {
  id: string;
}

export interface InternalBulkDeleteActionsRequestTo {
  actionIds: string[];
}

export interface InternalActionDeleteFailureTo {
  actionId: string;
  farmId: string;
  error: string;
}

export interface InternalBulkDeleteResult {
  requested: number;
  deleted: number;
  notFound: number;
  failed: InternalActionDeleteFailureTo[];
}

export interface SeedApplicationV2CreateTo {
  parcelId: string;
  /** @nullable */
  seedId?: string | null;
  dateStart: string;
  /** @nullable */
  dateEnd?: string | null;
  /** @maximum 100000 */
  areaHa: number;
  /** @nullable */
  cropUseTypeId?: string | null;
  isCatchCrop: boolean;
  /** @nullable */
  mainHarvestableProduct?: string | null;
  /** @nullable */
  groupId?: string | null;
  /** @nullable */
  expectedYieldTonnesHa?: number | null;
}

export interface SeedApplicationV2GroupMemberCreateTo {
  id: string;
  /** @nullable */
  dateStart?: string | null;
  /** @nullable */
  dateEnd?: string | null;
  /** @nullable */
  areaHa?: number | null;
  /** @nullable */
  groupId?: string | null;
  /** @nullable */
  expectedYieldTonnesHa?: number | null;
}

export interface SeedApplicationV2GroupCreateTo {
  /** @nullable */
  seedId?: string | null;
  /** @nullable */
  cropUseTypeId?: string | null;
  /** @nullable */
  isCatchCrop?: boolean | null;
  /** @nullable */
  mainHarvestableProduct?: string | null;
  seedApplications: SeedApplicationV2GroupMemberCreateTo[];
}

export type SeedApplicationConflictResolution = typeof SeedApplicationConflictResolution[keyof typeof SeedApplicationConflictResolution];


export const SeedApplicationConflictResolution = {
  NONE: 'NONE',
  EDIT_NEW: 'EDIT_NEW',
  SHIFT_NEIGHBOR: 'SHIFT_NEIGHBOR',
} as const;

export interface BulkParcelResolutionTo {
  parcelId: string;
  previousConflictResolution: SeedApplicationConflictResolution;
  followingConflictResolution: SeedApplicationConflictResolution;
}

export interface SeedApplicationV2BulkCreateTo {
  parcelIds: string[];
  /** @nullable */
  seedId?: string | null;
  dateStart: string;
  /** @nullable */
  dateEnd?: string | null;
  isCatchCrop: boolean;
  /** @nullable */
  cropUseTypeId?: string | null;
  /** @nullable */
  mainHarvestableProduct?: string | null;
  parcelResolutions: BulkParcelResolutionTo[];
  /** @nullable */
  expectedYieldTonnesHa?: number | null;
}

export type BulkNeighborChange = typeof BulkNeighborChange[keyof typeof BulkNeighborChange];


export const BulkNeighborChange = {
  CLOSED: 'CLOSED',
  SHIFTED: 'SHIFTED',
} as const;

export interface AffectedNeighborTo {
  seedApplication: SeedApplicationV2To;
  change: BulkNeighborChange;
}

export type BulkParcelConflictStatus = typeof BulkParcelConflictStatus[keyof typeof BulkParcelConflictStatus];


export const BulkParcelConflictStatus = {
  CLEAN: 'CLEAN',
  AUTO_CLOSE_PREVIOUS: 'AUTO_CLOSE_PREVIOUS',
  AUTO_CAP_END: 'AUTO_CAP_END',
  PREVIOUS_CONFLICT: 'PREVIOUS_CONFLICT',
  FOLLOWING_CONFLICT: 'FOLLOWING_CONFLICT',
  BOTH: 'BOTH',
} as const;

export interface BulkResolutionOptionTo {
  strategy: SeedApplicationConflictResolution;
  feasible: boolean;
  newDateStart: string;
  /** @nullable */
  newDateEnd?: string | null;
  /** @nullable */
  neighborId?: string | null;
  /** @nullable */
  neighborNewDateStart?: string | null;
  /** @nullable */
  neighborNewDateEnd?: string | null;
}

export type BulkSkipReason = typeof BulkSkipReason[keyof typeof BulkSkipReason];


export const BulkSkipReason = {
  PARCEL_NOT_FOUND: 'PARCEL_NOT_FOUND',
  SEED_APPLICATION_NOT_FOUND: 'SEED_APPLICATION_NOT_FOUND',
  PREVIOUS_SEED_APPLICATION_OVERLAP: 'PREVIOUS_SEED_APPLICATION_OVERLAP',
  FOLLOWING_SEED_APPLICATION_OVERLAP: 'FOLLOWING_SEED_APPLICATION_OVERLAP',
  PREVIOUS_RESOLUTION_INFEASIBLE: 'PREVIOUS_RESOLUTION_INFEASIBLE',
  FOLLOWING_RESOLUTION_INFEASIBLE: 'FOLLOWING_RESOLUTION_INFEASIBLE',
  OUTSIDE_PARCEL_VALIDITY: 'OUTSIDE_PARCEL_VALIDITY',
  STILL_OVERLAPS: 'STILL_OVERLAPS',
  INVALID_DATE_RANGE: 'INVALID_DATE_RANGE',
  CROP_DEPENDENT_FIELD_INVALID_FOR_CROP: 'CROP_DEPENDENT_FIELD_INVALID_FOR_CROP',
  CROP_CHANGE_REQUIRES_DEPENDENTS: 'CROP_CHANGE_REQUIRES_DEPENDENTS',
  GROUP_START_DATE_NOT_EDITABLE: 'GROUP_START_DATE_NOT_EDITABLE',
} as const;

export interface SkippedParcelTo {
  /** @nullable */
  parcelId?: string | null;
  reason: BulkSkipReason;
  conflicting?: SeedApplicationV2To | null;
  status?: BulkParcelConflictStatus | null;
  previousResolutionOptions: BulkResolutionOptionTo[];
  followingResolutionOptions: BulkResolutionOptionTo[];
  /** @nullable */
  seedApplicationId?: string | null;
  /** @nullable */
  parcelValidFrom?: string | null;
  /** @nullable */
  parcelValidTo?: string | null;
  /** @nullable */
  groupId?: string | null;
}

export interface SeedApplicationV2BulkResultTo {
  created: SeedApplicationV2To[];
  skipped: SkippedParcelTo[];
  affectedNeighbors: AffectedNeighborTo[];
}

export interface BulkParcelConflictTo {
  parcelId: string;
  status: BulkParcelConflictStatus;
  previous?: SeedApplicationV2To | null;
  following?: SeedApplicationV2To | null;
  previousResolutionOptions: BulkResolutionOptionTo[];
  followingResolutionOptions: BulkResolutionOptionTo[];
  /** @nullable */
  seedApplicationId?: string | null;
}

export interface SeedApplicationV2BulkPreviewTo {
  parcels: BulkParcelConflictTo[];
  cleanCount: number;
  conflictCount: number;
}

export interface BulkSeedApplicationResolutionTo {
  seedApplicationId: string;
  previousConflictResolution: SeedApplicationConflictResolution;
  followingConflictResolution: SeedApplicationConflictResolution;
}

export interface SeedApplicationV2BulkEditTo {
  seedApplicationIds: string[];
  /** @nullable */
  dateStart?: string | null;
  /** @nullable */
  dateEnd?: string | null;
  /** @nullable */
  seedId?: string | null;
  /** @nullable */
  cropUseTypeId?: string | null;
  /** @nullable */
  isCatchCrop?: boolean | null;
  /** @nullable */
  mainHarvestableProduct?: string | null;
  expectedYieldTonnesHa?: JsonNullableDouble;
  seedApplicationResolutions: BulkSeedApplicationResolutionTo[];
}

export interface SeedApplicationV2BulkEditResultTo {
  updated: SeedApplicationV2To[];
  skipped: SkippedParcelTo[];
  affectedNeighbors: AffectedNeighborTo[];
}

export interface SeedApplicationV2BulkDeleteTo {
  seedApplicationIds: string[];
}

export interface SkippedSeedApplicationTo {
  seedApplicationId: string;
  reason: BulkSkipReason;
}

export interface SeedApplicationV2BulkDeleteResultTo {
  deletedIds: string[];
  skipped: SkippedSeedApplicationTo[];
}

export interface ActionTypeTo {
  code: ActionType;
  name: string;
}

/**
 * Facility of a non-field action, as shown in an action overview
 */
export interface FacilityMinimalTo {
  id: string;
  type: FacilityType;
  name: string;
  unit: FacilityUnit;
}

export interface ParcelNameResponse {
  id: string;
  name: string;
}

export interface PorValidationErrorMaterialResponse {
  materialId: string;
  name: string;
  unit: string;
  totalDose: number;
  /** Dose per hectare; for a non-field action dose per unit of its facility */
  dosePerUnit: number;
  /** @nullable */
  parcels?: ParcelNameResponse[] | null;
}

export interface PorValidationErrorActionResponse {
  actionId: string;
  date: string;
  actionType: ActionTypeTo;
  targetCrop?: CropTo | null;
  materials: PorValidationErrorMaterialResponse[];
  facility?: FacilityMinimalTo | null;
}

export interface PorUseReportMissingDataBody {
  actionIdsMissingTargetCrop: PorValidationErrorActionResponse[];
  actionsWithInvalidUnit: PorValidationErrorActionResponse[];
  actionsWithInvalidOrganisms: PorValidationErrorActionResponse[];
  actionsWithInvalidEffectiveness: PorValidationErrorActionResponse[];
  /** The report has no osev in the period. The JUDPOR schema requires at least one, eAgri would refuse the report - typically a farm reporting only non-field applications (DEV-2959). */
  isMissingSeedApplication: boolean;
}

export interface ValidationError {
  detailedMessage: PorUseReportMissingDataBody;
  status: number;
  error: string;
  detail: string;
  /** @nullable */
  trace?: string | null;
}

/**
 * @nullable
 */
export type ReportIsAlreadyRunningDetailedMessage = { [key: string]: unknown } | null;

export type ReportType = typeof ReportType[keyof typeof ReportType];


export const ReportType = {
  POR_USE: 'POR_USE',
  FERTILIZER_USE: 'FERTILIZER_USE',
} as const;

export interface ReportIsAlreadyRunning {
  farmId?: string;
  type?: ReportType;
  status: number;
  error: string;
  detail: string;
  /** @nullable */
  trace?: string | null;
  /** @nullable */
  detailedMessage?: ReportIsAlreadyRunningDetailedMessage;
}

/**
 * @nullable
 */
export type EagriReportErrorDetailedMessage = { [key: string]: unknown } | null;

export interface EagriReportError {
  status: number;
  error: string;
  detail: string;
  /** @nullable */
  trace?: string | null;
  /** @nullable */
  detailedMessage?: EagriReportErrorDetailedMessage;
}

export interface FlatPlantProtectionMinimalTo {
  actionId: string;
  parcelId: string;
  materialName: string;
  date: string;
  targetCropName: string;
  actionType: ActionType;
}

export interface SeedApplicationMinimalTo {
  seedAppStart: string;
  /** @nullable */
  seedAppEnd?: string | null;
  parcelId: string;
  startSeedAppId: string;
  /** @nullable */
  seedExternalId?: string | null;
  /** @nullable */
  endActionId?: string | null;
  seedName: string;
  seedId: string;
  /** @nullable */
  parcelName?: string | null;
  /** @nullable */
  parcelExternalId?: string | null;
}

export interface PairedPlantProtectionTo {
  plantProtection: FlatPlantProtectionMinimalTo;
  seedApplication: SeedApplicationMinimalTo;
}

export type PlantProtectionPairingResultToAllItem = { [key: string]: unknown };

export interface PlantProtectionPairingResultTo {
  paired: PairedPlantProtectionTo[];
  pairedOnFollowing: PairedPlantProtectionTo[];
  notPaired: FlatPlantProtectionMinimalTo[];
  sendedSeedApplications: SeedApplicationMinimalTo[];
  all: PlantProtectionPairingResultToAllItem[];
}

export interface Aplikace {
  typ: string;
  idPestovani?: string;
  nazevObjekt?: string;
  datAplikace: string;
  idPlodina?: number;
  rozsahAplikace: number;
  mernaJednotkaObjekt: string;
  idPor?: number;
  nazevPor?: string;
  davka: number;
  mernaJednotkaPor: string;
  idSkodlivyOrganismus?: number;
  idSkodlivyOrganismusPPP?: number;
  nazevSkodlivyOrganismus?: string;
  tankmix?: boolean;
  ucinnostAplikace?: boolean;
}

export interface Applications {
  aplikace: Aplikace[];
}

export interface Vymery {
  vymera: number;
  platnostOd: string;
  platnostDo?: string;
}

export interface Pestovani {
  idPestovani: string;
  idPlodina?: number;
  viceleta?: boolean;
  hospRok?: number;
  typPlodiny?: string;
  zahajeniPestovani: string;
  ukonceniPestovani?: string;
  platnostOd: string;
  platnostDo?: string;
}

export interface Osev {
  zkod: string;
  ctverec: string;
  idPozemek: string;
  nazevPozemek?: string;
  platnostOd: string;
  platnostDo?: string;
  vymery: Vymery[];
  pestovani: Pestovani[];
}

export interface Osevy {
  osev: Osev[];
}

export interface PorUseBody {
  obdobiOd: string;
  obdobiDo: string;
  osevy: Osevy;
  aplikace?: Applications;
}

export type EagriFertilizerUseReportCallMode = typeof EagriFertilizerUseReportCallMode[keyof typeof EagriFertilizerUseReportCallMode];


export const EagriFertilizerUseReportCallMode = {
  PRODUCTION: 'PRODUCTION',
  TEST: 'TEST',
} as const;

export type EagriFertilizerUseReportType = typeof EagriFertilizerUseReportType[keyof typeof EagriFertilizerUseReportType];


export const EagriFertilizerUseReportType = {
  STATISTICS: 'STATISTICS',
  CHECK: 'CHECK',
  BALANCE: 'BALANCE',
} as const;

export interface EagriReportBody {
  from: string;
  to: string;
  type: EagriFertilizerUseReportType;
  callMode?: EagriFertilizerUseReportCallMode | null;
}

export interface SeedApplicationMissingUsageV2 {
  seedApplicationId: string;
  parcelId: string;
}

export interface FertilizerUseReportMissingDataBodyV2 {
  seedApplicationIdsMissingUsage: SeedApplicationMissingUsageV2[];
}

export interface MissingDataV2 {
  detailedMessage: FertilizerUseReportMissingDataBodyV2;
  status: number;
  error: string;
  detail: string;
  /** @nullable */
  trace?: string | null;
}

/**
 * @nullable
 */
export type InvalidDateRangeDetailedMessage = { [key: string]: unknown } | null;

export interface InvalidDateRange {
  status: number;
  error: string;
  detail: string;
  /** @nullable */
  trace?: string | null;
  /** @nullable */
  detailedMessage?: InvalidDateRangeDetailedMessage;
}

export interface EagriReportResponse {
  guid: string;
}

export interface Applcations {
  aplikace: Aplikace[];
}

export interface RozsahDat {
  kod: string;
}

export interface RozsahDats {
  rozsahDat: RozsahDat[];
}

export interface Sklizen {
  idPestovani: string;
  idProdukt?: number;
  typProduktu?: string;
  hospRok?: number;
  vymeraSklizne: number;
  mnozstviCelkem?: number;
  mnozstviHa?: number;
  mernaJednotka: string;
  susina?: number;
}

export interface Sklizne {
  sklizen: Sklizen[];
}

export interface Pastva {
  idPozemek: string;
  idDruhZvirat: string;
  idKategorieZvirat?: number;
  vlastniKategorieZvirat?: string;
  pocetKs: number;
  pocetDJ: number;
  pastvaOd: string;
  pastvaDo: string;
  pocetHodPastva?: number;
  vymeraPastvy?: number;
  mnozstviHa?: number;
  mernaJednotka?: string;
  idHnojivo?: number;
  nazevHnojivo?: string;
  metodaZivin?: string;
  privodN?: number;
  privodP?: number;
  privodK?: number;
}

export interface Pastvy {
  pastva: Pastva[];
}

export interface FertiliserUseBody {
  typ: string;
  obdobiOd?: string;
  obdobiDo?: string;
  hospRok?: number;
  rezimVolani?: string;
  rozsahDat?: RozsahDats;
  osevy: Osevy;
  aplikace?: Applcations;
  sklizne?: Sklizne;
  pastvy?: Pastvy;
}

/**
 * Format of the generated file.
 */
export type FileType = typeof FileType[keyof typeof FileType];


export const FileType = {
  PDF: 'PDF',
  XLSX: 'XLSX',
  CSV: 'CSV',
} as const;

/**
 * Parameters of a report export.
 */
export interface ReportRequestTo {
  /**
     * Parcels the report is limited to. Empty or null means the whole farm.
     * @nullable
     */
  parcelIds?: string[] | null;
  /** First day of the reported period. */
  dateFrom: string;
  /** Last day of the reported period. */
  dateTo: string;
  fileType: FileType;
}

export interface GeoJsonPolygon {
  coordinates: number[][][];
  type: GeoJsonType;
  isEmpty: boolean;
}

export interface FarmTo {
  id: string;
  code: string;
  /** @nullable */
  name?: string | null;
  countryCode: string;
  timeZone: string;
  /** @nullable */
  createdOn?: string | null;
  /** @nullable */
  createdBy?: string | null;
  boundingBox?: GeoJsonPolygon | null;
}

export type EagriImportMode = typeof EagriImportMode[keyof typeof EagriImportMode];


export const EagriImportMode = {
  BLOCKS: 'BLOCKS',
  BLOCKS_AND_PARCELS: 'BLOCKS_AND_PARCELS',
  SEED_APPS_V2: 'SEED_APPS_V2',
  BLOCKS_AND_PARCELS_V2: 'BLOCKS_AND_PARCELS_V2',
} as const;

export interface SubtractionTo {
  type: RestrictionType;
  /** @nullable */
  value?: number | null;
  /** @nullable */
  protectionLevel?: number | null;
  area: number;
  /** @nullable */
  isIgnored?: boolean | null;
}

export interface ZoneCreateTo {
  name: string;
}

export interface ZoneDetailTo {
  id: string;
  name: string;
  parcelCount: number;
  totalArea: number;
}

export interface ParcelVegetationStripRequest {
  parcelId: string;
  requiredWaterDistance: number;
}

export interface ParcelVegetationStripResponse {
  parcelId: string;
  requiredWaterDistance: number;
  isSufficient: boolean;
}

export interface MaterialApplicationRestrictionTo {
  plantProtectionId: string;
  targetOrganismIds: string[];
  targetCropId: string;
  driftClass: DriftClass;
}

export interface RecountSubtractionTo {
  type: RestrictionType;
  /** @nullable */
  value?: number | null;
  /** @nullable */
  protectionLevel?: number | null;
  isMaterial: boolean;
  isUsed: boolean;
  /** @nullable */
  isIgnored?: boolean | null;
}

/**
 * All parcels for action have to be sent. Even if there is no restriction for them.
 */
export interface ParcelRecountSubtractionTo {
  parcelId: string;
  restrictions: RecountSubtractionTo[];
}

export interface RecountSubtractionRequest {
  /** All parcels for action have to be sent. Even if there is no restriction for them. */
  restrictions: ParcelRecountSubtractionTo[];
  materials: MaterialApplicationRestrictionTo[];
}

export interface SubtractionResponse {
  type: RestrictionType;
  /** @nullable */
  value?: number | null;
  /** @nullable */
  protectionLevel?: number | null;
  area: number;
  isMaterial: boolean;
  isUsed: boolean;
  /** @nullable */
  isIgnored?: boolean | null;
}

export interface ParcelSubtractionResponse {
  parcelId: string;
  subtractions: SubtractionResponse[];
}

export interface ParcelRestrictionTo {
  parcelId: string;
  restrictions: RestrictionTo[];
}

export type GeoJsonCoordinatesItem = { [key: string]: unknown };

export interface GeoJson {
  type: GeoJsonType;
  geometries: GeoJson[];
  coordinates: GeoJsonCoordinatesItem[];
}

export interface ParcelGeometryResponse {
  parcelId: string;
  geometry: GeoJson;
}

export interface ParcelRestrictionRequestBody {
  parcelRestrictions: ParcelRestrictionTo[];
}

export interface SubtractionGeometryTo {
  type: RestrictionType;
  /** @nullable */
  value?: number | null;
  /** @nullable */
  protectionLevel?: number | null;
  isIgnored: boolean;
  /** Area [ha] of this subtraction alone; subtractions may overlap each other */
  area: number;
  /**
     * Part of area [ha] actually subtracted: not covered by an applied subtraction before it in the request. Counted areas add up to subtractedArea. Null when ignored.
     * @nullable
     */
  countedArea?: number | null;
  geometry?: GeoJson | null;
  /** True for an Absolute subtraction: its area is real, but the strip it is drawn as only illustrates it, it has no actual place on the parcel */
  isSchematic: boolean;
}

/**
 * Parcel with the geometry of each of its subtractions, for drawing them on a map
 */
export interface ParcelSubtractionGeometriesTo {
  parcelId: string;
  parcelGeometry: GeoJson;
  /** Recorded parcel area [ha], the one the form shows */
  parcelArea: number;
  effectiveGeometry: GeoJson;
  /** Area [ha] left once the non-ignored subtractions are applied, same as /subtractions/area */
  effectiveArea: number;
  subtractedGeometry: GeoJson;
  /** Area [ha] actually subtracted, parcelArea - effectiveArea */
  subtractedArea: number;
  subtractions: SubtractionGeometryTo[];
}

export interface ParcelAreaTo {
  parcelId: string;
  area: number;
}

/**
 * New farm facility
 */
export interface FacilityCreateTo {
  type: FacilityType;
  /**
     * Unique within the farm regardless of case
     * @maxLength 255
     */
  name: string;
  unit: FacilityUnit;
}

export interface CropSeedCreateTo {
  cropId: string;
  /** @nullable */
  varietyName?: string | null;
  /**
     * Remove with CFD-3673, new catalogue will use varietyName
     * @deprecated
     * @nullable
     */
  varietyId?: string | null;
  /**
     * Remove with CFD-3673
     * @deprecated
     * @nullable
     */
  note?: string | null;
}

export interface PlantProtectionApplicationBulkCreateTo {
  registrationId: string;
  applications: PlantProtectionApplicationCreateTo[];
}

export type PlantProtectionApplicationBulkSkipReason = typeof PlantProtectionApplicationBulkSkipReason[keyof typeof PlantProtectionApplicationBulkSkipReason];


export const PlantProtectionApplicationBulkSkipReason = {
  DUPLICATE_COMBINATION: 'DUPLICATE_COMBINATION',
} as const;

export interface SkippedPlantProtectionApplicationTo {
  /** @nullable */
  cropId?: string | null;
  /** @nullable */
  organismId?: string | null;
  reason: PlantProtectionApplicationBulkSkipReason;
}

export interface PlantProtectionApplicationBulkResultTo {
  created: string[];
  skipped: SkippedPlantProtectionApplicationTo[];
}

export interface CreateOrganismRequestTo {
  name: string;
}

export interface OrganismTo {
  id: string;
  name: string;
  /** @nullable */
  externalId?: string | null;
  catalogue: CatalogueTo;
}

export interface ActiveSubstanceCreateTo {
  name: string;
  /** @nullable */
  isIntegratedProductionVineyard?: boolean | null;
  /** @nullable */
  isIntegratedProductionOrchard?: boolean | null;
  /** @nullable */
  isIntegratedProductionVegetable?: boolean | null;
}

export interface CropCreateTo {
  name: string;
  color?: ColorTo | null;
  textColor?: ColorTo | null;
  /** @nullable */
  cropGroupId?: string | null;
  /** @nullable */
  isWinter?: boolean | null;
  /** @nullable */
  isSpring?: boolean | null;
  lifespan?: CropLifespan | null;
}

export interface CropProductCreateTo {
  cropId: string;
  /** @nullable */
  externalId?: string | null;
  name: string;
  isMain: boolean;
  /** @nullable */
  validFrom?: string | null;
  /** @nullable */
  validTo?: string | null;
  /** @nullable */
  secondaryProductId?: string | null;
}

export interface CropUseTypeCreateTo {
  /** @nullable */
  externalId?: string | null;
  name: string;
  /** @nullable */
  validFrom?: string | null;
  /** @nullable */
  validTo?: string | null;
}

export interface CropGroupCreateTo {
  name: string;
}

export type WaterProtectionZonesImportMode = typeof WaterProtectionZonesImportMode[keyof typeof WaterProtectionZonesImportMode];


export const WaterProtectionZonesImportMode = {
  SURFACE: 'SURFACE',
  GROUND: 'GROUND',
  BOTH: 'BOTH',
} as const;

export interface WaterProtectionZonesImportResult {
  mode: WaterProtectionZonesImportMode;
  /** @nullable */
  sourceRevisionDate?: string | null;
  /** @nullable */
  surfaceFeaturesImported?: number | null;
  /** @nullable */
  groundFeaturesImported?: number | null;
}

export type Status = typeof Status[keyof typeof Status];


export const Status = {
  NEW_VERSION_DETECTED: 'NEW_VERSION_DETECTED',
  UP_TO_DATE: 'UP_TO_DATE',
  ALREADY_NOTIFIED: 'ALREADY_NOTIFIED',
  VUV_UNREACHABLE: 'VUV_UNREACHABLE',
} as const;

export interface WaterProtectionZonesVuvContentSnapshot {
  surfaceFeatureCount: number;
  groundFeatureCount: number;
  opvnFeatureCount: number;
  fetchedAt: string;
}

export interface WaterProtectionZonesUpdateCheckResult {
  status: Status;
  /** @nullable */
  vuvRevisionDate?: string | null;
  /** @nullable */
  currentDbRevisionDate?: string | null;
  /** @nullable */
  lastNotifiedRevisionDate?: string | null;
  vuvContent?: WaterProtectionZonesVuvContentSnapshot | null;
}

export type AdminFarmManagementToResponse = { [key: string]: unknown };

export interface AdminFarmManagementTo {
  farmId: string;
  /** @nullable */
  farmName?: string | null;
  response: AdminFarmManagementToResponse;
}

export interface AdminNitrateVulnerableZoneTo {
  lpisBlockId: string;
  parcelId: string;
  /** @nullable */
  parcelName?: string | null;
  isNitrateVulnerable: boolean;
}

export interface ActionInheritanceDto {
  actionId: string;
  actionType: ActionType;
  retiredParcelId: string;
  newParcelId: string;
}

export interface ActionInheritanceResult {
  movedActions: ActionInheritanceDto[];
  notMovedActionsLowRank: ActionInheritanceDto[];
  notMovedActionsOther: ActionInheritanceDto[];
  notMovedActionDuplicated: ActionInheritanceDto[];
}

export interface AdminParcelValidityMoveItem {
  parcelId: string;
  newDate: string;
}

export interface AdminParcelValidityMoveResult {
  noop: string[];
  changed: AdminParcelValidityMoveItem[];
  actionMovesResult: ActionInheritanceResult[];
}

export interface AdminActionMoveResult {
  okFarms: string[];
  nokFarms: string[];
}

export interface AdminEagriTestFarmCreateRequest {
  userId: string;
  eagriLogin: string;
  eagriWsKey: string;
  eagriSzrid: string;
  customerName: string;
  validityDate: string;
  farmName: string;
  srid: number;
  language: string;
  importMode: EagriImportMode;
}

export interface SyncStats {
  totalFetched: number;
  totalUpserted: number;
  deletedCount: number;
}

export interface FarmSkeagisCreateRequest {
  skeagisUserId: string;
  state: IntegrationState;
  validFrom: string;
}

export interface FertilizerExpenseItemTo {
  dosePerHa: number;
  unit: string;
  fertilizerId: string;
}

export interface ParcelFertilizerExpenseV2To {
  parcelId: string;
  seedApplicationV2Id: string;
  actionArea: number;
  isStrawDecay: boolean;
  fertilizers: FertilizerExpenseItemTo[];
}

export interface TargetSeedApplicationFertilizationV2RequestTo {
  parcelFertilizerExpenses: ParcelFertilizerExpenseV2To[];
}

export interface ParcelAccountableNitrogenV2To {
  parcelId: string;
  seedApplicationV2Id: string;
  accountableNitrogen: number;
}

export interface SplitActionRequest {
  actionId: string;
  parcelsToSplit: string[];
}

export interface SplitActionResponse {
  originalActionId: string;
  splitActionId: string;
}

export type DecisionNodeType = typeof DecisionNodeType[keyof typeof DecisionNodeType];


export const DecisionNodeType = {
  GROUP: 'GROUP',
  BRANCH: 'BRANCH',
  GATE: 'GATE',
  CHECK: 'CHECK',
  VALUE: 'VALUE',
  LOOP: 'LOOP',
} as const;

export type NodeResult = typeof NodeResult[keyof typeof NodeResult];


export const NodeResult = {
  PASS: 'PASS',
  FAIL: 'FAIL',
  SKIPPED: 'SKIPPED',
} as const;

export type ViolationSeverity = typeof ViolationSeverity[keyof typeof ViolationSeverity];


export const ViolationSeverity = {
  OK: 'OK',
  ERROR: 'ERROR',
  WARNING: 'WARNING',
} as const;

export interface DecisionNodeTo {
  id: string;
  type: DecisionNodeType;
  label: string;
  onPath: boolean;
  result?: NodeResult | null;
  decisive: boolean;
  /** @nullable */
  expected?: string | null;
  /** @nullable */
  actual?: string | null;
  severity?: ViolationSeverity | null;
  /** @nullable */
  selectedChildId?: string | null;
  children: DecisionNodeTo[];
}

export type NitrateDirectiveVersion = typeof NitrateDirectiveVersion[keyof typeof NitrateDirectiveVersion];


export const NitrateDirectiveVersion = {
  NITRATE_DIRECTIVE_2015: 'NITRATE_DIRECTIVE_2015',
  NITRATE_DIRECTIVE_2016: 'NITRATE_DIRECTIVE_2016',
  NITRATE_DIRECTIVE_2020: 'NITRATE_DIRECTIVE_2020',
  NITRATE_DIRECTIVE_ALL: 'NITRATE_DIRECTIVE_ALL',
} as const;

export type NitrogenReferenceArea = typeof NitrogenReferenceArea[keyof typeof NitrogenReferenceArea];


export const NitrogenReferenceArea = {
  PARCEL: 'PARCEL',
  SOWN_AREA: 'SOWN_AREA',
} as const;

export interface NitrogenContributionTo {
  name: string;
  /** @nullable */
  date?: string | null;
  isCurrent: boolean;
  /** @nullable */
  nitrogenCategory?: string | null;
  doseKgHa: number;
  applicationAreaHa: number;
  referenceAreaHa: number;
  referenceArea: NitrogenReferenceArea;
  intersectionWeight: number;
  nitrogenKgHa: number;
  coefficient: number;
  accountableKgHa: number;
  excluded: boolean;
  /** @nullable */
  exclusionReason?: string | null;
  isOnStrawDecay: boolean;
}

export interface NitrogenBreakdownTo {
  currentAction: number;
  previousActions: number;
  /** @nullable */
  cropBound?: number | null;
  contributions: NitrogenContributionTo[];
}

export interface NitrogenInputTo {
  name: string;
  /**
     * Application date; null for the action currently being validated.
     * @nullable
     */
  date?: string | null;
  nitrogenKgHa: number;
  applicationAreaHa: number;
  nitrogenCategoryId: number;
  isOnStrawDecay: boolean;
  /** True for the action being validated, false for previously applied fertilizations. */
  isCurrent: boolean;
}

export type NitrogenLimitKind = typeof NitrogenLimitKind[keyof typeof NitrogenLimitKind];


export const NitrogenLimitKind = {
  SINGLE_DOSE_QUICK: 'SINGLE_DOSE_QUICK',
  SINGLE_DOSE_MINERAL: 'SINGLE_DOSE_MINERAL',
  SEASONAL_TOTAL: 'SEASONAL_TOTAL',
  SUMMER_AUTUMN_COMBINED: 'SUMMER_AUTUMN_COMBINED',
  SUMMER_AUTUMN_STRAW_DECAY: 'SUMMER_AUTUMN_STRAW_DECAY',
  SUMMER_AUTUMN_RAPESEED_EXTRA: 'SUMMER_AUTUMN_RAPESEED_EXTRA',
  ACCOUNTABLE_TOTAL: 'ACCOUNTABLE_TOTAL',
} as const;

export interface NitrogenLimitCheckTo {
  kind: NitrogenLimitKind;
  /** @nullable */
  limit?: number | null;
  applied: number;
  exceeded: boolean;
  breakdown?: NitrogenBreakdownTo | null;
}

/**
 * The crop that preceded this seed application (its crop-bound nitrogen is counted).
 */
export interface PreviousCropInputTo {
  eagriId: number;
  cropName: string;
  dateStart: string;
  /** @nullable */
  dateEnd?: string | null;
  nitrogenBindingKgHa: number;
}

export interface SeedApplicationInputTo {
  eagriId: number;
  cropName: string;
  dateStart: string;
  /** @nullable */
  dateEnd?: string | null;
  /** @nullable */
  sownArea?: number | null;
  isCatchCrop: boolean;
  /** Nitrogen bound by this crop in kg/ha. */
  nitrogenBindingKgHa: number;
  previousCrop?: PreviousCropInputTo | null;
  applications: NitrogenInputTo[];
}

export interface ParcelInputTo {
  parcelId: string;
  parcelName: string;
  seedApplications: SeedApplicationInputTo[];
}

export type RestrictionCode = typeof RestrictionCode[keyof typeof RestrictionCode];


export const RestrictionCode = {
  EagriCodeRestrictions: 'EagriCodeRestrictions',
  GrasslandsFertilizationRestriction: 'GrasslandsFertilizationRestriction',
  SlopeWaterFertilizationRestriction: 'SlopeWaterFertilizationRestriction',
  SlopeWaterSowingRestriction: 'SlopeWaterSowingRestriction',
  StrawDecayOrCatchCropRestriction: 'StrawDecayOrCatchCropRestriction',
} as const;

export interface ViolationSeedApplicationTo {
  eagriId: number;
  cropName: string;
  /** @nullable */
  seasonStartYear?: number | null;
  /** @nullable */
  cropStartDate?: string | null;
  /** @nullable */
  cropEndDate?: string | null;
  isCatchCrop: boolean;
  /**
     * ID of the parcel that violates the restriction. It may be historic parcel ID.
     * @nullable
     */
  parcelId?: string | null;
}

export interface ViolationParcelTo {
  id: string;
  name: string;
  eagriCodes: string[];
  /** @nullable */
  seedApplications?: ViolationSeedApplicationTo[] | null;
  /** @nullable */
  violatedSeedApplications?: ViolationSeedApplicationTo[] | null;
  /** @nullable */
  requiredWaterBuffer?: number | null;
}

export interface ViolationTo {
  code: string;
  message: string;
  text: string;
  /** @nullable */
  parcelId?: string | null;
  severity: ViolationSeverity;
  parcel?: ViolationParcelTo | null;
  limitChecks: NitrogenLimitCheckTo[];
  decisionTree?: DecisionNodeTo | null;
  /** @nullable */
  title?: string | null;
}

export interface ValidationResultTo {
  description: string;
  code: RestrictionCode;
  version: NitrateDirectiveVersion;
  violated: boolean;
  violations: ViolationTo[];
}

export interface ValidationResponseTo {
  valid: boolean;
  restrictions: ValidationResultTo[];
  refId: string;
  inputs: ParcelInputTo[];
}

export interface CenterAssignTo {
  /** @nullable */
  centerId?: string | null;
}

export type YieldGrade = typeof YieldGrade[keyof typeof YieldGrade];


export const YieldGrade = {
  I: 'I',
  II: 'II',
  III: 'III',
} as const;

export interface ParcelUpdateTo {
  /** @nullable */
  name?: string | null;
  userYieldGrade?: YieldGrade | null;
  /** @nullable */
  zoneIds?: string[] | null;
  center?: CenterAssignTo | null;
  /** @nullable */
  notes?: string | null;
}

/**
 * New start of a parcel's validity (DEV-1787). Backwards it opens the parcel up for records from before it was first imported; forwards it corrects a start set too early, as far as the day before the parcel's end.
 */
export interface ParcelValidFromUpdateTo {
  /** The date the parcel starts to be valid on. Not before 2000-01-01, not after the day before the parcel's end (today for a parcel that has not been retired). */
  validFrom: string;
}

/**
 * A parcel's validity period after the change
 */
export interface ParcelValidityTo {
  parcelId: string;
  validFrom: string;
  /**
     * Null for a parcel that is still open - it has not been retired by a historization yet.
     * @nullable
     */
  validTo?: string | null;
  /**
     * The date the parcel started on before anyone moved it, kept from the first move onwards. Null for a parcel that has never been moved.
     * @nullable
     */
  originalValidFrom?: string | null;
}

export type SeedUsageActivityType = typeof SeedUsageActivityType[keyof typeof SeedUsageActivityType];


export const SeedUsageActivityType = {
  SEED_APPLICATION_V2: 'SEED_APPLICATION_V2',
  PRESCRIPTION_MAP: 'PRESCRIPTION_MAP',
  ACTION: 'ACTION',
} as const;

export interface SeedUsageActivity {
  service: string;
  id: string;
  type: SeedUsageActivityType;
  /** @nullable */
  date?: string | null;
  /** @nullable */
  parcelId?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  status?: string | null;
}

export interface SeedInUseDetails {
  usedIn: string[];
  activities: SeedUsageActivity[];
}

export interface SeedInUseResponse {
  status: number;
  error: string;
  message: string;
  timestamp: string;
  details: SeedInUseDetails;
}

export interface CropSeedPatchTo {
  /** @nullable */
  varietyName?: string | null;
  /** @nullable */
  isFavorite?: boolean | null;
  /** @nullable */
  isHidden?: boolean | null;
}

export interface PlantProtectionPatchTo {
  isFavorite: boolean;
}

export interface SlopeConditionTo {
  /** @nullable */
  season?: string | null;
  /** @nullable */
  minDegrees?: number | null;
  /** @nullable */
  minDistanceM?: number | null;
  /** @nullable */
  vegetationStripM?: number | null;
  forbidden: boolean;
}

export interface PlantProtectionWaterSectionBulkTo {
  applicationIds: string[];
  buffers: PlantProtectionRegistrationApplicationBufferTo[];
  slopeConditions: SlopeConditionTo[];
  /** DEV-1652: true = merge — buffer rows this payload does not carry keep their stored value, and an empty/omitted slopeConditions keeps the stored slope rules; false = replace both buffers and slopes with this payload. Omit to get the merge default. */
  onlyFilledFields?: boolean;
}

export type ApplicationSectionBulkSkipReason = typeof ApplicationSectionBulkSkipReason[keyof typeof ApplicationSectionBulkSkipReason];


export const ApplicationSectionBulkSkipReason = {
  APPLICATION_NOT_FOUND: 'APPLICATION_NOT_FOUND',
} as const;

export interface SkippedApplicationSectionTo {
  applicationId: string;
  reason: ApplicationSectionBulkSkipReason;
}

export interface PlantProtectionApplicationSectionBulkResultTo {
  edited: string[];
  skipped: SkippedApplicationSectionTo[];
}

export interface PlantProtectionBufferSectionBulkTo {
  applicationIds: string[];
  buffers: PlantProtectionRegistrationApplicationBufferTo[];
  /** DEV-1652: true = merge — a buffer row this payload does not carry keeps the value the application already holds, a supplied row overwrites the stored row with the same discriminator; false = replace the section's buffers with this payload. Omit to get the merge default. */
  onlyFilledFields?: boolean;
}

export interface TankMixPartnerTo {
  /** @nullable */
  productName?: string | null;
  /** @nullable */
  productId?: string | null;
  /** @nullable */
  minDose?: number | null;
  /** @nullable */
  maxDose?: number | null;
  /** @nullable */
  unit?: string | null;
  /** @nullable */
  condition?: string | null;
  /** @nullable */
  dosageOrdinal?: number | null;
}

export interface PlantProtectionDosageSectionBulkTo {
  applicationIds: string[];
  /** @nullable */
  minDose?: number | null;
  /** @nullable */
  maxDose?: number | null;
  /** @nullable */
  unit?: string | null;
  /** @nullable */
  minDoseWater?: number | null;
  /** @nullable */
  maxDoseWater?: number | null;
  /** @nullable */
  unitWater?: string | null;
  /** @nullable */
  minBbch?: number | null;
  /** @nullable */
  maxBbch?: number | null;
  /** @nullable */
  allowedApplications?: number | null;
  /** @nullable */
  minInterval?: number | null;
  /** @nullable */
  maxInterval?: number | null;
  /** @nullable */
  protectionPeriod?: number | null;
  /** @nullable */
  protectionPeriodIsApplicationTerm?: boolean | null;
  /** @nullable */
  isAerialApplication?: boolean | null;
  /** @nullable */
  isSeedTreatment?: boolean | null;
  /** @nullable */
  dosages?: DosageTo[] | null;
  /** @nullable */
  tankMixPartners?: TankMixPartnerTo[] | null;
  /** DEV-1652: true = merge — a field this payload omits keeps the value the application already holds; false = replace the section, so an omitted field is cleared. Omit to get the merge default, which matches the FE switch "Uložit pouze vyplněná pole" being ON. */
  onlyFilledFields?: boolean;
}

export interface FertilizerPatchTo {
  /** @nullable */
  isFavorite?: boolean | null;
  /** @nullable */
  isHidden?: boolean | null;
}

export interface CropUpdateTo {
  /** @nullable */
  name?: string | null;
  color?: ColorTo | null;
  textColor?: ColorTo | null;
  /** @nullable */
  cropGroupId?: string | null;
  /** @nullable */
  isWinter?: boolean | null;
  /** @nullable */
  isSpring?: boolean | null;
  lifespan?: CropLifespan | null;
}

export interface PublicCropTo {
  id: string;
  name: string;
  /** @nullable */
  variety?: string | null;
}

export interface PublicParcelTo {
  id: string;
  blockNumber: string;
  name: string;
  area: number;
  geometry: GeoJsonMultiPolygon;
  currentCrop?: PublicCropTo | null;
}

/**
 * Agricultural season (July 1st - June 30th) of the V2 sowing plan, derived from the year. The seasons endpoint always includes the previous season to cover the season turnover (DEV-1357).
 */
export interface AgriculturalSeasonTo {
  startYear: number;
  endYear: number;
  dateStart: string;
  dateEnd: string;
  /** True for the season that today's date falls into */
  isCurrent: boolean;
}

/**
 * The season window the V2 sowing plan should display, plus how far back the farm can go.
 */
export interface SowingPlanSeasonWindowTo {
  /** The seasons of the window, oldest first */
  seasons: AgriculturalSeasonTo[];
  /**
     * Start year of the oldest season this farm has anything to show in - the season its oldest parcel record begins in. Null when no farm was given or the farm has no parcels; the caller then has no lower bound to stop at (DEV-1786).
     * @nullable
     */
  earliestStartYear?: number | null;
}

/**
 * One crop row of the V2 sowing plan overview
 */
export interface SowingPlanV2CropStatisticsTo {
  crop: CropTo;
  /** Distinct parcels with this crop attributed to the season */
  parcelsCount: number;
  /** Sum of the area (ha) of those parcels */
  area: number;
}

/**
 * Per-season crop summary of the V2 sowing plan: crop, parcel count and area
 */
export interface SowingPlanV2OverviewTo {
  startYear: number;
  endYear: number;
  /** First day of the agricultural season (July 1st of startYear) */
  dateStart: string;
  /** Last day of the agricultural season (June 30th of endYear) */
  dateEnd: string;
  statistics: SowingPlanV2CropStatisticsTo[];
  /** Distinct parcels with any real crop attributed to the season */
  totalParcelsCount: number;
  /** Total area (ha) of those parcels, each counted once */
  totalArea: number;
}

export interface InternalSeedApplicationByParcelTo {
  parcelId: string;
  seedApplication?: InternalSeedApplicationTo | null;
}

export interface InternalFertilizerMineralIntakeResponse {
  nitrogen: number;
  accountableNitrogen: number;
  p2o5: number;
  k2o: number;
  mgo: number;
  cao: number;
  sulfur: number;
}

export interface InternalFarmResponse {
  id: string;
  name: string;
  /** @nullable */
  countryCode?: string | null;
  source: InternalFarmImportSource;
  isVisibleInPublicLayers: boolean;
  integrationSource?: FarmIntegrationSource | null;
  /** @nullable */
  companyNumber?: string | null;
  /** @nullable */
  businessCentralId?: string | null;
  /** @nullable */
  createdOn?: string | null;
  isDeleted: boolean;
}

export interface InternalNutrientConsumptionTo {
  type: NutrientType;
  value: number;
}

export interface InternalCropProductUseTypeTo {
  productId: string;
  /** @nullable */
  productName?: string | null;
  /** @nullable */
  isMainProduct?: boolean | null;
  /** @nullable */
  cropUseTypeId?: string | null;
  /** @nullable */
  cropUseTypeName?: string | null;
  /** @nullable */
  dryMatter?: number | null;
  nutrientConsumption: InternalNutrientConsumptionTo[];
  /** @nullable */
  secondaryProductRatio?: number | null;
}

export interface InternalCropTo {
  id: string;
  externalId: string;
  name: string;
  isNoCrop: boolean;
  products: InternalCropProductUseTypeTo[];
}

export type SeedApplicationTerminationChangeType = typeof SeedApplicationTerminationChangeType[keyof typeof SeedApplicationTerminationChangeType];


export const SeedApplicationTerminationChangeType = {
  ENDED: 'ENDED',
  FOLLOWING_SHIFTED: 'FOLLOWING_SHIFTED',
} as const;

export interface SeedApplicationTerminationChangeTo {
  parcelId: string;
  seedApplicationId: string;
  change: SeedApplicationTerminationChangeType;
  dateStartFrom: string;
  dateStartTo: string;
  /** @nullable */
  dateEndFrom?: string | null;
  /** @nullable */
  dateEndTo?: string | null;
}

export type SeedApplicationTerminationSkipReason = typeof SeedApplicationTerminationSkipReason[keyof typeof SeedApplicationTerminationSkipReason];


export const SeedApplicationTerminationSkipReason = {
  NOT_LAST_PARCEL_IN_GROUP: 'NOT_LAST_PARCEL_IN_GROUP',
  GROUP_LAST_PARCEL_UNRESOLVED: 'GROUP_LAST_PARCEL_UNRESOLVED',
} as const;

export interface SeedApplicationTerminationSkipTo {
  parcelId: string;
  /** @nullable */
  parcelName?: string | null;
  /** @nullable */
  parcelShortName?: string | null;
  /** @nullable */
  parcelValidFrom?: string | null;
  /** @nullable */
  parcelValidTo?: string | null;
  seedApplicationId: string;
  /** @nullable */
  groupId?: string | null;
  reason: SeedApplicationTerminationSkipReason;
}

export interface SeedApplicationTerminationPreviewTo {
  farmId: string;
  actionDate: string;
  changes: SeedApplicationTerminationChangeTo[];
  skipped: SeedApplicationTerminationSkipTo[];
}

export interface ConnectableSeedApplicationV2ResultTo {
  type: SeedApplicationType;
  seed?: CropSeedTo;
  cropUse?: CropUseTypeTo;
  cropProduct?: CropProductTo;
  startDate: string;
  endDate?: string;
  resultType: string;
}

export type ConnectableSeedApplicationV2To = ConnectableSeedApplicationV2ResultTo & ({
  id: string;
  seed?: CropSeedTo | null;
  cropUse?: CropUseTypeTo | null;
  cropProduct?: CropProductTo | null;
  /** @nullable */
  groupId?: string | null;
  /** @nullable */
  endDate?: string | null;
  sownAreaHa: number;
  parcelId: string;
  parcelName: string;
  /** @nullable */
  parcelNumber?: string | null;
  parcelAreaHa: number;
  /** @nullable */
  parcelValidFrom?: string | null;
  /** @nullable */
  parcelValidTo?: string | null;
});

export type ConnectableSeedApplicationV2GroupTo = ConnectableSeedApplicationV2ResultTo & ({
  groupId: string;
  seed?: CropSeedTo | null;
  cropUse?: CropUseTypeTo | null;
  cropProduct?: CropProductTo | null;
  /** @nullable */
  endDate?: string | null;
  totalSownAreaHa: number;
  seedApplications: ConnectableSeedApplicationV2To[];
});

export type LandUse = typeof LandUse[keyof typeof LandUse];


export const LandUse = {
  ARABLE: 'ARABLE',
  HOPFIELD: 'HOPFIELD',
  VINEYARD: 'VINEYARD',
  OTHER_PERMANENT: 'OTHER_PERMANENT',
  ORCHARD: 'ORCHARD',
  GRASS: 'GRASS',
  OTHER: 'OTHER',
  SET_ASIDE: 'SET_ASIDE',
  FODDER: 'FODDER',
  UNPRODUCTIVE: 'UNPRODUCTIVE',
  MULTIPLE_CROPS: 'MULTIPLE_CROPS',
  TRUFFLES: 'TRUFFLES',
  CONTAINERS: 'CONTAINERS',
  NURSERY: 'NURSERY',
  VEGETABLES: 'VEGETABLES',
  POND: 'POND',
  FAST_GROW: 'FAST_GROW',
  WOODED: 'WOODED',
  UNKNOWN: 'UNKNOWN',
} as const;

export type ParcelV2SortColumn = typeof ParcelV2SortColumn[keyof typeof ParcelV2SortColumn];


export const ParcelV2SortColumn = {
  LOCAL_NAME: 'LOCAL_NAME',
  BLOCK_NUMBER: 'BLOCK_NUMBER',
  AREA: 'AREA',
  VALID_FROM: 'VALID_FROM',
  CENTER: 'CENTER',
} as const;

export type SortDirection = typeof SortDirection[keyof typeof SortDirection];


export const SortDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

/**
 * Point-in-time current-state crop summary of the V2 sowing plan
 */
export interface SowingPlanV2CurrentStateTo {
  /** The date the state is taken at (today when not specified) */
  date: string;
  /** One row per crop on the farm at the date, including a 'no crop' row */
  statistics: SowingPlanV2CropStatisticsTo[];
  /** All parcels valid at the date, each counted once (incl. parcels with no crop) */
  totalParcelsCount: number;
  /** Total area (ha) of those parcels */
  totalArea: number;
}

export type EagriEvaluationState = typeof EagriEvaluationState[keyof typeof EagriEvaluationState];


export const EagriEvaluationState = {
  WAITING: 'WAITING',
  DONE: 'DONE',
  GAVE_UP: 'GAVE_UP',
  NOT_APPLICABLE: 'NOT_APPLICABLE',
} as const;

export interface FertilizerUseReportMissingDataBody {
  actionIdsMissingUsage: string[];
}

export type ReportErrorBody = PorUseReportMissingDataBody | FertilizerUseReportMissingDataBody | FertilizerUseReportMissingDataBodyV2;

export type SendFailureType = typeof SendFailureType[keyof typeof SendFailureType];


export const SendFailureType = {
  VALIDATION: 'VALIDATION',
  EAGRI_REJECTED: 'EAGRI_REJECTED',
  TRANSPORT: 'TRANSPORT',
} as const;

export interface ReportHistoryTo {
  id: string;
  type: ReportType;
  started: string;
  /** @nullable */
  finished?: string | null;
  /** @nullable */
  success?: boolean | null;
  sendFailureType?: SendFailureType | null;
  /** @nullable */
  sendErrorsCount?: number | null;
  periodFrom: string;
  periodTo: string;
  /** @nullable */
  note?: string | null;
  jsonNote?: ReportErrorBody | null;
  /** @nullable */
  eagriGuid?: string | null;
  eagriStatus?: EagriReportStatusType | null;
  eagriEvaluation: EagriEvaluationState;
  /** @nullable */
  eagriErrorsCount?: number | null;
  /** @nullable */
  eagriWarningsCount?: number | null;
  hasErrorReport: boolean;
  hasConfirmation: boolean;
}

export type EagriReportSendingMode = typeof EagriReportSendingMode[keyof typeof EagriReportSendingMode];


export const EagriReportSendingMode = {
  REAL: 'REAL',
  MOCK: 'MOCK',
  DISABLED: 'DISABLED',
} as const;

export interface EagriReportSendingModeTo {
  sendingMode: EagriReportSendingMode;
}

export type ParcelSource = typeof ParcelSource[keyof typeof ParcelSource];


export const ParcelSource = {
  MANUAL: 'MANUAL',
  SHP: 'SHP',
  AGROEVIDENCE_EAGRI: 'AGROEVIDENCE_EAGRI',
  AGROEVIDENCE_EAGRI_AUTOMATIC: 'AGROEVIDENCE_EAGRI_AUTOMATIC',
  SKEAGIS: 'SKEAGIS',
  CORE: 'CORE',
} as const;

/**
 * Parcel list item
 */
export interface ParcelTo {
  id: string;
  blockNumber: string;
  localName: string;
  area: number;
  lpisBlockArea: number;
  nitrateVulnerable: boolean;
  validFrom: string;
  /** @nullable */
  validTo?: string | null;
  status: ParcelStatus;
  /** @nullable */
  zones?: ZoneTo[] | null;
  center?: CenterTo | null;
  landUseName: string;
  source: ParcelSource;
  /** @nullable */
  slope?: number | null;
  /** @nullable */
  waterDistance?: number | null;
  zone?: ZoneTo | null;
}

/**
 * Parcel application zone from LPIS
 */
export type ApplicationZone = typeof ApplicationZone[keyof typeof ApplicationZone];


export const ApplicationZone = {
  I: 'I',
  II: 'II',
  IIIa: 'IIIa',
  IIIb: 'IIIb',
} as const;

export interface EagriParcelAttributesTo {
  lpisBlockArea: number;
  landUse: LandUse;
  /** Designated parcel land use localized name */
  landUseName: string;
  yieldGrade?: YieldGrade | null;
  userYieldGrade?: YieldGrade | null;
  applicationZone?: ApplicationZone | null;
  /**
     * Bonitiated soil ecological unit = BPEJ
     * @nullable
     */
  soilEcologicalUnit?: string | null;
  /**
     * Average parcel altitude
     * @minimum 0
     * @nullable
     */
  altitude?: number | null;
  /**
     * Average parcel slope
     * @minimum 0
     * @nullable
     */
  slope?: number | null;
  /**
     * Minimal parcel water distance
     * @minimum 0
     * @nullable
     */
  waterDistance?: number | null;
}

/**
 * Parcel detail
 */
export interface ParcelDetailTo {
  id: string;
  blockNumber: string;
  localName: string;
  area: number;
  geometry: GeoJsonMultiPolygon;
  status: ParcelStatus;
  nitrateVulnerable: boolean;
  validFrom: string;
  /** @nullable */
  validTo?: string | null;
  /**
     * The date the parcel started on before a user moved its start into the past (DEV-1787). Null for a parcel nobody has moved.
     * @nullable
     */
  originalValidFrom?: string | null;
  /** @nullable */
  notes?: string | null;
  /** @nullable */
  zones?: ZoneTo[] | null;
  center?: CenterTo | null;
  eagri: EagriParcelAttributesTo;
  eagriRestrictions: string[];
  parcelSource: ParcelSource;
  zone?: ZoneTo | null;
}

export interface SowingPlanSeasonTo {
  id: string;
  startYear: number;
  endYear: number;
}

export interface SowingPlanSeasonCropTo {
  season: SowingPlanSeasonTo;
  crop?: CropTo | null;
}

export interface ParcelSeedApplicationWithPlanTo {
  planned?: SowingPlanSeasonCropTo | null;
}

export interface ParcelPredecessorTo {
  id: string;
  localName: string;
  /** @nullable */
  blockNumber?: string | null;
}

/**
 * Parcel list item with V2 seed application
 */
export interface ParcelToV2 {
  id: string;
  blockNumber: string;
  localName: string;
  area: number;
  lpisBlockArea: number;
  nitrateVulnerable: boolean;
  validFrom: string;
  /** @nullable */
  validTo?: string | null;
  status: ParcelStatus;
  isRetired: boolean;
  /** @nullable */
  zones?: ZoneTo[] | null;
  center?: CenterTo | null;
  landUseName: string;
  seedApplication?: SeedApplicationV2GroupToV2 | SeedApplicationV2To | null;
  source: ParcelSource;
  /** @nullable */
  slope?: number | null;
  /** @nullable */
  waterDistance?: number | null;
  zone?: ZoneTo | null;
}

export type NitrateRestrictionSource = typeof NitrateRestrictionSource[keyof typeof NitrateRestrictionSource];


export const NitrateRestrictionSource = {
  EAGRI: 'EAGRI',
  LAND_USE: 'LAND_USE',
  YIELD_GRADE: 'YIELD_GRADE',
  CLEVERFARM: 'CLEVERFARM',
} as const;

export interface EagriNitrateRestrictionWithDescriptionTo {
  code: string;
  description: string;
  /** @nullable */
  validFrom?: string | null;
  /** @nullable */
  validTo?: string | null;
  source: NitrateRestrictionSource;
}

export interface EagriNitrateRestrictionByYearTo {
  /** @nullable */
  year?: number | null;
  isOldNitrate: boolean;
  nitrateRestrictions: EagriNitrateRestrictionWithDescriptionTo[];
}

export interface EagriSubsidyTo {
  square: string;
  blockNr: string;
  declaredArea: number;
  subsidyTypeId: number;
  from: string;
  /** @nullable */
  to?: string | null;
  subsidyTitleId: number;
  /** @nullable */
  cropId?: number | null;
  code: string;
  description: string;
}

export interface ParcelEagriInfoTo {
  /** @nullable */
  aekoYear?: number | null;
  aeko: EagriSubsidyTo[];
  nitrate: EagriNitrateRestrictionByYearTo[];
}

export interface ParcelWaterDistanceTo {
  parcelId: string;
  landWaterBoundaryDistanceM: number;
}

/**
 * Parcel detail V2 with SeedApplicationV2To
 */
export interface ParcelDetailV2To {
  id: string;
  blockNumber: string;
  localName: string;
  area: number;
  geometry: GeoJsonMultiPolygon;
  status: ParcelStatus;
  nitrateVulnerable: boolean;
  validFrom: string;
  /** @nullable */
  validTo?: string | null;
  /**
     * The date the parcel started on before a user moved its start into the past (DEV-1787). Null for a parcel nobody has moved.
     * @nullable
     */
  originalValidFrom?: string | null;
  /** @nullable */
  notes?: string | null;
  /** @nullable */
  zones?: ZoneTo[] | null;
  center?: CenterTo | null;
  eagri: EagriParcelAttributesTo;
  seedApplication?: SeedApplicationV2To | null;
  eagriRestrictions: string[];
  parcelSource: ParcelSource;
  zone?: ZoneTo | null;
}

export interface FertilizationTo {
  /** Kilos of nitrogen per ha that will be absorbed by soil. Used for nitrate restrictions. */
  accountableNitrogen: number;
  /** Kilos of nitrogen per ha */
  nitrogen: number;
  /** Kilos of p2o5 per ha */
  p2o5: number;
  /** Kilos of k2o per ha */
  k2o: number;
  mgo: number;
  cao: number;
  sulfur: number;
}

/**
 * Yield per product and unit from the harvests of the year, per hectare of the same area.
 */
export interface SeedApplicationYieldProductTo {
  cropProduct?: CropProductTo | null;
  isMainProduct: boolean;
  unit: YieldUnit;
  /** Sum of the counted amounts of all sources of this product and unit. */
  amount: number;
  /** amount / area of the yield. */
  amountPerHa: number;
  /** Number of harvests / cuts the amount is made of. */
  sourceCount: number;
}

/**
 * Harvests and cuts dated in the year.
 */
export interface SeedApplicationYieldSourceTo {
  actionId: string;
  actionType: ActionType;
  date: string;
  cropProduct?: CropProductTo | null;
  isMainProduct: boolean;
  unit: YieldUnit;
  /** Amount entered for the parcel in the action. */
  amount: number;
  /** amount / area of the parcel in the action. */
  amountPerHa: number;
  /** Part of amount counted on this seed application: lower than amount when the action covered more than the sown area (DEV-2503). */
  countedAmount: number;
}

/**
 * Yield of a perennial seed application in one calendar year (DEV-2774).
 */
export interface SeedApplicationYieldYearTo {
  year: number;
  /** Yield per product and unit from the harvests of the year, per hectare of the same area. */
  products: SeedApplicationYieldProductTo[];
  /** Harvests and cuts dated in the year. */
  sources: SeedApplicationYieldSourceTo[];
}

/**
 * Actual yield of a seed application, from the harvests and cuts matched to it (DEV-2767).
 */
export interface SeedApplicationYieldTo {
  /** Area (ha) the per-hectare yield is expressed on: the sown area, or the harvested area when the seed application has none. */
  area: number;
  /** Yield per product and unit, main products first. Different units are never summed. */
  products: SeedApplicationYieldProductTo[];
  /** Harvests and cuts the yield is made of, by date. */
  sources: SeedApplicationYieldSourceTo[];
  /** Perennial crops only (DEV-2774): the yield per calendar year of the harvest date (1. 1.-31. 12.), every year from the start of the seed application to its end or the current year, years without a harvest included. Empty for annual crops. */
  years: SeedApplicationYieldYearTo[];
}

export interface GroupMemberParcelSeedApplicationToV2 {
  parcelId: string;
  parcelName: string;
  parcelArea: number;
  /** @nullable */
  blockNumber?: string | null;
  validFrom: string;
  /** @nullable */
  validTo?: string | null;
  parcelStatus: ParcelStatus;
  seedApplication: SeedApplicationV2To;
  fertilization: FertilizationTo;
  /** Geometric area (ha) of this member parcel's overlap with the viewed parcel, rounded to 3 decimals. */
  intersectionArea: number;
  /** Weight of this member in the group total: intersectionArea / geometric area of the viewed parcel (0..1), rounded to 3 decimals. */
  intersectionRatio: number;
  fertilizationContribution: FertilizationTo;
  /** @nullable */
  primaryRevenueHa?: number | null;
  /** @nullable */
  secondaryRevenueHa?: number | null;
  /** The member's parcel is historical and was split into more than one successor (DEV-2772): its yield cannot be attributed to the current field, so the app shows a hint instead of the yield. */
  hasMultipleSuccessors: boolean;
  actualYield: SeedApplicationYieldTo;
}

export interface ParcelSeedApplicationResultToV2 {
  resultType: string;
}

export interface PreviousCropToV2 {
  cropName: string;
  startDate: string;
  /** @nullable */
  endDate?: string | null;
  boundNitrogenKgHa: number;
}

export type ParcelSeedApplicationGroupToV2 = ParcelSeedApplicationResultToV2 & ({
  id: string;
  groupId: string;
  seed?: CropSeedTo | null;
  type: SeedApplicationType;
  startDate: string;
  /** @nullable */
  endDate?: string | null;
  cropUse?: CropUseTypeTo | null;
  sowingMainProduct?: CropProductTo | null;
  isHarvestable: boolean;
  totalArea: number;
  parcelIds: string[];
  totalFertilization: FertilizationTo;
  /** @nullable */
  totalPrimaryRevenue?: number | null;
  /** @nullable */
  totalSecondaryRevenue?: number | null;
  parcelSeedApplications: GroupMemberParcelSeedApplicationToV2[];
  previousCrop?: PreviousCropToV2 | null;
  /** @nullable */
  firstSowingDate?: string | null;
  /** @nullable */
  lastHarvestDate?: string | null;
});

export type ParcelSeedApplicationToV2 = ParcelSeedApplicationResultToV2 & ({
  seedApplication: SeedApplicationV2To;
  fertilization: FertilizationTo;
  /** @nullable */
  primaryRevenueHa?: number | null;
  /** @nullable */
  secondaryRevenueHa?: number | null;
  previousCrop?: PreviousCropToV2 | null;
  actualYield: SeedApplicationYieldTo;
});

export interface ActionExpenseOverviewTo {
  materialId: string;
  materialType: MaterialType;
  materialName: string;
  /** @nullable */
  materialLegislativeCode?: number | null;
  /** @nullable */
  amount?: number | null;
  /** @nullable */
  unit?: string | null;
  /** @nullable */
  dosePerUnit?: number | null;
  /** @nullable */
  nitrogen?: number | null;
  /** @nullable */
  p2o5?: number | null;
  /** @nullable */
  k2o?: number | null;
  /** @nullable */
  mgo?: number | null;
  /** @nullable */
  cao?: number | null;
  /** @nullable */
  s?: number | null;
}

export interface ActionParcelMinimalV2To {
  id: string;
  actionParcelId: string;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  blockNumber?: string | null;
  /** @nullable */
  region?: string | null;
  landUse: LandUse;
  /** @nullable */
  landUseLocalised?: string | null;
  parcelArea: number;
  actionArea: number;
  restrictedArea: number;
  /** @nullable */
  seedApplicationV2Id?: string | null;
  /** @nullable */
  seedAppSownArea?: number | null;
  /** @nullable */
  seedAppIsCatchCrop?: boolean | null;
  isNitrateVulnerable: boolean;
  status: ParcelStatus;
  validFrom: string;
  /** @nullable */
  validTo?: string | null;
  isOutsideValidity: boolean;
  isOutsideSeedApplication: boolean;
}

export interface ActionOverviewV2To {
  id: string;
  date: string;
  isDraft: boolean;
  actionType: ActionTypeTo;
  crops: CropTo[];
  parcels: ActionParcelMinimalV2To[];
  expenses: ActionExpenseOverviewTo[];
  source: ActionSource;
  seedApplicationType: SeedApplicationType;
  /** @nullable */
  seedApplicationNitrogen?: number | null;
  /** @nullable */
  isStrawDecay?: boolean | null;
  /**
     * Time of the action in ISO-8601 format
     * @nullable
     */
  time?: string | null;
  facility?: FacilityMinimalTo | null;
  /**
     * Extent of a non-field action in the unit of its facility; null for actions on parcels
     * @nullable
     */
  applicationExtent?: number | null;
  targetCrop?: CropTo | null;
}

export interface CropStatisticTo {
  /** @nullable */
  externalId?: number | null;
  name: string;
  count: number;
  totalArea: number;
  color: ColorTo;
  textColor: ColorTo;
  cropId: string;
  isNoCrop: boolean;
}

export interface ParcelStatisticsTo {
  count: number;
  totalArea: number;
}

export interface FarmStatisticsTo {
  crops: CropStatisticTo[];
  parcels: ParcelStatisticsTo;
}

export interface GeoJsonPoint {
  coordinates: number[];
  type: GeoJsonType;
}

export interface ParcelMapToV2 {
  parcelId: string;
  parcelName: string;
  /** @nullable */
  blockNr?: string | null;
  /** @nullable */
  currentCropName?: string | null;
  /** @nullable */
  cropId?: string | null;
  /** @nullable */
  cropColor?: string | null;
  area: number;
  /** @nullable */
  parcelValidFrom?: string | null;
  /** @nullable */
  altitude?: number | null;
  /** @nullable */
  slope?: number | null;
  isNitrateVulnerable: boolean;
  /** @nullable */
  landUseName?: string | null;
  /** @nullable */
  landUseColor?: string | null;
  zones: ZoneTo[];
  centroid?: GeoJsonPoint | null;
  isSowingPerformed: boolean;
}

/**
 * Parcel suggestions list item
 */
export interface ParcelSuggestionTo {
  id: string;
  blockNumber: string;
  localName: string;
  status: ParcelStatus;
  validFrom: string;
  /** @nullable */
  validTo?: string | null;
}

export interface LandUseResponse {
  key: LandUse;
  name: string;
}

export interface ParcelIntersectionTo {
  parcelId: string;
  intersectionArea: number;
  intersectionGeometry: GeoJsonMultiPolygon;
}

export interface ActionGeomOverviewTo {
  id: string;
  date: string;
  isDraft: boolean;
  actionType: ActionTypeTo;
  expenses: ActionExpenseOverviewTo[];
  source: ActionSource;
  /** @nullable */
  seedApplicationNitrogen?: number | null;
  /** @nullable */
  isStrawDecay?: boolean | null;
  actionParcelIntersections: ParcelIntersectionTo[];
  targetCrop?: CropTo | null;
  /** @nullable */
  time?: string | null;
}

export interface FarmUpdateParcelChange {
  /** @nullable */
  parcelId?: string | null;
  /** @nullable */
  block?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  area?: number | null;
  /** @nullable */
  validFrom?: string | null;
  /** @nullable */
  validTo?: string | null;
}

export interface FarmUpdateHistorizationChange {
  retired: FarmUpdateParcelChange[];
  new: FarmUpdateParcelChange[];
}

export interface FarmUpdateIdentityRefreshChange {
  /** @nullable */
  parcelId?: string | null;
  /** @nullable */
  block?: string | null;
  /** @nullable */
  oldName?: string | null;
  /** @nullable */
  oldExtId?: string | null;
  /** @nullable */
  oldVersionExtId?: string | null;
  /** @nullable */
  oldArea?: number | null;
  /** @nullable */
  oldValidFrom?: string | null;
  /** @nullable */
  newName?: string | null;
  /** @nullable */
  newExtId?: string | null;
  /** @nullable */
  newVersionExtId?: string | null;
  /** @nullable */
  newArea?: number | null;
}

export interface FarmUpdateChangeSummary {
  created: FarmUpdateParcelChange[];
  permanentlyRetired: FarmUpdateParcelChange[];
  historizations: FarmUpdateHistorizationChange[];
  identityRefreshed: FarmUpdateIdentityRefreshChange[];
}

export interface FarmUpdateErrorFlatResponse {
  /** @nullable */
  block?: string | null;
  /** @nullable */
  parcelId?: string | null;
  /** @nullable */
  parcelName?: string | null;
  /** @nullable */
  extParcelId?: string | null;
  geometryToRepair?: GeoJson | null;
  conflictingGeometry?: GeoJson | null;
  changeGeometry?: GeoJson | null;
}

export type FarmUpdateSource = typeof FarmUpdateSource[keyof typeof FarmUpdateSource];


export const FarmUpdateSource = {
  EMPTY_FARM: 'EMPTY_FARM',
  EAGRI: 'EAGRI',
  SKEAGIS: 'SKEAGIS',
  SHP: 'SHP',
} as const;

export type FarmUpdateState = typeof FarmUpdateState[keyof typeof FarmUpdateState];


export const FarmUpdateState = {
  IN_PROGRESS: 'IN_PROGRESS',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
} as const;

export interface FarmUpdateNewParcels {
  /** @nullable */
  parcelId?: string | null;
  /** @nullable */
  block?: string | null;
}

export type FarmUpdateGeometryErrorType = typeof FarmUpdateGeometryErrorType[keyof typeof FarmUpdateGeometryErrorType];


export const FarmUpdateGeometryErrorType = {
  BLOCK_OVERLAP: 'BLOCK_OVERLAP',
  PARCELS_OVERLAP: 'PARCELS_OVERLAP',
  PARCELS_NOT_FILLING_BLOCK: 'PARCELS_NOT_FILLING_BLOCK',
  PARCELS_VERSION_INCONSISTENCY: 'PARCELS_VERSION_INCONSISTENCY',
  PARCEL_INVALID_GEOMETRIES: 'PARCEL_INVALID_GEOMETRIES',
  PARCELS_DELETED: 'PARCELS_DELETED',
  PARCELS_DUPLICATED: 'PARCELS_DUPLICATED',
  PARCEL_IDENTITY_ROTATION_GEOMETRY_CHANGED: 'PARCEL_IDENTITY_ROTATION_GEOMETRY_CHANGED',
} as const;

export interface IdentityRotationAffectedParcel {
  parcelId: string;
  blockNumber: string;
  /** @nullable */
  lpisBlockExtId?: string | null;
  /** @nullable */
  oldName?: string | null;
  /** @nullable */
  validFrom?: string | null;
  /** @nullable */
  validTo?: string | null;
  /** @nullable */
  areaHa?: number | null;
  /** @nullable */
  oldExtId?: string | null;
  /** @nullable */
  oldExtVersionId?: string | null;
  /** @nullable */
  newExtId?: string | null;
  /** @nullable */
  newExtVersionId?: string | null;
  /** @nullable */
  newName?: string | null;
  /** @nullable */
  newAreaHa?: number | null;
  /** @nullable */
  newValidFrom?: string | null;
  /** @nullable */
  newValidTo?: string | null;
  /** @nullable */
  pairIoU?: number | null;
  /** @nullable */
  actions?: ActionOverviewV2To[] | null;
  /** @nullable */
  seedApplicationsV2?: SeedApplicationV2To[] | null;
}

export interface FarmUpdateFlatResponse {
  farmUpdateId: string;
  source: FarmUpdateSource;
  state: FarmUpdateState;
  startedAt: string;
  /** @nullable */
  updatedAt?: string | null;
  /** @nullable */
  lastSuccessUpdateDate?: string | null;
  /** @nullable */
  errorMessage?: string | null;
  /** @nullable */
  code?: string | null;
  /** @nullable */
  shortCode?: string | null;
  /** @nullable */
  conflictingBlocks?: string[] | null;
  /** @nullable */
  ambiguousParcels?: string[] | null;
  /** @nullable */
  newAutomaticParcels?: FarmUpdateNewParcels[] | null;
  farmUpdateErrorFlatResponse: FarmUpdateErrorFlatResponse[];
  errorCodeType?: FarmUpdateGeometryErrorType | null;
  /** @nullable */
  identityRotationAffectedParcels?: IdentityRotationAffectedParcel[] | null;
  /** @nullable */
  validityDate?: string | null;
  updateMode?: EagriFullFarmUpdateMode | null;
  changeSummary?: FarmUpdateChangeSummary | null;
}

export interface FarmSettingsTo {
  eagriSettingsEnabled: boolean;
  shpSettingsEnabled: boolean;
}

export interface AekoUdajeType {
  aekokod: string;
  hodnotanum?: number;
  hodnotaint?: number;
  hodnotastr?: string;
  platnostod: string;
  platnostdo?: string;
}

export interface AplPasmoType {
  aplpaskod?: number;
  vymprekryv: number;
  platnostod: string;
  platnostdo?: string;
}

export interface AzzpType {
  kod?: number;
  souradnicex: string;
  souradnicey: string;
}

export interface BpejType {
  bpejkod: string;
  vymprekryv: number;
  platnostod: string;
  platnostdo?: string;
}

export interface ChybaType {
  kodchyby: string;
  popis: string;
}

export interface ChybyType {
  chyba: ChybaType[];
}

export interface UzivatelType {
  iduzivatele?: number;
  jmeno?: string;
  prijmeni?: string;
  obchodnijmeno?: string;
  ic?: string;
  pravniforma?: number;
}

export interface PlodinaType {
  pestovaniid?: number;
  kodplodiny?: number;
  meziplodina?: boolean;
  gps?: boolean;
  platnostod: string;
  platnostdo?: string;
}

export interface PlodinyRozsireneType {
  pestovaniid?: number;
  kodplodiny?: number;
  kodproduktu?: number;
  kodusp?: number;
  kodpot?: number;
  pot?: string;
  poznamka?: string;
  meziplodina?: boolean;
  platnostod: string;
  platnostdo?: string;
}

export interface HistorieType {
  parcelaid?: number;
  parcelavymy: number;
  prekryv: number;
  vlastnizakre?: boolean;
  platnostod: string;
  platnostdo?: string;
}

export interface OdpocPlochyType {
  kodop?: number;
  sirka?: number;
  vymera: number;
  platnostod: string;
  platnostdo?: string;
}

export interface ZakladniType {
  kod: string;
  hodnotanum?: number;
  hodnotaint?: number;
  hodnotastr?: string;
  platnostod: string;
  platnostdo?: string;
}

export interface OpatreniNsType {
  kodtyp: string;
  hodnota: string;
  platnostod: string;
  platnostdo?: string;
}

export type VyslednaErozeType = typeof VyslednaErozeType[keyof typeof VyslednaErozeType];


export const VyslednaErozeType = {
  SEO: 'SEO',
  MEO: 'MEO',
  NEO: 'NEO',
} as const;

export interface PtopatreniType {
  kod: string;
}

export interface Eroze2GType {
  vyslednaeroze: VyslednaErozeType;
  seocelkem: number;
  seomeocelkem: number;
  maxsouvseo: number;
  maxsouvseomeo: number;
  osevod: string;
  osevdo: string;
  ptopatreni?: PtopatreniType[];
}

export type VyslednaEroze24Type = typeof VyslednaEroze24Type[keyof typeof VyslednaEroze24Type];


export const VyslednaEroze24Type = {
  SEO: 'SEO',
  MEO_VR: 'MEO_VR',
  MEO_NR: 'MEO_NR',
  NEO: 'NEO',
} as const;

export interface Eroze3GType {
  vyslednaeroze: VyslednaEroze24Type;
  seocelkem: number;
  seomeovrcelkem: number;
  seomeovrmeonrcelkem: number;
  maxsouvseo: number;
  maxsouvseomeovr: number;
  maxsouvseomeovrmeonr: number;
  osevod: string;
  osevdo: string;
  ptopatreni?: PtopatreniType[];
}

export interface NeprodPlochyType {
  id?: number;
  typnp: string;
  zkodnp: string;
  ctverecnp: string;
  vymnp: number;
  platnostod: string;
  platnostdo?: string;
}

export interface ParcelaVerzeType {
  idparcelaverze?: number;
  geometrie?: string;
  multipolygon?: boolean;
  vymera: number;
  parcelaverzeod: string;
  parcelaverzedo?: string;
  zakladni?: ZakladniType[];
  opatrenins?: OpatreniNsType[];
  aplpasmo?: AplPasmoType[];
  eroze2G?: Eroze2GType[];
  eroze3G?: Eroze3GType[];
  neprodplochy?: NeprodPlochyType[];
}

export interface ZemParcelyType {
  idparcela?: number;
  nazev: string;
  poradi?: number;
  parcelaod: string;
  parcelado?: string;
  idparcelapredek?: number;
  plodina: PlodinaType[];
  plodinyrozsirene: PlodinyRozsireneType[];
  historie?: HistorieType[];
  odpocplochy?: OdpocPlochyType[];
  parcelaverze?: ParcelaVerzeType[];
}

export interface PrekryvKatuzeType {
  kunazev: string;
  kukod?: number;
  vymprekryv: number;
  dlecentroid?: number;
  platnostod: string;
  platnostdo?: string;
}

export interface SeznamEvpType {
  evpid?: number;
  ctverec: string;
  zkod: string;
  vymera: number;
  vymeraprekryv: number;
  geometrieevp: string;
  druhnazev: string;
  druhid?: number;
  platnostod: string;
  platnostdo?: string;
}

export interface UdajeNsType {
  kod: string;
  hodnotanum?: number;
  hodnotaint?: number;
  hodnotastr?: string;
  platnostod: string;
  platnostdo?: string;
}

export interface VynosHladinaType {
  vynoshladinakod?: number;
  vymprekryv: number;
  platnostod: string;
  platnostdo?: string;
}

export interface UdajeErozeType {
  kod: string;
  hodnotanum?: number;
  hodnotaint?: number;
  hodnotastr?: string;
  platnostod: string;
  platnostdo?: string;
}

export interface OpatreniErozeType {
  erozekateg?: number;
  vymprekryv: number;
  osevod: string;
  osevdo: string;
  cfaktorod?: string;
  cfaktordo?: string;
}

export type KodOpatreniType = typeof KodOpatreniType[keyof typeof KodOpatreniType];


export const KodOpatreniType = {
  P_1: 'P_1',
  P_2: 'P_2',
  P_3: 'P_3',
  Z_0: 'Z_0',
  Z_1: 'Z_1',
  Z_2: 'Z_2',
  Z_3: 'Z_3',
  S_0: 'S_0',
  S_1: 'S_1',
  S_2: 'S_2',
  S_3: 'S_3',
  V_0: 'V_0',
  V_1: 'V_1',
  V_2: 'V_2',
  V_3: 'V_3',
  V_4: 'V_4',
  K: 'K',
  R: 'R',
  LOS: 'LOS',
  ST: 'ST',
  PK: 'PK',
} as const;

export interface OpatreniMeoType {
  kodopatreni: KodOpatreniType;
  osevod: string;
  osevdo: string;
}

export interface LfaType {
  lfakod: string;
  vymprekryv: number;
  vymprekryv4DM?: number;
  platnostod: string;
  platnostdo?: string;
}

export interface OpvType {
  kodzakres: string;
  geometrie: string;
}

export interface OpvzType {
  kategorieopvz?: number;
  vymprekryv: number;
  nazev?: string;
  typ?: string;
  overeno?: boolean;
  urlrozhodnuti?: string;
  platnostod: string;
  platnostdo?: string;
}

export interface EfasType {
  efaskod: string;
  vymefas: number;
  vymefasprep: number;
  platnostod: string;
  platnostdo?: string;
}

export interface MzpType {
  mzpkod: string;
  vymprekryv: number;
  vymprekryv4DM?: number;
  platnostod: string;
  platnostdo?: string;
}

export interface EnviroType {
  kodlouky: string;
  terminsec?: string;
  zpusobpastvy?: string;
  vymprekryv: number;
  kvalita: string;
  platnostod: string;
  platnostdo?: string;
}

export interface GmoType {
  plodinaid?: number;
  plodinanazev: string;
  vymera: number;
}

export type TypEroznihoPozemkuType = typeof TypEroznihoPozemkuType[keyof typeof TypEroznihoPozemkuType];


export const TypEroznihoPozemkuType = {
  EEP: 'EEP',
  VEP: 'VEP',
} as const;

export interface GeoinfoType {
  kod: string;
  hodnota: number;
  platnostod: string;
  platnostdo?: string;
}

export interface PrisluzdpbType {
  fbid?: number;
  ctverec: string;
  zkod: string;
  vymeradpb: number;
  platnostod: string;
  platnostdo?: string;
}

export interface EroznipozemekType {
  id?: number;
  typ: TypEroznihoPozemkuType;
  datumvytvoreni: string;
  vytvorilkdo: string;
  poznamka?: string;
  geoinfo?: GeoinfoType[];
  prislusdpb?: PrisluzdpbType;
  vyslednaeroze?: VyslednaErozeType;
  seocelkem?: number;
  seomeocelkem?: number;
  maxsouvseo?: number;
  maxsouvseomeo?: number;
  osevod?: string;
  osevdo?: string;
  ptopatreni?: PtopatreniType[];
}

export interface HonitbaType {
  kod: string;
  nazev: string;
  vymprekryv: number;
  prislusnostorp: string;
  platnostod: string;
  platnostdo?: string;
}

export interface UpobType {
  vymprekryv: number;
  platnostod: string;
  platnostdo?: string;
}

export interface PrehlidkaType {
  poradi: number;
  datprovedeni: string;
  vysledek: string;
  stav: number;
}

export interface MnozPorostyType {
  rok: number;
  ciszadosti?: number;
  datpodani: string;
  zadatel: string;
  zadatelico: string;
  druhkod?: number;
  druhnazev: string;
  odrudakod?: number;
  odrudanazev: string;
  kategorie: string;
  generace: string;
  vymerazadost: number;
  hodnoceni?: string;
  kvalitavazby: string;
  zrusenazadost: string;
  cisrozhodnuti?: string;
  prehlidka?: PrehlidkaType[];
}

export interface SeznamOtpType {
  obnovatpid?: number;
  datumzahajeniotp: string;
  datumsouvislyotp?: string;
  stav: number;
}

export interface DpbType {
  chyba?: string;
  chyby?: ChybyType;
  iddpb?: number;
  ctverec: string;
  zkod: string;
  stav: string;
  stavid?: number;
  ucinnostdlezakona?: string;
  platnostod: string;
  platnostdo?: string;
  vymera: number;
  vymeraopv: number;
  kultura: string;
  kulturaid?: number;
  kulturanazev: string;
  kulturaod?: string;
  geometriedpb?: string;
  uzivatel: UzivatelType;
  zemparcely?: ZemParcelyType[];
  zakladni?: ZakladniType[];
  prekryvkatuze?: PrekryvKatuzeType[];
  seznamevp?: SeznamEvpType[];
  udajens?: UdajeNsType[];
  opatrenins?: OpatreniNsType[];
  aplpasmo?: AplPasmoType[];
  vynoshladina?: VynosHladinaType[];
  udajeeroze?: UdajeErozeType[];
  opatrenieroze?: OpatreniErozeType[];
  opatrenimeo?: OpatreniMeoType[];
  lfa?: LfaType[];
  opv?: OpvType[];
  opvz?: OpvzType[];
  bpej?: BpejType[];
  efas?: EfasType[];
  mzp?: MzpType[];
  enviro?: EnviroType[];
  aekoudaje?: AekoUdajeType[];
  gmo?: GmoType[];
  azzp?: AzzpType[];
  eroze2G?: Eroze2GType[];
  eroze3G?: Eroze3GType[];
  eroznipozemek?: EroznipozemekType[];
  honitba?: HonitbaType[];
  upob?: UpobType[];
  mnozitelskeporosty?: MnozPorostyType[];
  neprodplochy?: NeprodPlochyType[];
  seznamotp?: SeznamOtpType[];
}

export interface EagriDpbPair {
  subsidyDpb: DpbType;
  detail?: DpbType | null;
}

export type FarmUpdateChangeType = typeof FarmUpdateChangeType[keyof typeof FarmUpdateChangeType];


export const FarmUpdateChangeType = {
  NEW_PARCEL: 'NEW_PARCEL',
  NEW_BLOCK: 'NEW_BLOCK',
  REPLACED_PARCEL: 'REPLACED_PARCEL',
  REPLACED_BLOCK: 'REPLACED_BLOCK',
  RETIRED_BLOCK: 'RETIRED_BLOCK',
} as const;

export interface FarmUpdateChange {
  changeDate: string;
  type: FarmUpdateChangeType;
  blockNumber: string;
}

export type FarmUpdateChangeRequestStatus = typeof FarmUpdateChangeRequestStatus[keyof typeof FarmUpdateChangeRequestStatus];


export const FarmUpdateChangeRequestStatus = {
  IN_PROGRESS: 'IN_PROGRESS',
  AVAILABLE: 'AVAILABLE',
} as const;

export interface FarmUpdateChangesResponse {
  status: FarmUpdateChangeRequestStatus;
  validityDate: string;
  /** @nullable */
  changes?: FarmUpdateChange[] | null;
}

export type FacilitySortColumn = typeof FacilitySortColumn[keyof typeof FacilitySortColumn];


export const FacilitySortColumn = {
  NAME: 'NAME',
  TYPE: 'TYPE',
  UNIT: 'UNIT',
} as const;

export interface CountryTo {
  code: string;
  name: string;
  fullSupport: boolean;
}

export type GrowingPeriod = typeof GrowingPeriod[keyof typeof GrowingPeriod];


export const GrowingPeriod = {
  SPRING: 'SPRING',
  WINTER: 'WINTER',
} as const;

export interface CropSeedSuggestionTo {
  id: string;
  catalogue: CatalogueTo;
  isHidden: boolean;
  isFavorite: boolean;
  name: string;
  cropId: string;
  /** @nullable */
  cropExternalId?: number | null;
  /** @nullable */
  varietyName?: string | null;
}

export interface PrimaryCatalogueTo {
  type: CatalogueType;
  canImport: boolean;
}

export interface PlantProtectionDetailRegistrationTo {
  id: string;
  /** @nullable */
  registrationNumber?: string | null;
  /** @nullable */
  registrationHolder?: string | null;
  /** @nullable */
  evidenceNumber?: string | null;
  /** @nullable */
  externalId?: string | null;
  isValid: boolean;
  isLegallyValid: boolean;
  /** @nullable */
  usableUntil?: string | null;
  /** @nullable */
  legalStart?: string | null;
  /** @nullable */
  legalEnd?: string | null;
  /** @nullable */
  marketEnd?: string | null;
  /** @nullable */
  useEnd?: string | null;
  applicationsCount: number;
  isCurrent: boolean;
}

export interface PlantProtectionDetailApplicationRowTo {
  id: string;
  /** @nullable */
  cropName?: string | null;
  /** @nullable */
  organismName?: string | null;
  /** @nullable */
  minDose?: number | null;
  /** @nullable */
  maxDose?: number | null;
  /** @nullable */
  unit?: string | null;
  /** @nullable */
  minBbch?: number | null;
  /** @nullable */
  maxBbch?: number | null;
  /** @nullable */
  allowedApplications?: number | null;
  /** @nullable */
  legalEnd?: string | null;
}

export interface PlantProtectionEagriAttachmentTo {
  /** @nullable */
  name?: string | null;
  /** @nullable */
  url?: string | null;
}

export interface PlantProtectionEagriNoteTo {
  /** @nullable */
  labelCode?: string | null;
  /** @nullable */
  labelMeaning?: string | null;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  catalogueDomain?: string | null;
  /** @nullable */
  noteText?: string | null;
  attachments: PlantProtectionEagriAttachmentTo[];
}

export interface PlantProtectionDetailRegistrationApplicationTo {
  id: string;
  registrationId: string;
  /** @nullable */
  registrationExternalId?: string | null;
  /** @nullable */
  registrationHolder?: string | null;
  /** @nullable */
  registrationNumber?: string | null;
  /** @nullable */
  evidenceNumber?: string | null;
  /** @nullable */
  validUntil?: string | null;
  /** @nullable */
  maxDose?: number | null;
  /** @nullable */
  minDose?: number | null;
  /** @nullable */
  unit?: string | null;
  /** @nullable */
  maxDoseWater?: number | null;
  /** @nullable */
  minDoseWater?: number | null;
  /** @nullable */
  unitWater?: string | null;
  /** @nullable */
  minBbch?: number | null;
  /** @nullable */
  maxBbch?: number | null;
  /** @nullable */
  allowedApplications?: number | null;
  /** @nullable */
  minInterval?: number | null;
  /** @nullable */
  maxInterval?: number | null;
  /** @nullable */
  protectionPeriod?: number | null;
  /** @nullable */
  protectionPeriodIsApplicationTerm?: boolean | null;
  /** @nullable */
  isAerialApplication?: boolean | null;
  /** @nullable */
  isSeedTreatment?: boolean | null;
  crop?: CropTo | null;
  cropGroup?: CropGroupTo | null;
  organism?: OrganismTo | null;
  /** @nullable */
  doseComment?: string | null;
  /** @nullable */
  doseText?: string | null;
  buffers: PlantProtectionRegistrationApplicationBufferTo[];
  /** @nullable */
  notes?: string | null;
  /** @nullable */
  eagriNote?: string | null;
  eagriNotes: PlantProtectionEagriNoteTo[];
  /** @nullable */
  legalStart?: string | null;
  /** @nullable */
  legalEnd?: string | null;
  /** @nullable */
  marketEnd?: string | null;
  /** @nullable */
  useEnd?: string | null;
  dosages: DosageTo[];
  slopeConditions: SlopeConditionTo[];
  tankMixPartners: TankMixPartnerTo[];
}

export interface ApplicationBasicSectionTo {
  /** @nullable */
  cropName?: string | null;
  /** @nullable */
  organismName?: string | null;
  /** @nullable */
  decisionId?: string | null;
  /** @nullable */
  registrationHolder?: string | null;
  /** @nullable */
  registrationNumber?: string | null;
  /** @nullable */
  usableUntil?: string | null;
  /** @nullable */
  legalEnd?: string | null;
  notes: PlantProtectionEagriNoteTo[];
}

export type ApplicationBufferVariant = typeof ApplicationBufferVariant[keyof typeof ApplicationBufferVariant];


export const ApplicationBufferVariant = {
  BASIC: 'BASIC',
  PREEMERGENT: 'PREEMERGENT',
  POSTEMERGENT: 'POSTEMERGENT',
  SPRING: 'SPRING',
  AUTUMN: 'AUTUMN',
} as const;

export interface ApplicationUsageTo {
  /** @nullable */
  minDose?: number | null;
  /** @nullable */
  maxDose?: number | null;
  /** @nullable */
  unit?: string | null;
  /** @nullable */
  minDoseWater?: number | null;
  /** @nullable */
  maxDoseWater?: number | null;
  /** @nullable */
  unitWater?: string | null;
  /** @nullable */
  minBbch?: number | null;
  /** @nullable */
  maxBbch?: number | null;
  /** @nullable */
  allowedApplications?: number | null;
  /** @nullable */
  minInterval?: number | null;
  /** @nullable */
  maxInterval?: number | null;
  /** @nullable */
  protectionPeriod?: number | null;
  /** @nullable */
  protectionPeriodIsApplicationTerm?: boolean | null;
  /** @nullable */
  isAerialApplication?: boolean | null;
  /** @nullable */
  isSeedTreatment?: boolean | null;
}

export interface ApplicationDosageSectionTo {
  dosages: DosageTo[];
  usage: ApplicationUsageTo;
  /** @nullable */
  doseText?: string | null;
  /** @nullable */
  doseComment?: string | null;
  /** @nullable */
  eagriNote?: string | null;
  tankMixPartners: TankMixPartnerTo[];
}

export interface DriftBufferRowTo {
  /** @nullable */
  driftReduction?: number | null;
  isAllowed: boolean;
  /** @nullable */
  buffer?: number | null;
  /** @nullable */
  protectionLevel?: number | null;
  /** @nullable */
  labelCode?: string | null;
  /** @nullable */
  description?: string | null;
  populationCategory?: PopulationCategory | null;
  /** @nullable */
  cropVariant?: string | null;
}

export interface DriftBufferVariantTo {
  variant: ApplicationBufferVariant;
  rows: DriftBufferRowTo[];
}

export interface ApplicationFieldBoundarySectionTo {
  drift: DriftBufferVariantTo[];
  notes: PlantProtectionEagriNoteTo[];
}

export interface ApplicationPopulationSectionTo {
  driftBuffers: DriftBufferRowTo[];
  notes: PlantProtectionEagriNoteTo[];
  attachments: PlantProtectionEagriAttachmentTo[];
}

export type WaterProtectionZoneType = typeof WaterProtectionZoneType[keyof typeof WaterProtectionZoneType];


export const WaterProtectionZoneType = {
  SURFACE: 'SURFACE',
  GROUND: 'GROUND',
} as const;

export interface WaterProtectionZoneVariantTo {
  zone: WaterProtectionZoneType;
  variant: ApplicationBufferVariant;
  rows: DriftBufferRowTo[];
}

export interface ApplicationWaterSectionTo {
  drift: DriftBufferVariantTo[];
  waterProtectionZones: WaterProtectionZoneVariantTo[];
  slopeConditions: SlopeConditionTo[];
  notes: PlantProtectionEagriNoteTo[];
}

export interface PlantProtectionApplicationSectionsTo {
  id: string;
  basic: ApplicationBasicSectionTo;
  dosage: ApplicationDosageSectionTo;
  population: ApplicationPopulationSectionTo;
  water: ApplicationWaterSectionTo;
  fieldBoundary: ApplicationFieldBoundarySectionTo;
}

export interface PlantProtectionApplicationTo {
  id: string;
  /** @nullable */
  validUntil?: string | null;
  /** @nullable */
  maxDose?: number | null;
  /** @nullable */
  minDose?: number | null;
  /** @nullable */
  unit?: string | null;
  /** @nullable */
  maxDoseWater?: number | null;
  /** @nullable */
  minDoseWater?: number | null;
  /** @nullable */
  unitWater?: string | null;
  /** @nullable */
  minBbch?: number | null;
  /** @nullable */
  maxBbch?: number | null;
  /** @nullable */
  allowedApplications?: number | null;
  /** @nullable */
  minInterval?: number | null;
  /** @nullable */
  maxInterval?: number | null;
  /** @nullable */
  protectionPeriod?: number | null;
  /** @nullable */
  protectionPeriodIsApplicationTerm?: boolean | null;
  crop?: CropTo | null;
  cropGroup?: CropGroupTo | null;
  organism?: OrganismTo | null;
  buffers: PlantProtectionRegistrationApplicationBufferTo[];
  dosages: DosageTo[];
  slopeConditions: SlopeConditionTo[];
  tankMixPartners: TankMixPartnerTo[];
}

export interface PlantProtectionSuggestionTo {
  id: string;
  name: string;
  catalogue: CatalogueTo;
  /** @nullable */
  validUntil?: string | null;
  isFavorite: boolean;
  /** @nullable */
  defaultUnit?: string | null;
}

export interface PlantProtectionOverviewTo {
  id: string;
  name: string;
  /** @nullable */
  externalId?: string | null;
  catalogue: CatalogueTo;
  /** @nullable */
  validUntil?: string | null;
  /** @nullable */
  activeSubstances?: string[] | null;
  /** @nullable */
  organisms?: string[] | null;
  /** @nullable */
  crops?: string[] | null;
  isFavorite: boolean;
}

export interface SyncReportSummaryResponse {
  id: string;
  startedAt: string;
  /** @nullable */
  finishedAt?: string | null;
  /** @nullable */
  durationMs?: string | null;
  status: string;
  /** @nullable */
  eagriDataDate?: string | null;
  warningCount: number;
  /** @nullable */
  totalProducts?: number | null;
  /** @nullable */
  errorMessage?: string | null;
}

export interface SyncStatsResponse {
  totalProducts: number;
  totalRegistrations: number;
  validRegistrations: number;
  invalidRegistrations: number;
  totalApplications: number;
  totalBuffers: number;
  buffersWater: number;
  buffersBoundary: number;
  buffersPopulation: number;
  buffersSlope: number;
  buffersSurfaceWater: number;
  buffersGroundWater: number;
  buffersLandscape: number;
  buffersOther: number;
  totalLabels: number;
  totalActiveSubstances: number;
  totalAttachments: number;
  totalReferencedRegistrations: number;
  plodinyTextFallbackUsed: number;
  pdfFallbackAttempted: number;
  pdfFallbackParsed: number;
  pdfAttachmentsDownloaded: number;
  pdfAttachmentsFailed: number;
  totalDosages: number;
  multiDoseApplications: number;
  dosagesWithSeason: number;
  dosagesWithMode: number;
  dosagesWithEmergence: number;
  dosagesWithConditionText: number;
  dosagesWithWater: number;
  pdfSourcedDosages: number;
  bufferNoteLookupHits: number;
  bufferNoteLookupRegexAuto: number;
  bufferNoteLookupPending: number;
  doseTextLookupHits: number;
  doseTextLookupRegexAuto: number;
  doseTextLookupPending: number;
  slopeConditions: number;
  appsWithTmPartners: number;
  appsWithPseudoUnit: number;
  appsWithMultiApplication: number;
  unitCanonicalizedHits: number;
  unitAugmentedHits: number;
}

export interface SyncReportDetailResponse {
  id: string;
  startedAt: string;
  /** @nullable */
  finishedAt?: string | null;
  /** @nullable */
  durationMs?: string | null;
  status: string;
  /** @nullable */
  eagriDataDate?: string | null;
  warningCount: number;
  /** @nullable */
  errorMessage?: string | null;
  stats?: SyncStatsResponse | null;
}

export type SyncWarningType = typeof SyncWarningType[keyof typeof SyncWarningType];


export const SyncWarningType = {
  MISSING_STRUCTURED_CROP_IN_BUFFER: 'MISSING_STRUCTURED_CROP_IN_BUFFER',
  PLODINY_TEXT_FALLBACK_FAILED: 'PLODINY_TEXT_FALLBACK_FAILED',
  UNKNOWN_BUFFER_UDAJE_TYPE: 'UNKNOWN_BUFFER_UDAJE_TYPE',
  UNKNOWN_PROTECTION_LEVEL: 'UNKNOWN_PROTECTION_LEVEL',
  UNPARSABLE_WATER_ZONE_RESTRICTION: 'UNPARSABLE_WATER_ZONE_RESTRICTION',
  UNPARSABLE_DOSE: 'UNPARSABLE_DOSE',
  UNPARSABLE_BBCH: 'UNPARSABLE_BBCH',
  UNMAPPED_CROP: 'UNMAPPED_CROP',
  UNMAPPED_CROP_GROUP: 'UNMAPPED_CROP_GROUP',
  UNMAPPED_ORGANISM: 'UNMAPPED_ORGANISM',
  UNCATEGORIZED_POPULATION_BUFFER: 'UNCATEGORIZED_POPULATION_BUFFER',
  ATTACHMENT_DOWNLOAD_FAILED: 'ATTACHMENT_DOWNLOAD_FAILED',
  PDF_FALLBACK_NO_ATTACHMENTS: 'PDF_FALLBACK_NO_ATTACHMENTS',
  PDF_FALLBACK_PARSE_EMPTY: 'PDF_FALLBACK_PARSE_EMPTY',
  UNPARSABLE_DOSE_CONDITION: 'UNPARSABLE_DOSE_CONDITION',
  EMPTY_BBCH_INTERSECTION: 'EMPTY_BBCH_INTERSECTION',
  UNPARSABLE_WATER_VOLUME: 'UNPARSABLE_WATER_VOLUME',
  BUFFER_NOTE_UNRESOLVED: 'BUFFER_NOTE_UNRESOLVED',
  BUFFER_NOTE_CROP_UNMAPPED: 'BUFFER_NOTE_CROP_UNMAPPED',
  BUFFER_NOTE_UNSUPPORTED_CONDITION: 'BUFFER_NOTE_UNSUPPORTED_CONDITION',
  DOSE_TEXT_UNRESOLVED: 'DOSE_TEXT_UNRESOLVED',
  UNIT_DICTIONARY_MISS: 'UNIT_DICTIONARY_MISS',
  PDF_TEXT_EXTRACTION_FAILED: 'PDF_TEXT_EXTRACTION_FAILED',
  PDF_DOSAGE_UNRESOLVED: 'PDF_DOSAGE_UNRESOLVED',
  BARE_UNIT_AUGMENTATION_MISSED: 'BARE_UNIT_AUGMENTATION_MISSED',
} as const;

export interface SyncWarningResponse {
  id: string;
  warningType: string;
  message: string;
  /** @nullable */
  bufferType?: string | null;
  /** @nullable */
  rawValue?: string | null;
  /** @nullable */
  eagriId?: string | null;
  /** @nullable */
  matched?: boolean | null;
  productCount: number;
}

export interface ProductSyncStatsResponse {
  productExternalId: string;
  productName: string;
  registrations: number;
  validRegistrations: number;
  applications: number;
  buffers: number;
  buffersWater: number;
  buffersBoundary: number;
  buffersPopulation: number;
  buffersSlope: number;
  buffersSurfaceWater: number;
  buffersGroundWater: number;
  buffersLandscape: number;
  buffersOther: number;
  labels: number;
  activeSubstances: number;
  attachments: number;
  warningCount: number;
  plodinyTextFallbackUsed: number;
  pdfFallbackFailed: number;
  totalDosages: number;
  multiDoseApplications: number;
  dosagesWithSeason: number;
  dosagesWithMode: number;
  dosagesWithEmergence: number;
  dosagesWithConditionText: number;
  dosagesWithWater: number;
  pdfSourcedDosages: number;
  slopeConditions: number;
  appsWithTmPartners: number;
  appsWithPseudoUnit: number;
  appsWithMultiApplication: number;
  unitCanonicalizedHits: number;
  unitAugmentedHits: number;
}

export interface EagriFertilizerPropertiesTo {
  nitrogenCategory: EagriFertilizerNitrogenCategoryTo;
  isValid: boolean;
  /** @nullable */
  validFrom?: string | null;
  /** @nullable */
  validTo?: string | null;
  /** @nullable */
  evidenceNumber?: string | null;
}

export interface FertilizerTo {
  id: string;
  name: string;
  catalogue: CatalogueTo;
  isHidden: boolean;
  isFavorite: boolean;
  /** @nullable */
  producerTradeName?: string | null;
  isOrganic: boolean;
  n: number;
  p2o5: number;
  k2o: number;
  mgo: number;
  cao: number;
  s: number;
  eagriProperties?: EagriFertilizerPropertiesTo | null;
}

export interface FertilizerMineralIntakeResponse {
  nitrogenIntake: number;
  p2o5Intake: number;
  k2oIntake: number;
  accountableNitrogenIntake: number;
}

export interface FertilizerSuggestionTo {
  id: string;
  name: string;
  catalogue: CatalogueTo;
  isHidden: boolean;
  isFavorite: boolean;
  /** @nullable */
  producerTradeName?: string | null;
  preferredUnitType: UnitType;
  /** @nullable */
  validTo?: string | null;
  hasPhosphorus: boolean;
  hasPotassium: boolean;
  hasNitrogen: boolean;
}

export type EnumEntriesEagriFertilizerNitrogenCategory = EagriFertilizerNitrogenCategory[];

export interface CropProductUseTypeTo {
  productId: string;
  /** @nullable */
  productName?: string | null;
  /** @nullable */
  isMainProduct?: boolean | null;
  /** @nullable */
  cropUseTypeId?: string | null;
  /** @nullable */
  cropUseTypeName?: string | null;
  /** @nullable */
  dryMatter?: number | null;
  nutrientConsumption: NutrientConsumptionTo[];
  /** @nullable */
  secondaryProductRatio?: number | null;
}

export interface CropDetailTo {
  id: string;
  name: string;
  /** @nullable */
  externalId?: string | null;
  catalogueType: CatalogueType;
  group?: CropGroupTo | null;
  /** @nullable */
  validFrom?: string | null;
  /** @nullable */
  validTo?: string | null;
  color: ColorTo;
  textColor: ColorTo;
  isNoCrop: boolean;
  products: CropProductUseTypeTo[];
  /** @nullable */
  isWinterCrop?: boolean | null;
  /** @nullable */
  isSpringCrop?: boolean | null;
  lifespan?: CropLifespan | null;
  varieties: string[];
  mainProducts: string[];
  secondaryProducts: string[];
  cropUseTypes: string[];
}

export interface DetectorStatus {
  /** @nullable */
  vuvRevisionDate?: string | null;
  /** @nullable */
  vuvContentFetchedAt?: string | null;
  /** @nullable */
  lastNotifiedRevisionDate?: string | null;
  /** @nullable */
  lastNotifiedAt?: string | null;
}

export interface LayerStatus {
  /** @nullable */
  dbRevisionDate?: string | null;
  dbFeatureCount: number;
  /** @nullable */
  vuvFeatureCount?: number | null;
  /** @nullable */
  featureDelta?: number | null;
}

export interface OpvnStatus {
  /** @nullable */
  vuvFeatureCount?: number | null;
}

export interface WaterProtectionZonesStatusTo {
  surface: LayerStatus;
  ground: LayerStatus;
  opvn: OpvnStatus;
  detector: DetectorStatus;
}

export interface StatisticsTo {
  /** @nullable */
  lastEphActivity?: string | null;
  /** @nullable */
  lastLpisUpdate?: string | null;
}

/**
 * Information about a successful sync
 */
export interface SyncInfoTo {
  /** When the sync was completed */
  finishedAt: string;
  /** Total number of landscape elements fetched from source */
  totalFetched: number;
  /** Type of sync */
  syncType: string;
}

/**
 * Status of the sync
 */
export type SyncAttemptToStatus = typeof SyncAttemptToStatus[keyof typeof SyncAttemptToStatus];


export const SyncAttemptToStatus = {
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
} as const;

/**
 * Information about a sync attempt
 */
export interface SyncAttemptTo {
  /** When the sync was started */
  startedAt: string;
  /**
     * When the sync finished (null if still in progress)
     * @nullable
     */
  finishedAt?: string | null;
  /** Status of the sync */
  status: SyncAttemptToStatus;
  /** Total number of landscape elements fetched (0 if failed or in progress) */
  totalFetched: number;
  /**
     * Error message if the sync failed
     * @nullable
     */
  errorMessage?: string | null;
  /** Type of sync */
  syncType: string;
}

/**
 * Status of Landscape Element synchronization
 */
export interface LandscapeSyncStatusTo {
  lastSuccessful?: SyncInfoTo | null;
  lastAttempt?: SyncAttemptTo | null;
}

export type FarmDeletionBlockerDetails = {[key: string]: { [key: string]: unknown }};

export interface FarmDeletionBlocker {
  service: string;
  code: string;
  reason: string;
  details: FarmDeletionBlockerDetails;
}

export interface EagriServiceSyncStatusTo {
  service: string;
  lastRun: string;
  lastData: string;
  lastSuccess: string;
}

/**
 * Always empty - a non-field action has no parcels
 */
export interface ActionParcelDetailTo {
  id: string;
  parcel: ParcelToV2;
  restrictions: SubtractionResponse[];
  actionArea: number;
  restrictedArea: number;
}

export interface ActionDetailTo {
  id: string;
  /** Time of the action in ISO-8601 format */
  time?: string;
  source: ActionSource;
  date: string;
  parcels: ActionParcelDetailTo[];
  actionType: ActionType;
  note?: string;
  isDraft: boolean;
  isEagriFromCoreParcels: boolean;
}

export type FertilizerTarget = typeof FertilizerTarget[keyof typeof FertilizerTarget];


export const FertilizerTarget = {
  CATCH_CROP: 'CATCH_CROP',
  MAIN_CROP: 'MAIN_CROP',
  STRAW: 'STRAW',
} as const;

export interface AverageFertilizationTo {
  nitrogen: number;
  p2o5: number;
  k2o: number;
  mgo: number;
  cao: number;
  sulfur: number;
}

export interface ActionExpenseFertilizerDetailTo {
  fertilization: AverageFertilizationTo;
  materialId: string;
  material: FertilizerTo;
  actionMaterial: EPHMat;
  actionExpense: ActionExpenseTo;
}

export interface ActionExpensePlantProtectionDetailTo {
  targetOrganisms: OrganismTo[];
  parcelPlantProtectionEffectiveness: ParcelPlantProtectionEffectivenessTo[];
  material: InternalFertilizerTo | InternalMaterialToBase;
  materialId: string;
  actionMaterial: EPHMat;
  actionExpense: ActionExpenseTo;
}

export type ActionEPHDetailTo = ActionDetailTo & ({
  targetCrop?: CropTo | null;
  /** @nullable */
  isStrawDecay?: boolean | null;
  fertilizationTarget?: FertilizerTarget | null;
  fertilizers: ActionExpenseFertilizerDetailTo[];
  plantProtections: ActionExpensePlantProtectionDetailTo[];
  /**
     * Time of the action in ISO-8601 format
     * @nullable
     */
  time?: string | null;
  /** @nullable */
  note?: string | null;
});

export interface ActionExpenseSeedDetailTo {
  material: CropSeedTo;
  materialId: string;
  actionMaterial: SeedMat;
  actionExpense?: ActionExpenseTo | null;
}

export interface NonFieldPlantProtectionDetailTo {
  id: string;
  material: InternalFertilizerTo | InternalMaterialToBase;
  amount: number;
  unit: string;
  dosePerUnit: number;
  effectiveness: PlantProtectionEffectiveness;
  /** @nullable */
  notes?: string | null;
  targetOrganisms: OrganismTo[];
}

/**
 * Detail of a non-field plant protection action
 */
export type ActionNonFieldDetailTo = ActionDetailTo & ({
  facility: FacilityTo;
  applicationExtent: number;
  targetCrop?: CropTo | null;
  plantProtections: NonFieldPlantProtectionDetailTo[];
  /** Always empty - a non-field action has no parcels */
  parcels: ActionParcelDetailTo[];
  /**
     * Time of the action in ISO-8601 format
     * @nullable
     */
  time?: string | null;
  /** @nullable */
  note?: string | null;
});

export type ActionOtherDetailTo = ActionDetailTo & ({
  /**
     * Time of the action in ISO-8601 format
     * @nullable
     */
  time?: string | null;
  /** @nullable */
  note?: string | null;
});

/**
 * Yield of the whole action, summed over its parcels.
 */
export interface RevenueTo {
  actionId: string;
  amount: number;
  amountPerHa: number;
  isMainProduct: boolean;
  cropProduct?: CropProductTo | null;
  unit: YieldUnit;
}

/**
 * Yield per parcel of the action (DEV-2766). A legacy yield of the whole action is spread over the parcels by area.
 */
export interface ParcelRevenueTo {
  parcelId: string;
  amount: number;
  amountPerHa: number;
  isMainProduct: boolean;
  cropProduct?: CropProductTo | null;
  unit: YieldUnit;
}

export type ActionRevenueDetailTo = ActionDetailTo & ({
  /** Yield of the whole action, summed over its parcels. */
  revenues: RevenueTo[];
  /** Yield per parcel of the action (DEV-2766). A legacy yield of the whole action is spread over the parcels by area. */
  parcelRevenues: ParcelRevenueTo[];
  /**
     * Time of the action in ISO-8601 format
     * @nullable
     */
  time?: string | null;
  /** @nullable */
  note?: string | null;
});

export type ActionSowingDetailTo = ActionDetailTo & ({
  seedExpense?: ActionExpenseSeedDetailTo | null;
  seedApplicationType: SeedApplicationType;
  cropUse?: CropUseTypeTo | null;
  cropProduct?: CropProductTo | null;
  /**
     * Time of the action in ISO-8601 format
     * @nullable
     */
  time?: string | null;
  /** @nullable */
  note?: string | null;
});

export interface FlatActionPlantProtectionV2To {
  actionId: string;
  date: string;
  materialId: string;
  materialName: string;
  dose: number;
  unit: string;
}

export interface FlatActionPlantProtectionByMaterialV2To {
  plantProtectionId: string;
  actions: FlatActionPlantProtectionV2To[];
}

export interface TargetSeedApplicationDetailV2To {
  parcelId: string;
  seedApplicationV2: SeedApplicationV2GroupToV2 | SeedApplicationV2To;
  accountableNitrogen: number;
  actionsByPlantProtection: FlatActionPlantProtectionByMaterialV2To[];
}

export interface TargetSeedApplicationV2ResponseTo {
  seedApplications: TargetSeedApplicationDetailV2To[];
}

export type ActionV2SortColumn = typeof ActionV2SortColumn[keyof typeof ActionV2SortColumn];


export const ActionV2SortColumn = {
  DATE: 'DATE',
  ACTION_TYPE: 'ACTION_TYPE',
} as const;

export interface CropGrowthStageTo {
  code: string;
  name: string;
}

export type ActionTypeGroupTo = typeof ActionTypeGroupTo[keyof typeof ActionTypeGroupTo];


export const ActionTypeGroupTo = {
  OTHER: 'OTHER',
} as const;

export interface CropVarietyRef {
  seedId: string;
  varietyName: string;
}

export interface CropHasVarietiesDetails {
  cropId: string;
  varieties: CropVarietyRef[];
}

export interface CropHasVarietiesResponse {
  status: number;
  error: string;
  message: string;
  timestamp: string;
  details: CropHasVarietiesDetails;
}

export interface CropUseNotEmptyDetails {
  cropId: string;
  cropUseTypeId: string;
  productIds: string[];
}

export interface CropUseNotEmptyResponse {
  status: number;
  error: string;
  message: string;
  timestamp: string;
  details: CropUseNotEmptyDetails;
}

export type CropProductUsageActivityType = typeof CropProductUsageActivityType[keyof typeof CropProductUsageActivityType];


export const CropProductUsageActivityType = {
  SEED_APPLICATION_V2: 'SEED_APPLICATION_V2',
  ACTION_REVENUE: 'ACTION_REVENUE',
} as const;

export interface CropProductUsageActivity {
  service: string;
  id: string;
  type: CropProductUsageActivityType;
  /** @nullable */
  date?: string | null;
  /** @nullable */
  parcelId?: string | null;
}

export interface CropProductInUseDetails {
  usedIn: string[];
  activities: CropProductUsageActivity[];
}

export interface CropProductInUseResponse {
  status: number;
  error: string;
  message: string;
  timestamp: string;
  details: CropProductInUseDetails;
}

export interface FarmDeletionConflictsBody {
  blockers: FarmDeletionBlocker[];
}

export interface FarmDeletionConflictResponse {
  status: number;
  error: string;
  message: string;
  path: string;
  trace: string;
  detailedMessage: FarmDeletionConflictsBody;
}

/**
 * Available farm settings keys for admin configuration
 */
export type FarmSettingsKey = typeof FarmSettingsKey[keyof typeof FarmSettingsKey];


export const FarmSettingsKey = {
  EAGRI_SETTINGS_ENABLED: 'EAGRI_SETTINGS_ENABLED',
  SHP_SETTINGS_ENABLED: 'SHP_SETTINGS_ENABLED',
} as const;

type UpdateCentersParamsTSMorphBase = {
farmIds: string;
}

export type UpdateCentersParams = Omit<UpdateCentersParamsTSMorphBase, "farmIds">;;

type UpdateSeedApplicationV2ParamsTSMorphBase = {
farmIds: string;
}

export type UpdateSeedApplicationV2Params = Omit<UpdateSeedApplicationV2ParamsTSMorphBase, "farmIds">;;

type DeleteSeedApplicationV2ParamsTSMorphBase = {
farmIds: string;
}

export type DeleteSeedApplicationV2Params = Omit<DeleteSeedApplicationV2ParamsTSMorphBase, "farmIds">;;

type UpdateSeedApplicationV2GroupParamsTSMorphBase = {
farmIds: string;
}

export type UpdateSeedApplicationV2GroupParams = Omit<UpdateSeedApplicationV2GroupParamsTSMorphBase, "farmIds">;;

type DisbandGroupParamsTSMorphBase = {
farmIds: string;
}

export type DisbandGroupParams = Omit<DisbandGroupParamsTSMorphBase, "farmIds">;;

type UpdateFarmFromShapefileParamsTSMorphBase = {
farmIds: string;
/**
 *
 *             Similarity threshold for shapefile validation.
 *             If new parcels have higher or equal jaccard_index than this threshold, the new parcel won't be created and old won't be retired.
 *             If you want to always retire all parcels use threshold 1.0.
 *             Value from 1.0 to 0.0 where 1.0 is most similar and 0.0 is not similar at all.
 *             Default is 0.98
 */
'similarity-threshold'?: number;
/**
 *
 *             If false doesn't retire parcels that do not have replacement in the shapefile.
 *             Can be used for partial update - shapefile can contain one parcel that needs to be updated and the rest will stay the same.
 *             Default is true
 */
'retire-parcels-without-replacement'?: boolean;
}

export type UpdateFarmFromShapefileParams = Omit<UpdateFarmFromShapefileParamsTSMorphBase, "farmIds">;;

export type UpdateFarmFromShapefileBody = {
  shapefile: Blob;
};

export type GetEagriAuthParams = {
language?: string;
};

export type UpdateFarmParams = {
language?: string;
srid?: number;
'update-mode'?: EagriFullFarmUpdateMode;
'sync-catalogues'?: boolean;
'validity-date'?: string;
'skip-parcel-fill-validation'?: boolean;
};

type GetFacilityParamsTSMorphBase = {
farmIds: string;
}

export type GetFacilityParams = Omit<GetFacilityParamsTSMorphBase, "farmIds">;;

type UpdateFacilityParamsTSMorphBase = {
farmIds: string;
}

export type UpdateFacilityParams = Omit<UpdateFacilityParamsTSMorphBase, "farmIds">;;

type DeleteFacilityParamsTSMorphBase = {
farmIds: string;
}

export type DeleteFacilityParams = Omit<DeleteFacilityParamsTSMorphBase, "farmIds">;;

type PutPlantProtectionParamsTSMorphBase = {
farmIds: string;
}

export type PutPlantProtectionParams = Omit<PutPlantProtectionParamsTSMorphBase, "farmIds">;;

type PatchPlantProtectionParamsTSMorphBase = {
farmIds: string;
}

export type PatchPlantProtectionParams = Omit<PatchPlantProtectionParamsTSMorphBase, "farmIds">;;

type UpdateRegistrationParamsTSMorphBase = {
farmIds: string;
}

export type UpdateRegistrationParams = Omit<UpdateRegistrationParamsTSMorphBase, "farmIds">;;

type UpdatePlantProtectionHeaderParamsTSMorphBase = {
farmIds: string;
}

export type UpdatePlantProtectionHeaderParams = Omit<UpdatePlantProtectionHeaderParamsTSMorphBase, "farmIds">;;

type PutPlantProtectionRegistrationApplicationParamsTSMorphBase = {
farmIds: string;
}

export type PutPlantProtectionRegistrationApplicationParams = Omit<PutPlantProtectionRegistrationApplicationParamsTSMorphBase, "farmIds">;;

type DeletePlantProtectionRegistrationApplicationParamsTSMorphBase = {
farmIds: string;
}

export type DeletePlantProtectionRegistrationApplicationParams = Omit<DeletePlantProtectionRegistrationApplicationParamsTSMorphBase, "farmIds">;;

type GetFertilizerParamsTSMorphBase = {
farmIds: string;
language?: string;
}

export type GetFertilizerParams = Omit<GetFertilizerParamsTSMorphBase, "farmIds">;;

type PutFertilizerParamsTSMorphBase = {
farmIds: string;
language?: string;
}

export type PutFertilizerParams = Omit<PutFertilizerParamsTSMorphBase, "farmIds">;;

type HideFertilizerParamsTSMorphBase = {
farmIds: string;
language?: string;
}

export type HideFertilizerParams = Omit<HideFertilizerParamsTSMorphBase, "farmIds">;;

type UpdateCropProductsParamsTSMorphBase = {
farmIds: string;
}

export type UpdateCropProductsParams = Omit<UpdateCropProductsParamsTSMorphBase, "farmIds">;;

type PutCropProductParamsTSMorphBase = {
farmIds: string;
}

export type PutCropProductParams = Omit<PutCropProductParamsTSMorphBase, "farmIds">;;

type PutCropUseTypeParamsTSMorphBase = {
farmIds: string;
}

export type PutCropUseTypeParams = Omit<PutCropUseTypeParamsTSMorphBase, "farmIds">;;

type PutCropGroupParamsTSMorphBase = {
farmIds: string;
}

export type PutCropGroupParams = Omit<PutCropGroupParamsTSMorphBase, "farmIds">;;

type DeleteCropGroupParamsTSMorphBase = {
farmIds: string;
}

export type DeleteCropGroupParams = Omit<DeleteCropGroupParamsTSMorphBase, "farmIds">;;

export type UpdateSkeagisFarmParams = {
farms: string;
};

export type DeleteFarmParams = {
areYouSure: boolean;
};

export type ResaveActionStoreTransactionsParams = {
'farm-id': string;
'action-id': string;
};

type UpdateSkeagisStateParamsTSMorphBase = {
farmIds: string;
}

export type UpdateSkeagisStateParams = Omit<UpdateSkeagisStateParamsTSMorphBase, "farmIds">;;

type CreateNewSkeagisIntegrationParamsTSMorphBase = {
farmIds: string;
}

export type CreateNewSkeagisIntegrationParams = Omit<CreateNewSkeagisIntegrationParamsTSMorphBase, "farmIds">;;

type UpdateSowingActionParamsTSMorphBase = {
farmIds: string;
}

export type UpdateSowingActionParams = Omit<UpdateSowingActionParamsTSMorphBase, "farmIds">;;

type UpdateOtherActionParamsTSMorphBase = {
farmIds: string;
}

export type UpdateOtherActionParams = Omit<UpdateOtherActionParamsTSMorphBase, "farmIds">;;

type UpdateNonFieldActionParamsTSMorphBase = {
farmIds: string;
}

export type UpdateNonFieldActionParams = Omit<UpdateNonFieldActionParamsTSMorphBase, "farmIds">;;

type UpdateMowingActionParamsTSMorphBase = {
farmIds: string;
}

export type UpdateMowingActionParams = Omit<UpdateMowingActionParamsTSMorphBase, "farmIds">;;

type UpdateHarvestActionParamsTSMorphBase = {
farmIds: string;
}

export type UpdateHarvestActionParams = Omit<UpdateHarvestActionParamsTSMorphBase, "farmIds">;;

type UpdateEPHActionParamsTSMorphBase = {
farmIds: string;
}

export type UpdateEPHActionParams = Omit<UpdateEPHActionParamsTSMorphBase, "farmIds">;;

export type SetScenario1Body = {
  submission: MockSubmissionOutcome;
  pollFailuresBeforeAnswer: number;
  evaluationDelaySeconds: number;
  evaluationStatus: EagriReportStatusType;
  errorsCount: number;
  warningsCount: number;
  includeErrorReport?: boolean;
  includeConfirmation?: boolean;
};

type WriteSeedApplicationBatchParamsTSMorphBase = {
farmIds: string;
}

export type WriteSeedApplicationBatchParams = Omit<WriteSeedApplicationBatchParamsTSMorphBase, "farmIds">;;

type SearchDashboardSowingPlansParamsTSMorphBase = {
farmIds: string;
language?: string;
}

export type SearchDashboardSowingPlansParams = Omit<SearchDashboardSowingPlansParamsTSMorphBase, "farmIds">;;

type SearchParcelVersionSowingPlansParamsTSMorphBase = {
farmIds: string;
language?: string;
}

export type SearchParcelVersionSowingPlansParams = Omit<SearchParcelVersionSowingPlansParamsTSMorphBase, "farmIds">;;

type WriteSeedApplicationsParamsTSMorphBase = {
farmIds: string;
}

export type WriteSeedApplicationsParams = Omit<WriteSeedApplicationsParamsTSMorphBase, "farmIds">;;

type SearchSowingPlansParamsTSMorphBase = {
farmIds: string;
language?: string;
}

export type SearchSowingPlansParams = Omit<SearchSowingPlansParamsTSMorphBase, "farmIds">;;

type GetPlantProtectionsInternalParamsTSMorphBase = {
farmIds: string;
}

export type GetPlantProtectionsInternalParams = Omit<GetPlantProtectionsInternalParamsTSMorphBase, "farmIds">;;

type GetParcelsWithSuccessorsParamsTSMorphBase = {
farmIds: string;
language?: string;
pageOffset?: number;
pageSize?: number;
sortProperty?: string;
}

export type GetParcelsWithSuccessorsParams = Omit<GetParcelsWithSuccessorsParamsTSMorphBase, "farmIds">;;

type SearchInternalParcelsParamsTSMorphBase = {
farmIds: string;
language?: string;
'valid-from'?: string;
'valid-to'?: string;
search?: string;
'crop-ids'?: string[];
status?: ParcelStatus;
pageOffset?: number;
pageSize?: number;
sortProperty?: string;
}

export type SearchInternalParcelsParams = Omit<SearchInternalParcelsParamsTSMorphBase, "farmIds">;;

type GetParcelIntersectionsParamsTSMorphBase = {
farmIds: string;
status?: ParcelStatus;
'at-date'?: string;
}

export type GetParcelIntersectionsParams = Omit<GetParcelIntersectionsParamsTSMorphBase, "farmIds">;;

export type GetInternationalParcelIntersectionsParams = {
'country-code': string;
'at-date'?: string;
};

type GetOpenParcelsIntersectingByParcelsParamsTSMorphBase = {
farmIds: string;
}

export type GetOpenParcelsIntersectingByParcelsParams = Omit<GetOpenParcelsIntersectingByParcelsParamsTSMorphBase, "farmIds">;;

type GetActionInfoParamsTSMorphBase = {
farmIds: string;
language?: LocalLanguage;
}

export type GetActionInfoParams = Omit<GetActionInfoParamsTSMorphBase, "farmIds">;;

type CreateDraftActionParamsTSMorphBase = {
farmIds: string;
}

export type CreateDraftActionParams = Omit<CreateDraftActionParamsTSMorphBase, "farmIds">;;

type GetSeedApplicationV2sParamsTSMorphBase = {
farmIds: string;
'parcel-ids'?: string[];
'date-from'?: string;
'date-to'?: string;
pageOffset?: number;
pageSize?: number;
sortProperty?: string;
language?: string;
}

export type GetSeedApplicationV2sParams = Omit<GetSeedApplicationV2sParamsTSMorphBase, "farmIds">;;

type CreateSeedApplicationV2ParamsTSMorphBase = {
farmIds: string;
}

export type CreateSeedApplicationV2Params = Omit<CreateSeedApplicationV2ParamsTSMorphBase, "farmIds">;;

type CreateSeedApplicationV2GroupParamsTSMorphBase = {
farmIds: string;
}

export type CreateSeedApplicationV2GroupParams = Omit<CreateSeedApplicationV2GroupParamsTSMorphBase, "farmIds">;;

type CreateBulkParamsTSMorphBase = {
farmIds: string;
}

export type CreateBulkParams = Omit<CreateBulkParamsTSMorphBase, "farmIds">;;

type PreviewBulkCreateParamsTSMorphBase = {
farmIds: string;
}

export type PreviewBulkCreateParams = Omit<PreviewBulkCreateParamsTSMorphBase, "farmIds">;;

type EditBulkParamsTSMorphBase = {
farmIds: string;
}

export type EditBulkParams = Omit<EditBulkParamsTSMorphBase, "farmIds">;;

type PreviewBulkEditParamsTSMorphBase = {
farmIds: string;
}

export type PreviewBulkEditParams = Omit<PreviewBulkEditParamsTSMorphBase, "farmIds">;;

type DeleteBulkParamsTSMorphBase = {
farmIds: string;
}

export type DeleteBulkParams = Omit<DeleteBulkParamsTSMorphBase, "farmIds">;;

type SendPorUserReportToEagriV2ParamsTSMorphBase = {
farmIds: string;
toDate: string;
fromDate?: string;
}

export type SendPorUserReportToEagriV2Params = Omit<SendPorUserReportToEagriV2ParamsTSMorphBase, "farmIds">;;

type GetPorUseReportBodyV2ParamsTSMorphBase = {
farmIds: string;
toDate: string;
}

export type GetPorUseReportBodyV2Params = Omit<GetPorUseReportBodyV2ParamsTSMorphBase, "farmIds">;;

type DownloadPorUseReportXmlV2ParamsTSMorphBase = {
farmIds: string;
toDate: string;
fromDate?: string;
}

export type DownloadPorUseReportXmlV2Params = Omit<DownloadPorUseReportXmlV2ParamsTSMorphBase, "farmIds">;;

type SendFertilizerUseReportToEagriV2ParamsTSMorphBase = {
farmIds: string;
}

export type SendFertilizerUseReportToEagriV2Params = Omit<SendFertilizerUseReportToEagriV2ParamsTSMorphBase, "farmIds">;;

type GetFertilizerUseReportBodyV2ParamsTSMorphBase = {
farmIds: string;
}

export type GetFertilizerUseReportBodyV2Params = Omit<GetFertilizerUseReportBodyV2ParamsTSMorphBase, "farmIds">;;

type GetSeededAreasV2ReportParamsTSMorphBase = {
farmIds: string;
'parcel-ids'?: string[];
'date-from': string;
'date-to': string;
'file-type': FileType;
language?: string;
}

export type GetSeededAreasV2ReportParams = Omit<GetSeededAreasV2ReportParamsTSMorphBase, "farmIds">;;

type PostSeededAreasV2ReportParamsTSMorphBase = {
farmIds: string;
language?: string;
}

export type PostSeededAreasV2ReportParams = Omit<PostSeededAreasV2ReportParamsTSMorphBase, "farmIds">;;

type GetSeedApplicationsV2ReportParamsTSMorphBase = {
farmIds: string;
'parcel-ids'?: string[];
'date-from': string;
'date-to': string;
'file-type': FileType;
language?: string;
}

export type GetSeedApplicationsV2ReportParams = Omit<GetSeedApplicationsV2ReportParamsTSMorphBase, "farmIds">;;

type PostSeedApplicationsV2ReportParamsTSMorphBase = {
farmIds: string;
language?: string;
}

export type PostSeedApplicationsV2ReportParams = Omit<PostSeedApplicationsV2ReportParamsTSMorphBase, "farmIds">;;

type GetRevenuesV2ReportParamsTSMorphBase = {
farmIds: string;
'parcel-ids'?: string[];
'date-from': string;
'date-to': string;
'file-type': FileType;
language?: string;
}

export type GetRevenuesV2ReportParams = Omit<GetRevenuesV2ReportParamsTSMorphBase, "farmIds">;;

type PostRevenuesV2ReportParamsTSMorphBase = {
farmIds: string;
language?: string;
}

export type PostRevenuesV2ReportParams = Omit<PostRevenuesV2ReportParamsTSMorphBase, "farmIds">;;

type GetPorUsageReportParamsTSMorphBase = {
farmIds: string;
'parcel-ids'?: string[];
'date-from': string;
'date-to': string;
'file-type': FileType;
language?: string;
}

export type GetPorUsageReportParams = Omit<GetPorUsageReportParamsTSMorphBase, "farmIds">;;

type PostPorUsageReportParamsTSMorphBase = {
farmIds: string;
language?: string;
}

export type PostPorUsageReportParams = Omit<PostPorUsageReportParamsTSMorphBase, "farmIds">;;

type GetPorConsumptionByPPReportParamsTSMorphBase = {
farmIds: string;
'parcel-ids'?: string[];
'date-from': string;
'date-to': string;
'file-type': FileType;
language?: string;
}

export type GetPorConsumptionByPPReportParams = Omit<GetPorConsumptionByPPReportParamsTSMorphBase, "farmIds">;;

type PostPorConsumptionByPPReportParamsTSMorphBase = {
farmIds: string;
language?: string;
}

export type PostPorConsumptionByPPReportParams = Omit<PostPorConsumptionByPPReportParamsTSMorphBase, "farmIds">;;

type GetPorConsumptionByCropReportParamsTSMorphBase = {
farmIds: string;
'parcel-ids'?: string[];
'date-from': string;
'date-to': string;
'file-type': FileType;
language?: string;
}

export type GetPorConsumptionByCropReportParams = Omit<GetPorConsumptionByCropReportParamsTSMorphBase, "farmIds">;;

type PostPorConsumptionByCropReportParamsTSMorphBase = {
farmIds: string;
language?: string;
}

export type PostPorConsumptionByCropReportParams = Omit<PostPorConsumptionByCropReportParamsTSMorphBase, "farmIds">;;

type GetNonFieldPorUsageReportParamsTSMorphBase = {
farmIds: string;
'parcel-ids'?: string[];
'date-from': string;
'date-to': string;
'file-type': FileType;
language?: string;
}

export type GetNonFieldPorUsageReportParams = Omit<GetNonFieldPorUsageReportParamsTSMorphBase, "farmIds">;;

type PostNonFieldPorUsageReportParamsTSMorphBase = {
farmIds: string;
language?: string;
}

export type PostNonFieldPorUsageReportParams = Omit<PostNonFieldPorUsageReportParamsTSMorphBase, "farmIds">;;

type GetFertilizerUsageReportParamsTSMorphBase = {
farmIds: string;
'parcel-ids'?: string[];
'date-from': string;
'date-to': string;
'file-type': FileType;
language?: string;
}

export type GetFertilizerUsageReportParams = Omit<GetFertilizerUsageReportParamsTSMorphBase, "farmIds">;;

type PostFertilizerUsageReportParamsTSMorphBase = {
farmIds: string;
language?: string;
}

export type PostFertilizerUsageReportParams = Omit<PostFertilizerUsageReportParamsTSMorphBase, "farmIds">;;

type GetFertilizerOrganicReportParamsTSMorphBase = {
farmIds: string;
'parcel-ids'?: string[];
'date-from': string;
'date-to': string;
'file-type': FileType;
language?: string;
}

export type GetFertilizerOrganicReportParams = Omit<GetFertilizerOrganicReportParamsTSMorphBase, "farmIds">;;

type PostFertilizerOrganicReportParamsTSMorphBase = {
farmIds: string;
language?: string;
}

export type PostFertilizerOrganicReportParams = Omit<PostFertilizerOrganicReportParamsTSMorphBase, "farmIds">;;

type GetFertilizerConsumptionReportParamsTSMorphBase = {
farmIds: string;
'parcel-ids'?: string[];
'date-from': string;
'date-to': string;
'file-type': FileType;
language?: string;
}

export type GetFertilizerConsumptionReportParams = Omit<GetFertilizerConsumptionReportParamsTSMorphBase, "farmIds">;;

type PostFertilizerConsumptionReportParamsTSMorphBase = {
farmIds: string;
language?: string;
}

export type PostFertilizerConsumptionReportParams = Omit<PostFertilizerConsumptionReportParamsTSMorphBase, "farmIds">;;

type GetFertilizerConsumptionByCropReportParamsTSMorphBase = {
farmIds: string;
'parcel-ids'?: string[];
'date-from': string;
'date-to': string;
'file-type': FileType;
language?: string;
}

export type GetFertilizerConsumptionByCropReportParams = Omit<GetFertilizerConsumptionByCropReportParamsTSMorphBase, "farmIds">;;

type PostFertilizerConsumptionByCropReportParamsTSMorphBase = {
farmIds: string;
language?: string;
}

export type PostFertilizerConsumptionByCropReportParams = Omit<PostFertilizerConsumptionByCropReportParamsTSMorphBase, "farmIds">;;

type GetActionsReportParamsTSMorphBase = {
farmIds: string;
'parcel-ids'?: string[];
'date-from': string;
'date-to': string;
'file-type': FileType;
language?: string;
}

export type GetActionsReportParams = Omit<GetActionsReportParamsTSMorphBase, "farmIds">;;

type PostActionsReportParamsTSMorphBase = {
farmIds: string;
language?: string;
}

export type PostActionsReportParams = Omit<PostActionsReportParamsTSMorphBase, "farmIds">;;

export type RegisterWithShapeFileParams = {
farmName: string;
countryCode: string;
language?: string;
};

export type RegisterWithShapeFileBody = {
  lpisFile: Blob;
};

export type ValidateShapefileParams = {
countryCode: string;
};

export type ValidateShapefileBody = {
  lpisFile: Blob;
};

export type RegisterEmptyFarmParams = {
farmName: string;
countryCode: string;
language?: string;
};

export type RegisterWithEagriParams = {
farmName: string;
language?: string;
srid?: number;
importMode?: EagriImportMode;
};

type GetParcelsSubtractionParamsTSMorphBase = {
farmIds: string;
'valid-date'?: string;
}

export type GetParcelsSubtractionParams = Omit<GetParcelsSubtractionParamsTSMorphBase, "farmIds">;;

type GetZonesParamsTSMorphBase = {
farmIds: string;
search?: string;
date?: string;
}

export type GetZonesParams = Omit<GetZonesParamsTSMorphBase, "farmIds">;;

type CreateZoneParamsTSMorphBase = {
farmIds: string;
}

export type CreateZoneParams = Omit<CreateZoneParamsTSMorphBase, "farmIds">;;

type PostParcelVegetationStripParamsTSMorphBase = {
farmIds: string;
}

export type PostParcelVegetationStripParams = Omit<PostParcelVegetationStripParamsTSMorphBase, "farmIds">;;

type RecountSubtractionsForActionParamsTSMorphBase = {
farmIds: string;
'valid-date'?: string;
}

export type RecountSubtractionsForActionParams = Omit<RecountSubtractionsForActionParamsTSMorphBase, "farmIds">;;

type GetParcelSubtractionGeometryParamsTSMorphBase = {
farmIds: string;
'valid-date'?: string;
}

export type GetParcelSubtractionGeometryParams = Omit<GetParcelSubtractionGeometryParamsTSMorphBase, "farmIds">;;

type GetParcelSubtractionGeometriesParamsTSMorphBase = {
farmIds: string;
'valid-date'?: string;
}

export type GetParcelSubtractionGeometriesParams = Omit<GetParcelSubtractionGeometriesParamsTSMorphBase, "farmIds">;;

type GetParcelAreaAfterSubtractionParamsTSMorphBase = {
farmIds: string;
'valid-date'?: string;
}

export type GetParcelAreaAfterSubtractionParams = Omit<GetParcelAreaAfterSubtractionParamsTSMorphBase, "farmIds">;;

type GetAvailableUpdatesParamsTSMorphBase = {
farmIds: string;
}

export type GetAvailableUpdatesParams = Omit<GetAvailableUpdatesParamsTSMorphBase, "farmIds">;;

type RequestAvailableUpdatesParamsTSMorphBase = {
farmIds: string;
}

export type RequestAvailableUpdatesParams = Omit<RequestAvailableUpdatesParamsTSMorphBase, "farmIds">;;

type GetFacilitiesParamsTSMorphBase = {
farmIds: string;
search?: string;
types?: FacilityType[];
units?: FacilityUnit[];
'sort-col'?: FacilitySortColumn;
'sort-dir'?: SortDirection;
language?: LocalLanguage;
}

export type GetFacilitiesParams = Omit<GetFacilitiesParamsTSMorphBase, "farmIds">;;

type CreateFacilityParamsTSMorphBase = {
farmIds: string;
}

export type CreateFacilityParams = Omit<CreateFacilityParamsTSMorphBase, "farmIds">;;

type GetSeedsParamsTSMorphBase = {
farmIds: string;
/**
 * Catalog localization language
 */
language?: string;
pageOffset?: number;
pageSize?: number;
sortProperty?: string;
/**
 * Filter by crop name
 */
search?: string;
/**
 * Set catalogue type
 */
catalogue?: CatalogueType;
/**
 * Include hidden seeds
 */
'include-hidden'?: boolean;
/**
 * Filter by crop external id
 */
'external-ids'?: string[];
/**
 * Filter seeds by internal crop id (catalogue-agnostic)
 */
'crop-ids'?: string[];
/**
 * Seed validity end
 */
'valid-on'?: string;
/**
 * If true, returns only favorite fertilizers
 */
'favorite-only'?: boolean;
/**
 * Filter by crop group id
 */
'crop-group-ids'?: string[];
/**
 * Filter by lifespan (ANNUAL / PERENNIAL)
 */
lifespan?: CropLifespan;
/**
 * Filter by growing period (SPRING / WINTER). Multi-select uses OR — a crop matches if any of the listed periods applies.
 */
'growing-periods'?: GrowingPeriod[];
/**
 * Filter seeds whose crop maps any of the given crop use types
 */
'use-type-ids'?: string[];
/**
 * Filter seeds whose crop has any of the given products mapped as main (CropProduct.isMain = true).
 */
'main-product-ids'?: string[];
/**
 * Filter seeds whose crop has any of the given products mapped as secondary product (CropProduct.isMain = false).
 */
'secondary-product-ids'?: string[];
}

export type GetSeedsParams = Omit<GetSeedsParamsTSMorphBase, "farmIds">;;

type PostSeedParamsTSMorphBase = {
farmIds: string;
}

export type PostSeedParams = Omit<PostSeedParamsTSMorphBase, "farmIds">;;

type PostPlantProtectionParamsTSMorphBase = {
farmIds: string;
}

export type PostPlantProtectionParams = Omit<PostPlantProtectionParamsTSMorphBase, "farmIds">;;

type CopyPlantProtectionParamsTSMorphBase = {
farmIds: string;
}

export type CopyPlantProtectionParams = Omit<CopyPlantProtectionParamsTSMorphBase, "farmIds">;;

type CreateRegistrationParamsTSMorphBase = {
farmIds: string;
}

export type CreateRegistrationParams = Omit<CreateRegistrationParamsTSMorphBase, "farmIds">;;

type PostPlantProtectionRegistrationApplicationParamsTSMorphBase = {
farmIds: string;
}

export type PostPlantProtectionRegistrationApplicationParams = Omit<PostPlantProtectionRegistrationApplicationParamsTSMorphBase, "farmIds">;;

type BulkCreatePlantProtectionRegistrationApplicationsParamsTSMorphBase = {
farmIds: string;
}

export type BulkCreatePlantProtectionRegistrationApplicationsParams = Omit<BulkCreatePlantProtectionRegistrationApplicationsParamsTSMorphBase, "farmIds">;;

type ImportPlantProtectionsFromCSVParamsTSMorphBase = {
farmIds: string;
}

export type ImportPlantProtectionsFromCSVParams = Omit<ImportPlantProtectionsFromCSVParamsTSMorphBase, "farmIds">;;

export type ImportPlantProtectionsFromCSVBody = {
  file: Blob;
};

type CreatePlantProtectionHeaderParamsTSMorphBase = {
farmIds: string;
}

export type CreatePlantProtectionHeaderParams = Omit<CreatePlantProtectionHeaderParamsTSMorphBase, "farmIds">;;

type GetOrganismsParamsTSMorphBase = {
farmIds: string;
search?: string;
'is-used'?: boolean;
'valid-only'?: boolean;
}

export type GetOrganismsParams = Omit<GetOrganismsParamsTSMorphBase, "farmIds">;;

type CreateOrganismsParamsTSMorphBase = {
farmIds: string;
}

export type CreateOrganismsParams = Omit<CreateOrganismsParamsTSMorphBase, "farmIds">;;

type GetActiveSubstancesParamsTSMorphBase = {
farmIds: string;
search?: string;
}

export type GetActiveSubstancesParams = Omit<GetActiveSubstancesParamsTSMorphBase, "farmIds">;;

type PostActiveSubstanceParamsTSMorphBase = {
farmIds: string;
}

export type PostActiveSubstanceParams = Omit<PostActiveSubstanceParamsTSMorphBase, "farmIds">;;

type GetFertilizersParamsTSMorphBase = {
farmIds: string;
language?: string;
/**
 * Filter by fertilizer name
 */
search?: string;
/**
 * Set catalogue type
 */
catalogue?: CatalogueType;
/**
 * Include hidden fertilizers
 */
'include-hidden'?: boolean;
/**
 * Filter by fertilizer external id
 */
'external-ids'?: string[];
/**
 * Filter by fertilizer organic flag
 */
organic?: boolean;
/**
 * Filter by eAgri fertilizer nitrogen category type
 */
'eagri-nitrogen-category'?: EagriFertilizerNitrogenCategory[];
/**
 * Fertilizer validity end
 */
'valid-on'?: string;
/**
 * If true, returns only favorite fertilizers
 */
'favorite-only'?: boolean;
pageOffset?: number;
pageSize?: number;
sortProperty?: string;
}

export type GetFertilizersParams = Omit<GetFertilizersParamsTSMorphBase, "farmIds">;;

type PostFertilizerParamsTSMorphBase = {
farmIds: string;
language?: string;
}

export type PostFertilizerParams = Omit<PostFertilizerParamsTSMorphBase, "farmIds">;;

type ImportFertilizersFromCSVParamsTSMorphBase = {
farmIds: string;
}

export type ImportFertilizersFromCSVParams = Omit<ImportFertilizersFromCSVParamsTSMorphBase, "farmIds">;;

export type ImportFertilizersFromCSVBody = {
  file: Blob;
};

type GetCropsParamsTSMorphBase = {
farmIds: string;
language?: string;
pageOffset?: number;
pageSize?: number;
sortProperty?: string;
/**
 * Filter by crop name
 */
search?: string;
/**
 * Filter by crop external id
 */
'external-ids'?: string[];
/**
 * Filter by crop validity on date
 */
'valid-on'?: string;
/**
 * Include no crop
 */
'include-no-crop'?: boolean;
}

export type GetCropsParams = Omit<GetCropsParamsTSMorphBase, "farmIds">;;

type PostCropParamsTSMorphBase = {
farmIds: string;
}

export type PostCropParams = Omit<PostCropParamsTSMorphBase, "farmIds">;;

type GetCropProductsParamsTSMorphBase = {
farmIds: string;
'crop-id'?: string;
'is-main'?: boolean;
}

export type GetCropProductsParams = Omit<GetCropProductsParamsTSMorphBase, "farmIds">;;

type PostCropProductParamsTSMorphBase = {
farmIds: string;
}

export type PostCropProductParams = Omit<PostCropProductParamsTSMorphBase, "farmIds">;;

type ImportCropsFromCSVParamsTSMorphBase = {
farmIds: string;
}

export type ImportCropsFromCSVParams = Omit<ImportCropsFromCSVParamsTSMorphBase, "farmIds">;;

export type ImportCropsFromCSVBody = {
  file: Blob;
};

type GetCropUseTypesParamsTSMorphBase = {
farmIds: string;
'crop-id'?: string;
'valid-on'?: string;
}

export type GetCropUseTypesParams = Omit<GetCropUseTypesParamsTSMorphBase, "farmIds">;;

type PostCropUseTypeParamsTSMorphBase = {
farmIds: string;
}

export type PostCropUseTypeParams = Omit<PostCropUseTypeParamsTSMorphBase, "farmIds">;;

type AttachCropUseTypeToCropParamsTSMorphBase = {
farmIds: string;
}

export type AttachCropUseTypeToCropParams = Omit<AttachCropUseTypeToCropParamsTSMorphBase, "farmIds">;;

type DetachCropUseTypeFromCropParamsTSMorphBase = {
farmIds: string;
}

export type DetachCropUseTypeFromCropParams = Omit<DetachCropUseTypeFromCropParamsTSMorphBase, "farmIds">;;

export type DetachCropUseTypeFromCrop204 = { [key: string]: unknown };

export type DetachCropUseTypeFromCrop403 = { [key: string]: unknown };

export type DetachCropUseTypeFromCrop404 = { [key: string]: unknown };

type GetCropGroupsParamsTSMorphBase = {
farmIds: string;
}

export type GetCropGroupsParams = Omit<GetCropGroupsParamsTSMorphBase, "farmIds">;;

type PostCropGroupParamsTSMorphBase = {
farmIds: string;
}

export type PostCropGroupParams = Omit<PostCropGroupParamsTSMorphBase, "farmIds">;;

export type ImportSurfaceWaterProtectionZonesParams = {
'source-srid': number;
};

export type ImportSurfaceWaterProtectionZonesBody = {
  file: Blob;
};

export type ImportFromVuvZipParams = {
'source-srid': number;
mode?: WaterProtectionZonesImportMode;
};

export type ImportFromVuvZipBody = {
  file: Blob;
};

export type ImportGroundWaterProtectionZonesParams = {
'source-srid': number;
};

export type ImportGroundWaterProtectionZonesBody = {
  file: Blob;
};

export type UpdateNitrateVulnerableParams = {
batch?: number;
'batch-size'?: number;
};

export type MoveParcelValiditiesToNewestSowingParams = {
farms: string;
parcels?: string[];
};

export type MoveActionsAfterUpdateParams = {
farms: string[];
};

export type UpdateEagriFarmParams = {
updateMode?: EagriFullFarmUpdateMode;
};

type GetTargetSeedApplicationAccountableNitrogenParamsTSMorphBase = {
farmIds: string;
}

export type GetTargetSeedApplicationAccountableNitrogenParams = Omit<GetTargetSeedApplicationAccountableNitrogenParamsTSMorphBase, "farmIds">;;

type SplitActionParamsTSMorphBase = {
farmIds: string;
}

export type SplitActionParams = Omit<SplitActionParamsTSMorphBase, "farmIds">;;

type CreateSowingActionParamsTSMorphBase = {
farmIds: string;
}

export type CreateSowingActionParams = Omit<CreateSowingActionParamsTSMorphBase, "farmIds">;;

type CreateOtherActionParamsTSMorphBase = {
farmIds: string;
}

export type CreateOtherActionParams = Omit<CreateOtherActionParamsTSMorphBase, "farmIds">;;

type CreateNonFieldActionParamsTSMorphBase = {
farmIds: string;
}

export type CreateNonFieldActionParams = Omit<CreateNonFieldActionParamsTSMorphBase, "farmIds">;;

type CreateMowingActionParamsTSMorphBase = {
farmIds: string;
}

export type CreateMowingActionParams = Omit<CreateMowingActionParamsTSMorphBase, "farmIds">;;

type CreateHarvestActionParamsTSMorphBase = {
farmIds: string;
}

export type CreateHarvestActionParams = Omit<CreateHarvestActionParamsTSMorphBase, "farmIds">;;

type CreateEPHActionParamsTSMorphBase = {
farmIds: string;
}

export type CreateEPHActionParams = Omit<CreateEPHActionParamsTSMorphBase, "farmIds">;;

type ValidateEPHActionParamsTSMorphBase = {
farmIds: string;
}

export type ValidateEPHActionParams = Omit<ValidateEPHActionParamsTSMorphBase, "farmIds">;;

type GetParcelParamsTSMorphBase = {
farmIds: string;
language?: string;
}

export type GetParcelParams = Omit<GetParcelParamsTSMorphBase, "farmIds">;;

type PatchParcelParamsTSMorphBase = {
farmIds: string;
}

export type PatchParcelParams = Omit<PatchParcelParamsTSMorphBase, "farmIds">;;

type PatchParcelValidFromParamsTSMorphBase = {
farmIds: string;
}

export type PatchParcelValidFromParams = Omit<PatchParcelValidFromParamsTSMorphBase, "farmIds">;;

type DeleteZoneParamsTSMorphBase = {
farmIds: string;
}

export type DeleteZoneParams = Omit<DeleteZoneParamsTSMorphBase, "farmIds">;;

type UpdateZoneParamsTSMorphBase = {
farmIds: string;
}

export type UpdateZoneParams = Omit<UpdateZoneParamsTSMorphBase, "farmIds">;;

type GetSeedParamsTSMorphBase = {
farmIds: string;
}

export type GetSeedParams = Omit<GetSeedParamsTSMorphBase, "farmIds">;;

type DeleteSeedParamsTSMorphBase = {
farmIds: string;
}

export type DeleteSeedParams = Omit<DeleteSeedParamsTSMorphBase, "farmIds">;;

export type DeleteSeed204 = { [key: string]: unknown };

export type DeleteSeed403 = { [key: string]: unknown };

export type DeleteSeed404 = { [key: string]: unknown };

type PatchSeedParamsTSMorphBase = {
farmIds: string;
}

export type PatchSeedParams = Omit<PatchSeedParamsTSMorphBase, "farmIds">;;

export type PatchSeed403 = { [key: string]: unknown };

export type PatchSeed404 = { [key: string]: unknown };

type BulkUpdateWaterSectionParamsTSMorphBase = {
farmIds: string;
}

export type BulkUpdateWaterSectionParams = Omit<BulkUpdateWaterSectionParamsTSMorphBase, "farmIds">;;

type BulkUpdatePopulationSectionParamsTSMorphBase = {
farmIds: string;
}

export type BulkUpdatePopulationSectionParams = Omit<BulkUpdatePopulationSectionParamsTSMorphBase, "farmIds">;;

type BulkUpdateDosageSectionParamsTSMorphBase = {
farmIds: string;
}

export type BulkUpdateDosageSectionParams = Omit<BulkUpdateDosageSectionParamsTSMorphBase, "farmIds">;;

type BulkUpdateBoundarySectionParamsTSMorphBase = {
farmIds: string;
}

export type BulkUpdateBoundarySectionParams = Omit<BulkUpdateBoundarySectionParamsTSMorphBase, "farmIds">;;

type PatchCropParamsTSMorphBase = {
farmIds: string;
}

export type PatchCropParams = Omit<PatchCropParamsTSMorphBase, "farmIds">;;

type GetParcelByArealNameParamsTSMorphBase = {
farmIds: string;
'zone-name': string;
'parcel-status'?: ParcelStatus;
language: LocalLanguage;
}

export type GetParcelByArealNameParams = Omit<GetParcelByArealNameParamsTSMorphBase, "farmIds">;;

export type GetSeedApplicationV2DebugPageParams = {
farmIds?: string;
parcelId?: string;
};

type GetVisualizationContentParamsTSMorphBase = {
farmIds: string;
parcelId: string;
}

export type GetVisualizationContentParams = Omit<GetVisualizationContentParamsTSMorphBase, "farmIds">;;

export type GetPlantProtectionDebugPageParams = {
plantProtectionId?: string;
};

export type SearchPlantProtectionsParams = {
q: string;
limit?: number;
eagriOnly?: boolean;
validOnly?: boolean;
};

export type GetProvenancePageParams = {
plantProtectionId?: string;
};

export type SearchAttachmentProvenanceParams = {
q: string;
limit?: number;
};

type GetDashboardSeasonWindowParamsTSMorphBase = {
farmIds: string;
size?: number;
startYear?: number;
}

export type GetDashboardSeasonWindowParams = Omit<GetDashboardSeasonWindowParamsTSMorphBase, "farmIds">;;

type GetDashboardSeasonOverviewParamsTSMorphBase = {
farmIds: string;
startYear: number;
}

export type GetDashboardSeasonOverviewParams = Omit<GetDashboardSeasonOverviewParamsTSMorphBase, "farmIds">;;

type GetSowingPlansParamsTSMorphBase = {
farmIds: string;
parcelIds: string[];
'date-from': string;
'date-to': string;
'crop-ids'?: string[];
status?: ParcelStatus[];
language?: string;
}

export type GetSowingPlansParams = Omit<GetSowingPlansParamsTSMorphBase, "farmIds">;;

type GetSeedsInternalParamsTSMorphBase = {
farmIds: string;
ids?: string[];
name?: string;
language?: string;
}

export type GetSeedsInternalParams = Omit<GetSeedsInternalParamsTSMorphBase, "farmIds">;;

type GetInternalParcelsParamsTSMorphBase = {
farmIds: string;
language?: string;
ids?: string[];
'valid-from'?: string;
'valid-to'?: string;
search?: string;
'crop-ids'?: string[];
status?: ParcelStatus;
pageOffset?: number;
pageSize?: number;
sortProperty?: string;
}

export type GetInternalParcelsParams = Omit<GetInternalParcelsParamsTSMorphBase, "farmIds">;;

type GetParcelDetailParamsTSMorphBase = {
farmIds: string;
language?: string;
'at-date'?: string;
}

export type GetParcelDetailParams = Omit<GetParcelDetailParamsTSMorphBase, "farmIds">;;

type GetSeedApplicationsParamsTSMorphBase = {
farmIds: string;
}

export type GetSeedApplicationsParams = Omit<GetSeedApplicationsParamsTSMorphBase, "farmIds">;;

type GetSeedApplicationsByParcelIdsParamsTSMorphBase = {
farmIds: string;
parcelIds?: string[];
}

export type GetSeedApplicationsByParcelIdsParams = Omit<GetSeedApplicationsByParcelIdsParamsTSMorphBase, "farmIds">;;

type GetFertilizersInternalParamsTSMorphBase = {
farmIds: string;
ids?: string[];
name?: string;
}

export type GetFertilizersInternalParams = Omit<GetFertilizersInternalParamsTSMorphBase, "farmIds">;;

type GetInternalFertilizerMineralIntakeParamsTSMorphBase = {
farmIds: string;
'unit-id': string;
dose: number;
}

export type GetInternalFertilizerMineralIntakeParams = Omit<GetInternalFertilizerMineralIntakeParamsTSMorphBase, "farmIds">;;

type GetInternalFarmDetailParamsTSMorphBase = {
farmIds: string;
}

export type GetInternalFarmDetailParams = Omit<GetInternalFarmDetailParamsTSMorphBase, "farmIds">;;

export type SearchFarmsParams = {
search?: string;
pageOffset?: number;
pageSize?: number;
sortProperty?: string;
language?: string;
};

type GetCropsInternalParamsTSMorphBase = {
farmIds: string;
'external-id'?: string[];
}

export type GetCropsInternalParams = Omit<GetCropsInternalParamsTSMorphBase, "farmIds">;;

type GetCropCatalogueTypeParamsTSMorphBase = {
farmIds: string;
}

export type GetCropCatalogueTypeParams = Omit<GetCropCatalogueTypeParamsTSMorphBase, "farmIds">;;

type PreviewTerminationParamsTSMorphBase = {
farmIds: string;
'parcel-ids': string[];
date: string;
}

export type PreviewTerminationParams = Omit<PreviewTerminationParamsTSMorphBase, "farmIds">;;

type GetConnectableSeedApplicationsParamsTSMorphBase = {
farmIds: string;
'seed-application-id'?: string;
'group-id'?: string;
}

export type GetConnectableSeedApplicationsParams = Omit<GetConnectableSeedApplicationsParamsTSMorphBase, "farmIds">;;

type GetSeedApplicationsV2AtDateParamsTSMorphBase = {
farmIds: string;
'parcel-ids': string[];
date: string;
'action-type'?: ActionType;
}

export type GetSeedApplicationsV2AtDateParams = Omit<GetSeedApplicationsV2AtDateParamsTSMorphBase, "farmIds">;;

type CheckFertilizerUseReportParamsTSMorphBase = {
farmIds: string;
guid: string;
'date-from'?: string;
'date-to'?: string;
}

export type CheckFertilizerUseReportParams = Omit<CheckFertilizerUseReportParamsTSMorphBase, "farmIds">;;

export type GetSeasonsParams = {
size?: number;
startYear?: number;
farmIds?: string;
};

type GetSeasonsExcelParamsTSMorphBase = {
farmIds: string;
startYear: number;
size: number;
language?: string;
/**
 * Filter by parcel name or block number.
 */
search?: string;
/**
 * Filter by parcel status.
 */
status?: ParcelStatus[];
/**
 * <p>Start of interval in which the parcel is considered valid.</p><p>If <b>valid-from</b> and/or <b>valid-to</b> filter is used, it will return parcels that are considered valid inside the given date range. If either <b>valid-from</b> or <b>valid-to</b> is null, the interval is considered open from respective side.<p>
 */
'valid-from'?: string;
/**
 * <p>End of interval in which the parcel is considered valid.</p><p><i>See valid-from</i></p>
 */
'valid-to'?: string;
/**
 * <p>Date parcel is expected to be valid on. It is mutually exclusive with valid-from and valid-to.</p>
 */
'valid-on'?: string;
/**
 * Filter by parcel land use.
 */
'land-use'?: LandUse[];
/**
 * Filter only parcels with given IDs.
 */
ids?: string[];
/**
 * Filter parcels by zone ID(s) of zones they are in. Use NONE to filter parcels with no zone.
 */
zones?: string[];
/**
 * Filter parcels by center ID(s) of centers they are in. Use NONE to filter parcels with no center.
 */
centers?: string[];
/**
 * Filter parcels by sown crop legislative codes.
 */
crops?: number[];
/**
 * Filter parcels by sown crop id.
 */
'crop-ids'?: string[];
/**
 * Filters parcels by their nitrate vulnerable status.<ul><li>If <b>true</b>, filters only nitrate vulnerable parcels</li><li>If <b>false</b>, filters only nitrate invulnerable parcel</li><li>If <b>null</b>, no nitrate vulnerable filter is applied</li></ul>
 */
'nitrate-vulnerable'?: boolean;
/**
 * Filters parcels by whether they have an active seed application (crop).<ul><li>If <b>true</b>, filters only parcels with an active seed application</li><li>If <b>false</b>, filters only parcels without an active seed application</li><li>If <b>null</b>, no filter is applied</li></ul>
 */
sown?: boolean;
/**
 * Filters parcels by whether a sowing activity has been physically performed.<ul><li>If <b>true</b>, filters only parcels where a sowing action exists for the current seed application</li><li>If <b>false</b>, filters parcels where no sowing action was performed, or no active seed application exists</li><li>If <b>null</b>, no filter is applied</li></ul>
 */
'sowing-performed'?: boolean;
'season-crop'?: string[];
'season-no-crop'?: number[];
'season-crop-type'?: string[];
'shown-crop'?: string[];
'shown-crop-type'?: SeedApplicationType[];
'shown-no-crop'?: boolean;
'shown-season'?: number[];
}

export type GetSeasonsExcelParams = Omit<GetSeasonsExcelParamsTSMorphBase, "farmIds">;;

type GetParcelsWithSowingPlansParamsTSMorphBase = {
farmIds: string;
startYear: number;
size: number;
language?: string;
/**
 * Filter by parcel name or block number.
 */
search?: string;
/**
 * Filter by parcel status.
 */
status?: ParcelStatus[];
/**
 * <p>Start of interval in which the parcel is considered valid.</p><p>If <b>valid-from</b> and/or <b>valid-to</b> filter is used, it will return parcels that are considered valid inside the given date range. If either <b>valid-from</b> or <b>valid-to</b> is null, the interval is considered open from respective side.<p>
 */
'valid-from'?: string;
/**
 * <p>End of interval in which the parcel is considered valid.</p><p><i>See valid-from</i></p>
 */
'valid-to'?: string;
/**
 * <p>Date parcel is expected to be valid on. It is mutually exclusive with valid-from and valid-to.</p>
 */
'valid-on'?: string;
/**
 * Filter by parcel land use.
 */
'land-use'?: LandUse[];
/**
 * Filter only parcels with given IDs.
 */
ids?: string[];
/**
 * Filter parcels by zone ID(s) of zones they are in. Use NONE to filter parcels with no zone.
 */
zones?: string[];
/**
 * Filter parcels by center ID(s) of centers they are in. Use NONE to filter parcels with no center.
 */
centers?: string[];
/**
 * Filter parcels by sown crop legislative codes.
 */
crops?: number[];
/**
 * Filter parcels by sown crop id.
 */
'crop-ids'?: string[];
/**
 * Filters parcels by their nitrate vulnerable status.<ul><li>If <b>true</b>, filters only nitrate vulnerable parcels</li><li>If <b>false</b>, filters only nitrate invulnerable parcel</li><li>If <b>null</b>, no nitrate vulnerable filter is applied</li></ul>
 */
'nitrate-vulnerable'?: boolean;
/**
 * Filters parcels by whether they have an active seed application (crop).<ul><li>If <b>true</b>, filters only parcels with an active seed application</li><li>If <b>false</b>, filters only parcels without an active seed application</li><li>If <b>null</b>, no filter is applied</li></ul>
 */
sown?: boolean;
/**
 * Filters parcels by whether a sowing activity has been physically performed.<ul><li>If <b>true</b>, filters only parcels where a sowing action exists for the current seed application</li><li>If <b>false</b>, filters parcels where no sowing action was performed, or no active seed application exists</li><li>If <b>null</b>, no filter is applied</li></ul>
 */
'sowing-performed'?: boolean;
'season-crop'?: string[];
'season-no-crop'?: number[];
'season-crop-type'?: string[];
'shown-crop'?: string[];
'shown-crop-type'?: SeedApplicationType[];
'shown-no-crop'?: boolean;
'shown-season'?: number[];
page?: number;
'per-page'?: number;
'sort-col'?: ParcelV2SortColumn;
'sort-dir'?: SortDirection;
}

export type GetParcelsWithSowingPlansParams = Omit<GetParcelsWithSowingPlansParamsTSMorphBase, "farmIds">;;

type GetSeasonOverviewParamsTSMorphBase = {
farmIds: string;
startYear: number;
}

export type GetSeasonOverviewParams = Omit<GetSeasonOverviewParamsTSMorphBase, "farmIds">;;

type GetCurrentStateOverviewParamsTSMorphBase = {
farmIds: string;
date?: string;
}

export type GetCurrentStateOverviewParams = Omit<GetCurrentStateOverviewParamsTSMorphBase, "farmIds">;;

type GetNitrateBalanceV2ReportParamsTSMorphBase = {
farmIds: string;
year: number;
language: LocalLanguage;
}

export type GetNitrateBalanceV2ReportParams = Omit<GetNitrateBalanceV2ReportParamsTSMorphBase, "farmIds">;;

type GetRestrictionsSowingReportParamsTSMorphBase = {
farmIds: string;
date: string;
'failed-only'?: boolean;
'parcel-ids'?: string[];
seasons?: string;
codes?: string[];
language?: string;
}

export type GetRestrictionsSowingReportParams = Omit<GetRestrictionsSowingReportParamsTSMorphBase, "farmIds">;;

type GetParcelsReportParamsTSMorphBase = {
farmIds: string;
language?: LocalLanguage;
}

export type GetParcelsReportParams = Omit<GetParcelsReportParamsTSMorphBase, "farmIds">;;

type GetReportsParamsTSMorphBase = {
farmIds: string;
type: ReportType;
pageOffset?: number;
pageSize?: number;
sortProperty?: string;
language?: string;
}

export type GetReportsParams = Omit<GetReportsParamsTSMorphBase, "farmIds">;;

type DownloadErrorReportParamsTSMorphBase = {
farmIds: string;
}

export type DownloadErrorReportParams = Omit<DownloadErrorReportParamsTSMorphBase, "farmIds">;;

type DownloadConfirmationParamsTSMorphBase = {
farmIds: string;
}

export type DownloadConfirmationParams = Omit<DownloadConfirmationParamsTSMorphBase, "farmIds">;;

type GetFarmNitrogenReportParamsTSMorphBase = {
farmIds: string;
'date-from': string;
'file-type': FileType;
language?: string;
}

export type GetFarmNitrogenReportParams = Omit<GetFarmNitrogenReportParamsTSMorphBase, "farmIds">;;

type GetCvsReportParamsTSMorphBase = {
farmIds: string;
}

export type GetCvsReportParams = Omit<GetCvsReportParamsTSMorphBase, "farmIds">;;

type GetParcelsParamsTSMorphBase = {
farmIds: string;
language?: string;
/**
 * Filter by parcel name or block number.
 */
search?: string;
/**
 * Filter by parcel status.
 */
status?: ParcelStatus[];
/**
 * <p>Start of interval in which the parcel is considered valid.</p><p>If <b>valid-from</b> and/or <b>valid-to</b> filter is used, it will return parcels that are considered valid inside the given date range. If either <b>valid-from</b> or <b>valid-to</b> is null, the interval is considered open from respective side.<p>
 */
'valid-from'?: string;
/**
 * <p>End of interval in which the parcel is considered valid.</p><p><i>See valid-from</i></p>
 */
'valid-to'?: string;
/**
 * <p>Date parcel is expected to be valid on. It is mutually exclusive with valid-from and valid-to.</p>
 */
'valid-on'?: string;
/**
 * Filter by parcel land use.
 */
'land-use'?: LandUse[];
/**
 * Filter only parcels with given IDs.
 */
ids?: string[];
/**
 * Filter parcels by zone ID(s) of zones they are in. Use NONE to filter parcels with no zone.
 */
zones?: string[];
/**
 * Filter parcels by center ID(s) of centers they are in. Use NONE to filter parcels with no center.
 */
centers?: string[];
/**
 * Filter parcels by sown crop legislative codes.
 */
crops?: number[];
/**
 * Filter parcels by sown crop id.
 */
'crop-ids'?: string[];
/**
 * Filters parcels by their nitrate vulnerable status.<ul><li>If <b>true</b>, filters only nitrate vulnerable parcels</li><li>If <b>false</b>, filters only nitrate invulnerable parcel</li><li>If <b>null</b>, no nitrate vulnerable filter is applied</li></ul>
 */
'nitrate-vulnerable'?: boolean;
/**
 * Filters parcels by whether they have an active seed application (crop).<ul><li>If <b>true</b>, filters only parcels with an active seed application</li><li>If <b>false</b>, filters only parcels without an active seed application</li><li>If <b>null</b>, no filter is applied</li></ul>
 */
sown?: boolean;
/**
 * Filters parcels by whether a sowing activity has been physically performed.<ul><li>If <b>true</b>, filters only parcels where a sowing action exists for the current seed application</li><li>If <b>false</b>, filters parcels where no sowing action was performed, or no active seed application exists</li><li>If <b>null</b>, no filter is applied</li></ul>
 */
'sowing-performed'?: boolean;
pageOffset?: number;
pageSize?: number;
sortProperty?: string;
}

export type GetParcelsParams = Omit<GetParcelsParamsTSMorphBase, "farmIds">;;

type GetParcelSubtractionHistoryParamsTSMorphBase = {
farmIds: string;
otherParcels: string[];
'valid-date'?: string;
}

export type GetParcelSubtractionHistoryParams = Omit<GetParcelSubtractionHistoryParamsTSMorphBase, "farmIds">;;

type DeleteParcelSubtractionParamsTSMorphBase = {
farmIds: string;
type: RestrictionType;
value: number;
}

export type DeleteParcelSubtractionParams = Omit<DeleteParcelSubtractionParamsTSMorphBase, "farmIds">;;

type GetParcelPlannedCropParamsTSMorphBase = {
farmIds: string;
}

export type GetParcelPlannedCropParams = Omit<GetParcelPlannedCropParamsTSMorphBase, "farmIds">;;

type GetParcelPredecessorsParamsTSMorphBase = {
farmIds: string;
}

export type GetParcelPredecessorsParams = Omit<GetParcelPredecessorsParamsTSMorphBase, "farmIds">;;

type GetParcelFollowingParamsTSMorphBase = {
farmIds: string;
}

export type GetParcelFollowingParams = Omit<GetParcelFollowingParamsTSMorphBase, "farmIds">;;

type GetExchangeCandidatesParamsTSMorphBase = {
farmIds: string;
language?: string;
'at-date'?: string;
}

export type GetExchangeCandidatesParams = Omit<GetExchangeCandidatesParamsTSMorphBase, "farmIds">;;

type GetParcelRestrictionsParamsTSMorphBase = {
farmIds: string;
}

export type GetParcelRestrictionsParams = Omit<GetParcelRestrictionsParamsTSMorphBase, "farmIds">;;

type GetWaterParcelDistanceParamsTSMorphBase = {
farmIds: string;
'parcel-ids': string[];
}

export type GetWaterParcelDistanceParams = Omit<GetWaterParcelDistanceParamsTSMorphBase, "farmIds">;;

type GetParcelsV2ParamsTSMorphBase = {
farmIds: string;
language?: string;
/**
 * Filter by parcel name or block number.
 */
search?: string;
/**
 * Filter by parcel status.
 */
status?: ParcelStatus[];
/**
 * <p>Start of interval in which the parcel is considered valid.</p><p>If <b>valid-from</b> and/or <b>valid-to</b> filter is used, it will return parcels that are considered valid inside the given date range. If either <b>valid-from</b> or <b>valid-to</b> is null, the interval is considered open from respective side.<p>
 */
'valid-from'?: string;
/**
 * <p>End of interval in which the parcel is considered valid.</p><p><i>See valid-from</i></p>
 */
'valid-to'?: string;
/**
 * <p>Date parcel is expected to be valid on. It is mutually exclusive with valid-from and valid-to.</p>
 */
'valid-on'?: string;
/**
 * Filter by parcel land use.
 */
'land-use'?: LandUse[];
/**
 * Filter only parcels with given IDs.
 */
ids?: string[];
/**
 * Filter parcels by zone ID(s) of zones they are in. Use NONE to filter parcels with no zone.
 */
zones?: string[];
/**
 * Filter parcels by center ID(s) of centers they are in. Use NONE to filter parcels with no center.
 */
centers?: string[];
/**
 * Filter parcels by sown crop legislative codes.
 */
crops?: number[];
/**
 * Filter parcels by sown crop id.
 */
'crop-ids'?: string[];
/**
 * Filters parcels by their nitrate vulnerable status.<ul><li>If <b>true</b>, filters only nitrate vulnerable parcels</li><li>If <b>false</b>, filters only nitrate invulnerable parcel</li><li>If <b>null</b>, no nitrate vulnerable filter is applied</li></ul>
 */
'nitrate-vulnerable'?: boolean;
/**
 * Filters parcels by whether they have an active seed application (crop).<ul><li>If <b>true</b>, filters only parcels with an active seed application</li><li>If <b>false</b>, filters only parcels without an active seed application</li><li>If <b>null</b>, no filter is applied</li></ul>
 */
sown?: boolean;
/**
 * Filters parcels by whether a sowing activity has been physically performed.<ul><li>If <b>true</b>, filters only parcels where a sowing action exists for the current seed application</li><li>If <b>false</b>, filters parcels where no sowing action was performed, or no active seed application exists</li><li>If <b>null</b>, no filter is applied</li></ul>
 */
'sowing-performed'?: boolean;
page?: number;
'per-page'?: number;
'sort-col'?: ParcelV2SortColumn;
'sort-dir'?: SortDirection;
}

export type GetParcelsV2Params = Omit<GetParcelsV2ParamsTSMorphBase, "farmIds">;;

type GetParcelDetailV2ParamsTSMorphBase = {
farmIds: string;
language?: string;
}

export type GetParcelDetailV2Params = Omit<GetParcelDetailV2ParamsTSMorphBase, "farmIds">;;

type GetSeedApplicationsV2ParamsTSMorphBase = {
farmIds: string;
language?: string;
}

export type GetSeedApplicationsV2Params = Omit<GetSeedApplicationsV2ParamsTSMorphBase, "farmIds">;;

type GetActionsV2ParamsTSMorphBase = {
farmIds: string;
language?: string;
'seedApplication-ids'?: string[];
'action-types'?: ActionType[];
'date-from'?: string;
'date-to'?: string;
'material-type'?: MaterialType;
'material-ids'?: string[];
'seed-crop-ids'?: string[];
sources?: ActionSource[];
'is-draft'?: boolean;
'has-parcel-outside-validity'?: boolean;
'has-parcel-outside-seed-application'?: boolean;
pageOffset?: number;
pageSize?: number;
sortProperty?: string;
}

export type GetActionsV2Params = Omit<GetActionsV2ParamsTSMorphBase, "farmIds">;;

type GetParcelStatisticsV2ParamsTSMorphBase = {
farmIds: string;
language?: string;
date?: string;
}

export type GetParcelStatisticsV2Params = Omit<GetParcelStatisticsV2ParamsTSMorphBase, "farmIds">;;

type GetParcelMapDataV2ParamsTSMorphBase = {
farmIds: string;
language?: string;
date?: string;
}

export type GetParcelMapDataV2Params = Omit<GetParcelMapDataV2ParamsTSMorphBase, "farmIds">;;

type GetParcelMapDataBySeasonV2ParamsTSMorphBase = {
farmIds: string;
startYear: number;
date?: string;
language?: string;
}

export type GetParcelMapDataBySeasonV2Params = Omit<GetParcelMapDataBySeasonV2ParamsTSMorphBase, "farmIds">;;

type GetParcelSuggestionsParamsTSMorphBase = {
farmIds: string;
/**
 * Filter by parcel name or block number.
 */
search?: string;
/**
 * Filter by parcel status.
 */
status?: ParcelStatus[];
/**
 * <p>Start of interval in which the parcel is considered valid.</p><p>If <b>valid-from</b> and/or <b>valid-to</b> filter is used, it will return parcels that are considered valid inside the given date range. If either <b>valid-from</b> or <b>valid-to</b> is null, the interval is considered open from respective side.<p>
 */
'valid-from'?: string;
/**
 * <p>End of interval in which the parcel is considered valid.</p><p><i>See valid-from</i></p>
 */
'valid-to'?: string;
/**
 * <p>Date parcel is expected to be valid on. It is mutually exclusive with valid-from and valid-to.</p>
 */
'valid-on'?: string;
/**
 * Filter by parcel land use.
 */
'land-use'?: LandUse[];
/**
 * Filter only parcels with given IDs.
 */
ids?: string[];
/**
 * Filter parcels by zone ID(s) of zones they are in. Use NONE to filter parcels with no zone.
 */
zones?: string[];
/**
 * Filter parcels by center ID(s) of centers they are in. Use NONE to filter parcels with no center.
 */
centers?: string[];
/**
 * Filter parcels by sown crop legislative codes.
 */
crops?: number[];
/**
 * Filter parcels by sown crop id.
 */
'crop-ids'?: string[];
/**
 * Filters parcels by their nitrate vulnerable status.<ul><li>If <b>true</b>, filters only nitrate vulnerable parcels</li><li>If <b>false</b>, filters only nitrate invulnerable parcel</li><li>If <b>null</b>, no nitrate vulnerable filter is applied</li></ul>
 */
'nitrate-vulnerable'?: boolean;
/**
 * Filters parcels by whether they have an active seed application (crop).<ul><li>If <b>true</b>, filters only parcels with an active seed application</li><li>If <b>false</b>, filters only parcels without an active seed application</li><li>If <b>null</b>, no filter is applied</li></ul>
 */
sown?: boolean;
/**
 * Filters parcels by whether a sowing activity has been physically performed.<ul><li>If <b>true</b>, filters only parcels where a sowing action exists for the current seed application</li><li>If <b>false</b>, filters parcels where no sowing action was performed, or no active seed application exists</li><li>If <b>null</b>, no filter is applied</li></ul>
 */
'sowing-performed'?: boolean;
}

export type GetParcelSuggestionsParams = Omit<GetParcelSuggestionsParamsTSMorphBase, "farmIds">;;

export type GetLandUseParams = {
language?: string;
};

type GetParcelCurrentSeedApplicationsParamsTSMorphBase = {
farmIds: string;
}

export type GetParcelCurrentSeedApplicationsParams = Omit<GetParcelCurrentSeedApplicationsParamsTSMorphBase, "farmIds">;;

type GetCentersParamsTSMorphBase = {
farmIds: string;
search?: string;
}

export type GetCentersParams = Omit<GetCentersParamsTSMorphBase, "farmIds">;;

type GetActionsAndSeedAppsAtDetailParamsTSMorphBase = {
farmIds: string;
'parcel-id': string;
language: LocalLanguage;
'date-from'?: string;
'date-to'?: string;
'material-ids'?: string[];
'is-draft'?: boolean;
sources?: ActionSource[];
'target-crop-ids'?: string[];
'action-types'?: ActionType[];
pageOffset?: number;
pageSize?: number;
sortProperty?: string;
}

export type GetActionsAndSeedAppsAtDetailParams = Omit<GetActionsAndSeedAppsAtDetailParamsTSMorphBase, "farmIds">;;

type GetFarmUpdatesParamsTSMorphBase = {
farmIds: string;
pageOffset?: number;
pageSize?: number;
sortProperty?: string;
language?: string;
}

export type GetFarmUpdatesParams = Omit<GetFarmUpdatesParamsTSMorphBase, "farmIds">;;

type GetFullLpisDetailParamsTSMorphBase = {
farmIds: string;
validFrom?: string;
}

export type GetFullLpisDetailParams = Omit<GetFullLpisDetailParamsTSMorphBase, "farmIds">;;

export type SearchCountriesParams = {
search?: string;
language?: string;
};

type GetCataloguesParamsTSMorphBase = {
farmIds: string;
}

export type GetCataloguesParams = Omit<GetCataloguesParamsTSMorphBase, "farmIds">;;

type GetSeedSuggestionsParamsTSMorphBase = {
farmIds: string;
/**
 * Catalog localization language
 */
language?: string;
/**
 * Filter by crop name
 */
search?: string;
/**
 * Set catalogue type
 */
catalogue?: CatalogueType;
/**
 * Include hidden seeds
 */
'include-hidden'?: boolean;
/**
 * Filter by crop external id
 */
'external-ids'?: string[];
/**
 * Filter seeds by internal crop id (catalogue-agnostic)
 */
'crop-ids'?: string[];
/**
 * Seed validity end
 */
'valid-on'?: string;
/**
 * If true, returns only favorite fertilizers
 */
'favorite-only'?: boolean;
/**
 * Filter by crop group id
 */
'crop-group-ids'?: string[];
/**
 * Filter by lifespan (ANNUAL / PERENNIAL)
 */
lifespan?: CropLifespan;
/**
 * Filter by growing period (SPRING / WINTER). Multi-select uses OR — a crop matches if any of the listed periods applies.
 */
'growing-periods'?: GrowingPeriod[];
/**
 * Filter seeds whose crop maps any of the given crop use types
 */
'use-type-ids'?: string[];
/**
 * Filter seeds whose crop has any of the given products mapped as main (CropProduct.isMain = true).
 */
'main-product-ids'?: string[];
/**
 * Filter seeds whose crop has any of the given products mapped as secondary product (CropProduct.isMain = false).
 */
'secondary-product-ids'?: string[];
}

export type GetSeedSuggestionsParams = Omit<GetSeedSuggestionsParamsTSMorphBase, "farmIds">;;

type GetCropsCatalogSourceParamsTSMorphBase = {
farmIds: string;
}

export type GetCropsCatalogSourceParams = Omit<GetCropsCatalogSourceParamsTSMorphBase, "farmIds">;;

type GetPlantProtectionDetailParamsTSMorphBase = {
farmIds: string;
}

export type GetPlantProtectionDetailParams = Omit<GetPlantProtectionDetailParamsTSMorphBase, "farmIds">;;

type GetPlantProtectionDetailRegistrationsParamsTSMorphBase = {
farmIds: string;
language: LocalLanguage;
'only-valid'?: boolean;
}

export type GetPlantProtectionDetailRegistrationsParams = Omit<GetPlantProtectionDetailRegistrationsParamsTSMorphBase, "farmIds">;;

type GetPlantProtectionDetailApplicationRowsParamsTSMorphBase = {
farmIds: string;
language: LocalLanguage;
search?: string;
pageOffset?: number;
pageSize?: number;
sortProperty?: string;
}

export type GetPlantProtectionDetailApplicationRowsParams = Omit<GetPlantProtectionDetailApplicationRowsParamsTSMorphBase, "farmIds">;;

type GetPlantProtectionDetailApplicationsParamsTSMorphBase = {
farmIds: string;
language: LocalLanguage;
}

export type GetPlantProtectionDetailApplicationsParams = Omit<GetPlantProtectionDetailApplicationsParamsTSMorphBase, "farmIds">;;

type GetPlantProtectionApplicationSectionsParamsTSMorphBase = {
farmIds: string;
language: LocalLanguage;
}

export type GetPlantProtectionApplicationSectionsParams = Omit<GetPlantProtectionApplicationSectionsParamsTSMorphBase, "farmIds">;;

type GetPlantProtectionApplicationsParamsTSMorphBase = {
farmIds: string;
language: LocalLanguage;
cropGrowthStage?: CropGrowthStage;
}

export type GetPlantProtectionApplicationsParams = Omit<GetPlantProtectionApplicationsParamsTSMorphBase, "farmIds">;;

type GetPlantProtectionSuggestionsParamsTSMorphBase = {
farmIds: string;
/**
 * Set of crop ids
 */
'crop-id'?: string[];
/**
 * Returns all plant protections that are usable after given date
 */
'usable-until'?: string;
/**
 * Filter by plant protection name
 */
search?: string;
pageOffset?: number;
pageSize?: number;
sortProperty?: string;
language?: string;
}

export type GetPlantProtectionSuggestionsParams = Omit<GetPlantProtectionSuggestionsParamsTSMorphBase, "farmIds">;;

type GetPlantProtectionsParamsTSMorphBase = {
farmIds: string;
language?: string;
/**
 * Filter by plant protection product name
 */
search?: string;
/**
 * Set of catalogue ids
 */
catalogue?: string[];
/**
 * Include hidden plant protection products
 */
'include-hidden'?: boolean;
/**
 * Plant protection usability end
 */
'usable-until'?: string;
/**
 * If true, returns only favorite plant protection products
 */
'favorite-only'?: boolean;
'crop-id'?: string[];
'organism-id'?: string[];
'active-substance-id'?: string[];
pageOffset?: number;
pageSize?: number;
sortProperty?: string;
}

export type GetPlantProtectionsParams = Omit<GetPlantProtectionsParamsTSMorphBase, "farmIds">;;

export type GetPlantProtectionSyncReportsParams = {
pageOffset?: number;
pageSize?: number;
sortProperty?: string;
language?: string;
};

export type GetReportWarningsParams = {
warningType?: SyncWarningType;
pageOffset?: number;
pageSize?: number;
sortProperty?: string;
language?: string;
};

export type GetReportProductStatsParams = {
productName?: string;
pageOffset?: number;
pageSize?: number;
sortProperty?: string;
language?: string;
};

type GetBioFunctionParamsTSMorphBase = {
farmIds: string;
search?: string;
}

export type GetBioFunctionParams = Omit<GetBioFunctionParamsTSMorphBase, "farmIds">;;

type GetFertilizerMineralIntakeParamsTSMorphBase = {
farmIds: string;
unitId: string;
dose: number;
}

export type GetFertilizerMineralIntakeParams = Omit<GetFertilizerMineralIntakeParamsTSMorphBase, "farmIds">;;

type GetFertilizerSuggestionsParamsTSMorphBase = {
farmIds: string;
/**
 * Filter by fertilizer name
 */
search?: string;
/**
 * Set catalogue type
 */
catalogue?: CatalogueType;
/**
 * Include hidden fertilizers
 */
'include-hidden'?: boolean;
/**
 * Filter by fertilizer external id
 */
'external-ids'?: string[];
/**
 * Filter by fertilizer organic flag
 */
organic?: boolean;
/**
 * Filter by eAgri fertilizer nitrogen category type
 */
'eagri-nitrogen-category'?: EagriFertilizerNitrogenCategory[];
/**
 * Fertilizer validity end
 */
'valid-on'?: string;
/**
 * If true, returns only favorite fertilizers
 */
'favorite-only'?: boolean;
}

export type GetFertilizerSuggestionsParams = Omit<GetFertilizerSuggestionsParamsTSMorphBase, "farmIds">;;

export type GetFertilizerRegistratinTypeParams = {
language?: LocalLanguage;
};

export type GetFertilizerNitrogenCategoryParams = {
language?: LocalLanguage;
};

type GetCropParamsTSMorphBase = {
farmIds: string;
'sort-col'?: GetCropSortCol;
'sort-dir'?: GetCropSortDir;
}

export type GetCropParams = Omit<GetCropParamsTSMorphBase, "farmIds">;;

export type GetCropSortCol = typeof GetCropSortCol[keyof typeof GetCropSortCol];


export const GetCropSortCol = {
  productName: 'productName',
  isMainProduct: 'isMainProduct',
} as const;

export type GetCropSortDir = typeof GetCropSortDir[keyof typeof GetCropSortDir];


export const GetCropSortDir = {
  asc: 'asc',
  desc: 'desc',
} as const;

type ExportCropsToCSVParamsTSMorphBase = {
farmIds: string;
}

export type ExportCropsToCSVParams = Omit<ExportCropsToCSVParamsTSMorphBase, "farmIds">;;

type GetFarmStatisticsParamsTSMorphBase = {
farmIds: string;
}

export type GetFarmStatisticsParams = Omit<GetFarmStatisticsParamsTSMorphBase, "farmIds">;;

export type GetAllFarmsParams = {
name?: string;
search?: string;
pageOffset?: number;
pageSize?: number;
sortProperty?: string;
language?: string;
};

export type GetAdminFullLpisDetailParams = {
validFrom?: string;
};

type GetActionV2ParamsTSMorphBase = {
farmIds: string;
language?: string;
}

export type GetActionV2Params = Omit<GetActionV2ParamsTSMorphBase, "farmIds">;;

type GetTargetSeedApplicationParamsTSMorphBase = {
farmIds: string;
'target-crop-id': string;
'action-date': string;
'parcel-Ids': string[];
'except-action-id'?: string;
language: LocalLanguage;
}

export type GetTargetSeedApplicationParams = Omit<GetTargetSeedApplicationParamsTSMorphBase, "farmIds">;;

type GetActionsOverviewV2ParamsTSMorphBase = {
farmIds: string;
language?: string;
search?: string;
'parcel-Ids'?: string[];
'date-from'?: string;
'date-to'?: string;
'target-crop-ids'?: string[];
'seed-crop-ids'?: string[];
'material-type'?: MaterialType;
'action-types'?: ActionType[];
'material-ids'?: string[];
'action-sources'?: ActionSource[];
'is-draft'?: boolean;
'has-parcel-outside-validity'?: boolean;
'has-parcel-outside-seed-application'?: boolean;
'facility-ids'?: string[];
'sort-col'?: ActionV2SortColumn;
'sort-dir'?: SortDirection;
pageOffset?: number;
pageSize?: number;
sortProperty?: string;
}

export type GetActionsOverviewV2Params = Omit<GetActionsOverviewV2ParamsTSMorphBase, "farmIds">;;

type GetUsedSeedsParamsTSMorphBase = {
farmIds: string;
search?: string;
language: LocalLanguage;
}

export type GetUsedSeedsParams = Omit<GetUsedSeedsParamsTSMorphBase, "farmIds">;;

type GetUsedPlantProtectionsParamsTSMorphBase = {
farmIds: string;
search?: string;
}

export type GetUsedPlantProtectionsParams = Omit<GetUsedPlantProtectionsParamsTSMorphBase, "farmIds">;;

type GetUsedFertilizersParamsTSMorphBase = {
farmIds: string;
'include-hidden'?: boolean;
search?: string;
}

export type GetUsedFertilizersParams = Omit<GetUsedFertilizersParamsTSMorphBase, "farmIds">;;

export type GetCropGrowthStagesParams = {
language: LocalLanguage;
};

export type GetActionTypesParams = {
language?: string;
group?: ActionTypeGroupTo;
};

type RemoveFromGroupParamsTSMorphBase = {
farmIds: string;
}

export type RemoveFromGroupParams = Omit<RemoveFromGroupParamsTSMorphBase, "farmIds">;;

type DeleteProductFromCropUseParamsTSMorphBase = {
farmIds: string;
}

export type DeleteProductFromCropUseParams = Omit<DeleteProductFromCropUseParamsTSMorphBase, "farmIds">;;

export type DeleteProductFromCropUse204 = { [key: string]: unknown };

export type DeleteProductFromCropUse403 = { [key: string]: unknown };

export type DeleteProductFromCropUse404 = { [key: string]: unknown };

type DeleteActionsParamsTSMorphBase = {
actionIds: string[];
farmIds: string;
}

export type DeleteActionsParams = Omit<DeleteActionsParamsTSMorphBase, "farmIds">;;

type DeleteActionParamsTSMorphBase = {
farmIds: string;
}

export type DeleteActionParams = Omit<DeleteActionParamsTSMorphBase, "farmIds">;;

/**
 * @summary Updates centers (batch)
 */
export const updateCenters = (
    internalCenterCreateTo: InternalCenterCreateTo[],
    params: UpdateCentersParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<InternalCenterTo[]>> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/parcels/centers`,
      internalCenterCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Updates an existing seed parcel lifecycle. Only provided fields will be updated.
 * @summary Update seed parcel lifecycle
 */
export const updateSeedApplicationV2 = (
    id: string,
    seedApplicationV2UpdateTo: SeedApplicationV2UpdateTo,
    params: UpdateSeedApplicationV2Params, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SeedApplicationV2To>> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/v2/seed-applications/${id}`,
      seedApplicationV2UpdateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Deletes an existing seed parcel lifecycle.
 * @summary Delete seed parcel lifecycle
 */
export const deleteSeedApplicationV2 = (
    id: string,
    params: DeleteSeedApplicationV2Params, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `${window.ENV.AGROEVIDENCE_URL}/api/v2/seed-applications/${id}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Updates a seed application group. The request defines the desired state of the group:
 *
 * - **Members in request** = kept in group (or added if new), with optional attribute updates
 * - **Members in request with deleted=true** = permanently deleted
 * - **Existing members NOT in request** = automatically removed from group (kept as standalone)
 *
 * Supports:
 * - Updating common fields (seedId, cropUseTypeId, isCatchCrop, mainHarvestableProduct) for all members
 * - Updating individual fields (dates, area) per member
 * - Use groupId field for orphan cleanup when moving member from another group
 *
 * Returns null if the group was disbanded (less than 2 members remain after update).
 * @summary Update seed application group
 */
export const updateSeedApplicationV2Group = (
    groupId: string,
    seedApplicationV2GroupUpdateTo: SeedApplicationV2GroupUpdateTo,
    params: UpdateSeedApplicationV2GroupParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SeedApplicationV2GroupToV2>> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/v2/seed-applications/groups/${groupId}`,
      seedApplicationV2GroupUpdateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Sets group_id to NULL for ALL seed applications that share the specified groupId. This effectively dissolves the group, leaving all members as individual seed applications.
 * @summary Disband an entire group
 */
export const disbandGroup = (
    groupId: string,
    params: DisbandGroupParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `${window.ENV.AGROEVIDENCE_URL}/api/v2/seed-applications/groups/${groupId}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 *
 *             Updates parcels from shapefile with parcel historization.
 *
 *             It is advised to use /dry and check how the parcels will be retired beforehand as it is not rollback-able.
 *             Does not work with CZ farms or farms with active integration.
 *             Can be used for partial update - shapefile can contain one parcel that needs to be updated and the rest will stay the same.
 * @summary Updates parcels from shapefile with parcel historization.
 */
export const updateFarmFromShapefile = (
    params: UpdateFarmFromShapefileParams,
    updateFarmFromShapefileBody?: UpdateFarmFromShapefileBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/farms/shapefile`,
      updateFarmFromShapefileBody,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 *
 *             Validates eAgri credentials for the farm.
 *             If validation is successful, returns farm name from eAgri, otherwise returns error message and status.
 *             In any case, returns farm szrid and login, if they are stored. Secret (WS key) is never returned in the response.
 * @summary Returns farm eAgri credentials
 */
export const getEagriAuth = (
    farmId: string,
    params?: GetEagriAuthParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EagriAuthDataValidationResponseTo>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/farms/settings/${farmId}/eagri-auth`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 *
 *             Validates eAgri credentials for the farm and stores them if validation is successful.
 * @summary Validas and stores farm eAgri credentials
 */
export const putEagriAuth = (
    farmId: string,
    eagriAuthDataValidationRequestTo: EagriAuthDataValidationRequestTo, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EagriAuthDataValidationResponseTo>> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/farms/settings/${farmId}/eagri-auth`,
      eagriAuthDataValidationRequestTo,options
    );
  }

/**
 *
 *             Updates a farm using eAGRI service. Farms created using SHP or empty foreign farms are not allowed to use this endpoint.
 *             At most one concurrent update per farm is permitted.
 *
 *             Farm update also automatically synchronizes eAGRI catalogues. If you wish to turn off this behaviour,
 *             set request parameter sync-catalogues to false.
 *
 *             Note that update logic itself, i.e. logic beyond concurrency and eligibility checks, is asynchronous.
 *             If you wish to see current update status, use /api/farms/updated.
 * @summary Updates a farm using eAGRI webservices.
 */
export const updateFarm = (
    farmId: string,
    eagriUpdateRequestBody?: EagriUpdateRequestBody,
    params?: UpdateFarmParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/farms/eagri/${farmId}`,
      eagriUpdateRequestBody,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Returns a farm facility
 */
export const getFacility = (
    facilityId: string,
    params: GetFacilityParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FacilityTo>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/facilities/${facilityId}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * A used facility (isUsed) can only be renamed; the rename shows on all its actions.
 * @summary Updates a farm facility
 */
export const updateFacility = (
    facilityId: string,
    facilityUpdateTo: FacilityUpdateTo,
    params: UpdateFacilityParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FacilityTo>> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/facilities/${facilityId}`,
      facilityUpdateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Only a facility without actions (isUsed = false) can be deleted.
 * @summary Deletes a farm facility
 */
export const deleteFacility = (
    facilityId: string,
    params: DeleteFacilityParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `${window.ENV.AGROEVIDENCE_URL}/api/facilities/${facilityId}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Updates plant protection product in PRIVATE catalogue.
 * @summary Update plant protection
 */
export const putPlantProtection = (
    plantProtectionId: string,
    plantProtectionCreateUpdateTo: PlantProtectionCreateUpdateTo,
    params: PutPlantProtectionParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PlantProtectionDetailTo>> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protections/${plantProtectionId}`,
      plantProtectionCreateUpdateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Updates plant protection product in PRIVATE catalogue.
 * @summary Update plant protection
 */
export const patchPlantProtection = (
    plantProtectionId: string,
    plantProtectionPatchTo: PlantProtectionPatchTo,
    params: PatchPlantProtectionParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.patch(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protections/${plantProtectionId}`,
      plantProtectionPatchTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Update a registration on a private POR
 */
export const updateRegistration = (
    plantProtectionId: string,
    registrationId: string,
    plantProtectionRegistrationCreateUpdateTo: PlantProtectionRegistrationCreateUpdateTo,
    params: UpdateRegistrationParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PlantProtectionRegistrationTo>> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protections/${plantProtectionId}/registrations/${registrationId}`,
      plantProtectionRegistrationCreateUpdateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Updates header fields and active substances of a PRIVATE plant protection product. Returns the new detail DTO.
 * @summary Update plant protection header (new detail editing)
 */
export const updatePlantProtectionHeader = (
    plantProtectionId: string,
    plantProtectionCreateUpdateTo: PlantProtectionCreateUpdateTo,
    params: UpdatePlantProtectionHeaderParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PlantProtectionDetailTo>> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protections/${plantProtectionId}/header`,
      plantProtectionCreateUpdateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Update plant protection application
 */
export const putPlantProtectionRegistrationApplication = (
    plantProtectionId: string,
    applicationId: string,
    plantProtectionApplicationCreateTo: PlantProtectionApplicationCreateTo,
    params: PutPlantProtectionRegistrationApplicationParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protections/${plantProtectionId}/applications/${applicationId}`,
      plantProtectionApplicationCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Delete plant protection application
 */
export const deletePlantProtectionRegistrationApplication = (
    plantProtectionId: string,
    applicationId: string,
    params: DeletePlantProtectionRegistrationApplicationParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protections/${plantProtectionId}/applications/${applicationId}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns fertilizer detail.
 * @summary Fertilizer detail
 */
export const getFertilizer = (
    fertilizerId: string,
    params: GetFertilizerParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FertilizerDetailTo>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/fertilizers/${fertilizerId}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Update fertilizer
 */
export const putFertilizer = (
    fertilizerId: string,
    fertilizerCreateTo: FertilizerCreateTo,
    params: PutFertilizerParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FertilizerDetailTo>> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/fertilizers/${fertilizerId}`,
      fertilizerCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Hidden fertilizers are not deleted, and can be un-hidden by PUT request.
 * @summary Hides fertilizer
 */
export const hideFertilizer = (
    fertilizerId: string,
    fertilizerPatchTo: FertilizerPatchTo,
    params: HideFertilizerParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FertilizerDetailTo>> => {
    return axios.patch(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/fertilizers/${fertilizerId}`,
      fertilizerPatchTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const updateCropProducts = (
    cropId: string,
    cropProductUseTypeUpdateTo: CropProductUseTypeUpdateTo[],
    params: UpdateCropProductsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/crops/${cropId}/products`,
      cropProductUseTypeUpdateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const putCropProduct = (
    id: string,
    cropProductUpdateTo: CropProductUpdateTo,
    params: PutCropProductParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CropProductTo>> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/crops/products/${id}`,
      cropProductUpdateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const putCropUseType = (
    id: string,
    cropUseTypeUpdateTo: CropUseTypeUpdateTo,
    params: PutCropUseTypeParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CropUseTypeTo>> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/crops/crop-use/${id}`,
      cropUseTypeUpdateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Update a farm private crop group
 */
export const putCropGroup = (
    id: string,
    cropGroupUpdateTo: CropGroupUpdateTo,
    params: PutCropGroupParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CropGroupResponseTo>> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/crops/crop-groups/${id}`,
      cropGroupUpdateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Deleting a group that is still assigned to crops is allowed; those crops keep existing and lose the group assignment.
 * @summary Delete a farm private crop group
 */
export const deleteCropGroup = (
    id: string,
    params: DeleteCropGroupParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/crops/crop-groups/${id}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const updateSkeagisFarm = (
    params: UpdateSkeagisFarmParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SkeagisFarmUpdateResult>> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/management/farm/update-skeagis-farm`,
      undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns detail of a farm user is authorized.
 * @summary Returns farm detail
 */
export const getAdminFarmDetail = (
    farmId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AdminFarmTo>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/farms/${farmId}`,options
    );
  }

/**
 * @summary Update farm
 */
export const putFarm = (
    farmId: string,
    adminFarmUpdateTo: AdminFarmUpdateTo, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AdminFarmTo>> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/farms/${farmId}`,
      adminFarmUpdateTo,options
    );
  }

/**
 * Sets is_deleted=true on the farm. Requires areYouSure=true confirmation query parameter. With areYouSure=false the endpoint runs all dependency checks as a dry-run - same 409/503/404 responses, but returns 204 No Content on success without modifying anything. Returns 200 with the soft-deleted farm if areYouSure=true.
 * @summary Soft-delete farm
 */
export const deleteFarm = (
    farmId: string,
    params: DeleteFarmParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AdminFarmTo>> => {
    return axios.delete(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/farms/${farmId}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const updateFarmCurrentParcels = (
    farmId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/farms/${farmId}/eagri/current-parcels`,
      undefined,options
    );
  }

export const updateAllFarmsCurrentParcels = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/farms/eagri/current-parcels`,
      undefined,options
    );
  }

export const resaveActionStoreTransactions = (
    params: ResaveActionStoreTransactionsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/farms/actions/resave-stores`,
      undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const updateSkeagisState = (
    farmSkeagisUpdateRequest: FarmSkeagisUpdateRequest,
    params: UpdateSkeagisStateParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FarmIntegrationResponse>> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/farm/integrations/skeagis`,
      farmSkeagisUpdateRequest,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const createNewSkeagisIntegration = (
    farmSkeagisCreateRequest: FarmSkeagisCreateRequest,
    params: CreateNewSkeagisIntegrationParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FarmIntegrationResponse>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/farm/integrations/skeagis`,
      farmSkeagisCreateRequest,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Resets the fetch counters, so the scenario applies from the next submission onwards.
 * @summary Sets what the mocked eAgri answers to the next submission and its evaluation fetches.
 */
export const setScenario = (
    eagriReportMockScenarioTo: EagriReportMockScenarioTo, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EagriReportMockStateTo>> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/eagri-reports/mock/scenario`,
      eagriReportMockScenarioTo,options
    );
  }

/**
 * @summary Restores the default scenario: accepted submission, evaluated OK on the first fetch.
 */
export const resetScenario = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EagriReportMockStateTo>> => {
    return axios.delete(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/eagri-reports/mock/scenario`,options
    );
  }

/**
 * Updates an existing sowing action using seed_application_v2. Automatically updates seed application V2 records based on date and parcel.
 * @summary Update sowing action (V2)
 */
export const updateSowingAction = (
    actionId: string,
    actionSowingCreateV2To: ActionSowingCreateV2To,
    params: UpdateSowingActionParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ActionIdTo>> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/v2/sowing/${actionId}`,
      actionSowingCreateV2To,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Updates an action that has no dedicated endpoint (e.g. plow, tillage, disking).
 * @summary Update other action (V2)
 */
export const updateOtherAction = (
    actionId: string,
    actionOtherCreateTo: ActionOtherCreateTo,
    params: UpdateOtherActionParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ActionIdTo>> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/v2/other/${actionId}`,
      actionOtherCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Updates a non-field plant protection action. A field action cannot be turned into a non-field one and vice versa.
 * @summary Update non-field plant protection action
 */
export const updateNonFieldAction = (
    actionId: string,
    actionNonFieldCreateTo: ActionNonFieldCreateTo,
    params: UpdateNonFieldActionParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ActionIdTo>> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/v2/non-field/${actionId}`,
      actionNonFieldCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Updates an existing mowing action using seed_application_v2. Works with existing seed application V2 records based on date and parcel.
 * @summary Update mowing action (V2)
 */
export const updateMowingAction = (
    actionId: string,
    actionMowingCreateV2To: ActionMowingCreateV2To,
    params: UpdateMowingActionParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ActionIdTo>> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/v2/mowing/${actionId}`,
      actionMowingCreateV2To,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Updates an existing harvest action using seed_application_v2. Automatically manages seed application V2 records based on date and parcel.
 * @summary Update harvest action (V2)
 */
export const updateHarvestAction = (
    actionId: string,
    actionHarvestCreateV2To: ActionHarvestCreateV2To,
    params: UpdateHarvestActionParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ActionIdTo>> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/v2/harvest/${actionId}`,
      actionHarvestCreateV2To,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Updates an existing EPH action using seed_application_v2. Accepts targetCropId for form compatibility, but target crop is determined by date and parcel.
 * @summary Update EPH action (V2)
 */
export const updateEPHAction = (
    actionId: string,
    actionEPHCreateV2To: ActionEPHCreateV2To,
    params: UpdateEPHActionParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ActionIdTo>> => {
    return axios.put(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/v2/eph/${actionId}`,
      actionEPHCreateV2To,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Shows and sets what the mocked eAgri answers to the next submission.
 * @summary eAgri report mock
 */
export const getDebugPage = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/internal/web/eagri-report-mock`,{
        responseType: 'text',
    ...options,}
    );
  }

/**
 * @summary Applies the scenario from the form.
 */
export const setScenario1 = (
    setScenario1Body?: SetScenario1Body, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {const formUrlEncoded = new URLSearchParams();
if(setScenario1Body?.submission !== undefined) {
 formUrlEncoded.append(`submission`, setScenario1Body.submission);
 }
if(setScenario1Body?.pollFailuresBeforeAnswer !== undefined) {
 formUrlEncoded.append(`pollFailuresBeforeAnswer`, setScenario1Body.pollFailuresBeforeAnswer.toString())
 }
if(setScenario1Body?.evaluationDelaySeconds !== undefined) {
 formUrlEncoded.append(`evaluationDelaySeconds`, setScenario1Body.evaluationDelaySeconds.toString())
 }
if(setScenario1Body?.evaluationStatus !== undefined) {
 formUrlEncoded.append(`evaluationStatus`, setScenario1Body.evaluationStatus);
 }
if(setScenario1Body?.errorsCount !== undefined) {
 formUrlEncoded.append(`errorsCount`, setScenario1Body.errorsCount.toString())
 }
if(setScenario1Body?.warningsCount !== undefined) {
 formUrlEncoded.append(`warningsCount`, setScenario1Body.warningsCount.toString())
 }
if(setScenario1Body?.includeErrorReport !== undefined) {
 formUrlEncoded.append(`includeErrorReport`, setScenario1Body.includeErrorReport.toString())
 }
if(setScenario1Body?.includeConfirmation !== undefined) {
 formUrlEncoded.append(`includeConfirmation`, setScenario1Body.includeConfirmation.toString())
 }

    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/internal/web/eagri-report-mock`,
      formUrlEncoded,{
        responseType: 'text',
    ...options,}
    );
  }

/**
 * @summary Restores the default scenario: accepted, evaluated OK on the first fetch.
 */
export const resetScenario1 = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/internal/web/eagri-report-mock/reset`,
      undefined,{
        responseType: 'text',
    ...options,}
    );
  }

/**
 * Creates the listed seed applications and fills the planned yield on the listed existing ones where it is still empty. A create names the crop, not the seed: its base seed is used; the area comes from the parcel and the window is clipped to the parcel version validity, retired versions included. A create overlapping an existing seed application does not fail: the existing one gets its empty planned yield filled and is reported under `updated` or `alreadyPresent`. Creates sharing a `groupKey` end up in one group; a key equal to an existing group UUID joins that group. Every item is written on its own: a rejected item is listed under `failed` with its dates and the rest still lands, so the same batch can be sent again to finish the leftovers. `atomic=true` writes nothing as soon as one item is rejected. Replaces the deprecated `POST /internal-api/sowing-plan/v2/seed-applications`.
 * @summary Writes seed applications in bulk
 */
export const writeSeedApplicationBatch = (
    internalSeedApplicationBatchTo: InternalSeedApplicationBatchTo,
    params: WriteSeedApplicationBatchParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<InternalSeedApplicationBatchResultTo>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/sowing-plan/v3/seed-applications`,
      internalSeedApplicationBatchTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * <b>The preferred sowing plan search for precision farming</b> - the same history the sowing plan screen shows. Only a caller that needs the answer under exactly the parcel id it holds falls back to `/parcel-versions/search`. The parcel ids travel in the body, so their number is not limited by the URL length, and the seasons are addressed by their start year (2025 is the season 2025-07-01 - 2026-06-30), both bounds inclusive, at most 30 seasons.<ul><li><b>A row is a parcel with all its versions, not a single parcel record.</b> Versions one parcel was cut into are collapsed into a single row carrying what was sown on all of them; the versions behind it are listed in `mergedVersions` with their own names, validity, area and block.</li><li><b>The row id need not be the id you asked for.</b> A row is named after the newest version of the parcel, so send whichever version you know and map the answer back through `mergedVersions`. Every seed application, and every member of a group, still names the version it lies on in `parcelId`, so a row can be split back into its versions.</li><li>Retired parcels are rows too: a window that has ended lists the parcels the farm held then.</li><li><b>Filters work as on the sowing plan screen</b> (DEV-3046): crops, crop types and no crop in the filtered seasons, zones and full-text search, each matching its `GET /api/sowing-plan/v2/parcels` counterpart - see the request schema.</li><li>A seed application spanning several parcels (megaosev) carries `positionInGroup`, saying whether the crop reached this parcel from an earlier one, continues onto a later one, or both.</li></ul>The response is unpaged and shaped exactly like `GET /api/sowing-plan/v2/parcels`.
 * @summary Returns the sowing plan of the given land over a range of seasons, versions collapsed (preferred)
 */
export const searchDashboardSowingPlans = (
    internalSowingPlanV3SearchRequest: InternalSowingPlanV3SearchRequest,
    params: SearchDashboardSowingPlansParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ParcelWithSowingPlansV2To[]>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/sowing-plan/v3/parcels/search`,
      internalSowingPlanV3SearchRequest,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * <b>Prefer `/parcels/search`.</b> This search is only a fallback for a caller that cannot use its collapsed rows - one that needs the answer under exactly the parcel id it holds, e.g. the crop of the very parcel a product is attached to. Nothing here tells which versions belong to the same parcel; a caller showing sowings would have to rebuild that, and could end up telling a different history than the sowing plan. The parcel ids travel in the body, so their number is not limited by the URL length, and the seasons are addressed by their start year (2025 is the season 2025-07-01 - 2026-06-30), both bounds inclusive, at most 30 seasons. <b>A row is a parcel version and carries the id you asked for</b>; retired versions come back as rows of their own, so the caller can ask for every version it knows of and get the crops that grew on the land before the current version existed. A seed application is returned in every season its range overlaps; parcels sown together arrive as one entry listing every member's parcel id. `cropIds` keeps a parcel when one of the crops is attributed to any covered season - the season it was sown into, or a later one it carries over into while its harvest is unrecorded (DEV-1631). Replaces the deprecated `POST /internal-api/sowing-plan/v2/parcels/search`.
 * @summary Fallback: returns seed applications of the given parcel versions over a range of seasons, retired versions included
 */
export const searchParcelVersionSowingPlans = (
    internalSowingPlanSearchRequest: InternalSowingPlanSearchRequest,
    params: SearchParcelVersionSowingPlansParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ParcelWithSowingPlansV2To[]>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/sowing-plan/v3/parcel-versions/search`,
      internalSowingPlanSearchRequest,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * <b>Deprecated</b> - moved unchanged to `POST /internal-api/sowing-plan/v3/seed-applications` (DEV-2864). Creates the listed seed applications and fills the planned yield on the listed existing ones where it is still empty. A create names the crop, not the seed: its base seed is used; the area comes from the parcel and the window is clipped to the parcel version validity, retired versions included. A create overlapping an existing seed application does not fail: the existing one gets its empty planned yield filled and is reported under `updated` or `alreadyPresent`. Creates sharing a `groupKey` end up in one group; a key equal to an existing group UUID joins that group. Every item is written on its own: a rejected item is listed under `failed` with its dates and the rest still lands, so the same batch can be sent again to finish the leftovers. `atomic=true` writes nothing as soon as one item is rejected.
 * @deprecated
 * @summary Writes seed applications in bulk
 */
export const writeSeedApplications = (
    internalSeedApplicationBatchTo: InternalSeedApplicationBatchTo,
    params: WriteSeedApplicationsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<InternalSeedApplicationBatchResultTo>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/sowing-plan/v2/seed-applications`,
      internalSeedApplicationBatchTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * <b>Deprecated</b> - moved unchanged to `POST /internal-api/sowing-plan/v3/parcel-versions/search` (DEV-2864). The sowing plan search for a caller that tracks the history of a parcel across its versions: the parcel ids travel in the body, so their number is not limited by the URL length, and the seasons are addressed by their start year (2025 is the season 2025-07-01 - 2026-06-30), both bounds inclusive, at most 30 seasons. Unlike `GET /parcels`, retired parcel versions come back as rows of their own, so the caller can ask for every version it knows of and get the crops that grew on the parcel before the current version existed. The response has the same shape as `GET /parcels`; `cropIds` narrows the parcels the same way as `crop-ids` does there.
 * @deprecated
 * @summary Returns seed applications of the given parcels over a range of agricultural seasons, retired parcel versions included (DEV-2655)
 */
export const searchSowingPlans = (
    internalSowingPlanSearchRequest: InternalSowingPlanSearchRequest,
    params: SearchSowingPlansParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ParcelWithSowingPlansV2To[]>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/sowing-plan/v2/parcels/search`,
      internalSowingPlanSearchRequest,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getPlantProtectionsInternal = (
    getInternalPlantProtectionMaterialBody: GetInternalPlantProtectionMaterialBody,
    params: GetPlantProtectionsInternalParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<(InternalFertilizerTo | InternalMaterialToBase)[]>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/plant-protections`,
      getInternalPlantProtectionMaterialBody,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns the given parcels regardless of their status and validity, i.e. including retired ones, a retired one with the open parcels overlapping it and the overlap measures, an open one with none. Intended for consumers reacting to parcel change notifications.
 * @summary Returns the given parcels with their successor candidates
 */
export const getParcelsWithSuccessors = (
    getParcelsWithSuccessorsBody: string[],
    params: GetParcelsWithSuccessorsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<InternalParcelWithSuccessorsTo[]>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/parcels/with-successors`,
      getParcelsWithSuccessorsBody,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Same listing, filtering, sorting and paging as GET, with the parcel ids in the request body so that a large set of ids is not limited by the URL length.
 * @summary Returns list of parcels restricted to the given ids
 */
export const searchInternalParcels = (
    internalParcelSearchRequest: InternalParcelSearchRequest,
    params: SearchInternalParcelsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<InternalParcelTo[]>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/parcels/search`,
      internalParcelSearchRequest,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns a list of parcels intersecting with the given geometry. The parcel's crop corresponds to the at-date parameter, which defaults to today's date.
 * @summary Returns list of parcels
 */
export const getParcelIntersections = (
    geoJsonMultiPoint: GeoJsonMultiPoint,
    params: GetParcelIntersectionsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<InternalParcelTo[]>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/parcels/intersecting`,
      geoJsonMultiPoint,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns a list of parcels intersecting with the given geometry in a country. The parcel's crop corresponds to the at-date parameter, which defaults to today's date.
 * @summary Returns list of parcels intersected by country
 */
export const getInternationalParcelIntersections = (
    geoJsonMultiPoint: GeoJsonMultiPoint,
    params: GetInternationalParcelIntersectionsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<InternalIntersectionParcelTo[]>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/parcels/intersecting/international`,
      geoJsonMultiPoint,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns all (input, open) parcel intersection pairs with computed intersection area and Jaccard similarity index, grouped by input parcel ID. With includeRetired the retired parcels are paired too. Jaccard index = intersection area / union area, ranges from 0.0 (no overlap) to 1.0 (identical geometries).
 * @summary Returns open parcels intersecting with given parcel IDs
 */
export const getOpenParcelsIntersectingByParcels = (
    internalParcelIntersectionRequest: InternalParcelIntersectionRequest,
    params: GetOpenParcelsIntersectingByParcelsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<InternalParcelIntersectionTo[]>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/parcels/intersecting-by-parcels`,
      internalParcelIntersectionRequest,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getActionInfo = (
    internalActionInfoRequestBodyTo: InternalActionInfoRequestBodyTo,
    params: GetActionInfoParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<InternalActionInfo[]>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/actions/notes`,
      internalActionInfoRequestBodyTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const createDraftAction = (
    internalTelematicsActionCreate: InternalTelematicsActionCreate,
    params: CreateDraftActionParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<InternalActionIdResponse>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/actions/draft`,
      internalTelematicsActionCreate,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const bulkDeleteActions = (
    internalBulkDeleteActionsRequestTo: InternalBulkDeleteActionsRequestTo, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<InternalBulkDeleteResult>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/actions/bulk-delete`,
      internalBulkDeleteActionsRequestTo,options
    );
  }

/**
 * Returns a paginated list of seed parcel lifecycles filtered by query parameters. Results may include individual lifecycles or grouped lifecycles (when multiple lifecycles share a group_id, e.g., after parcel splits). Both types implement SeedApplicationResultTo interface.
 * @summary Get seed parcel lifecycles
 */
export const getSeedApplicationV2s = (
    params: GetSeedApplicationV2sParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<(SeedApplicationV2GroupToV2 | SeedApplicationV2To)[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/v2/seed-applications`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Creates a new seed parcel lifecycle representing a crop growing on a parcel.
 * @summary Create seed parcel lifecycle
 */
export const createSeedApplicationV2 = (
    seedApplicationV2CreateTo: SeedApplicationV2CreateTo,
    params: CreateSeedApplicationV2Params, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SeedApplicationV2To>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/v2/seed-applications`,
      seedApplicationV2CreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Creates a new group from existing seed applications. This is used when a user wants to create a group from a standalone seed application by connecting it with other seed applications. All specified members will be assigned a newly generated group_id. A group must have at least 2 members.
 * @summary Create seed application group
 */
export const createSeedApplicationV2Group = (
    seedApplicationV2GroupCreateTo: SeedApplicationV2GroupCreateTo,
    params: CreateSeedApplicationV2GroupParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SeedApplicationV2GroupToV2>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/v2/seed-applications/groups`,
      seedApplicationV2GroupCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Creates one seed application with the same attributes on every requested parcel. Open-ended previous seed applications are auto-closed and open-ended new seed applications auto-capped before any following seed application. A closed-neighbor conflict is resolved with the strategy chosen for that parcel in 'parcelResolutions'; a parcel not listed there uses NONE (the conflict skips it). Parcels that cannot be resolved with the chosen strategy, or that fall outside their validity period, are skipped and returned in the 'skipped' list - each resolvable skip carries its conflict status and feasible resolution options so the FE can offer a per-parcel resolution and resend just those parcels. The created seed applications are independent (no shared group).
 * @summary Bulk create seed parcel lifecycles
 */
export const createBulk = (
    seedApplicationV2BulkCreateTo: SeedApplicationV2BulkCreateTo,
    params: CreateBulkParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SeedApplicationV2BulkResultTo>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/v2/seed-applications/bulk`,
      seedApplicationV2BulkCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Dry-run for creating one seed application with the same attributes on many parcels. Analyses each parcel's existing timeline and reports, per parcel, whether the seed application can be created cleanly or conflicts with a neighbor:
 *
 * - **CLEAN** - no conflict.
 * - **AUTO_CLOSE_PREVIOUS** - an open-ended previous seed application will be auto-closed the day before the new start.
 * - **AUTO_CAP_END** - the new seed application is open-ended and will be auto-capped before a following seed application.
 * - **PREVIOUS_CONFLICT / FOLLOWING_CONFLICT / BOTH** - a closed neighbor overlaps; each conflict lists the resolution options (EDIT_NEW = move the new seed application, SHIFT_NEIGHBOR = move the neighbor) with the resulting dates and a feasibility flag.
 *
 * Writes nothing. The chosen per-parcel strategies are then sent to the bulk-create endpoint. The same conflict status and options are also returned on each skipped parcel of the bulk-create response, so the preview is optional for the FE.
 * @summary Preview bulk seed application creation
 */
export const previewBulkCreate = (
    seedApplicationV2BulkCreateTo: SeedApplicationV2BulkCreateTo,
    params: PreviewBulkCreateParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SeedApplicationV2BulkPreviewTo>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/v2/seed-applications/bulk/preview`,
      seedApplicationV2BulkCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Applies the same new dateStart / dateEnd to every requested seed application (DEV-1098). Mirror of bulk create, but the input is existing seed application ids and the commit updates each seed application's dates instead of inserting. The same conflict engine runs per seed application (the seed application is excluded from its own conflict check); a conflict is resolved with the strategy chosen for that seed application in 'seedApplicationResolutions' (a seed application not listed uses NONE = skip). Seed applications that cannot be resolved, fall outside parcel validity, or are not found are returned in 'skipped' (with 'seedApplicationId' and, for resolvable conflicts, the feasible options). The 'updated' list holds the edited seed applications in their new state; 'affectedNeighbors' the shifted/closed neighbors. Non-temporal crop fields (seed, use type, catch crop, product) are editable too (DEV-1167). DEV-1352: when a requested id is a member of a megaosev group, the edit is scoped per field - a non-date (crop) field is applied to the WHOLE group (all members, incl. on parcels not listed), 'dateEnd' applies only to that one member (its own parcel), and 'dateStart' is blocked for a grouped member (GROUP_START_DATE_NOT_EDITABLE). Because a crop change on a grouped member is applied even when that member's own date change is skipped by a conflict, the same member can appear in both 'updated' (crop) and 'skipped' (date); each 'skipped' entry carries its 'groupId'. Send a group's member id (of the edited sowing-plan row) in 'seedApplicationIds'.
 * @summary Bulk edit seed parcel lifecycle dates
 */
export const editBulk = (
    seedApplicationV2BulkEditTo: SeedApplicationV2BulkEditTo,
    params: EditBulkParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SeedApplicationV2BulkEditResultTo>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/v2/seed-applications/bulk-edit`,
      seedApplicationV2BulkEditTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Dry-run for editing the dates of many existing seed applications at once (DEV-1098). Mirror of the bulk create preview, but the input is a list of existing seed application ids that all get the same new dateStart / dateEnd. Each seed application is re-checked against its parcel timeline (excluding itself) and reported with its conflict status and the resolution options (EDIT_NEW = move the edited seed application, SHIFT_NEIGHBOR = move the neighbor). Writes nothing. In the response each entry carries the 'seedApplicationId' it belongs to.
 * @summary Preview bulk seed application edit
 */
export const previewBulkEdit = (
    seedApplicationV2BulkEditTo: SeedApplicationV2BulkEditTo,
    params: PreviewBulkEditParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SeedApplicationV2BulkPreviewTo>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/v2/seed-applications/bulk-edit/preview`,
      seedApplicationV2BulkEditTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Permanently deletes every requested seed application lifecycle in one call (DEV-1151). The input is a list of seed application ids; each found id is hard-deleted, and an id that does not exist or does not belong to the farm is reported in 'skipped' (reason SEED_APPLICATION_NOT_FOUND) rather than failing the whole call. Unlike bulk create/edit there is no timeline conflict to resolve, so no preview is needed. Group membership is auto-cleaned the same way as a single delete: if deleting members leaves a megaosev group with a single remaining member, that member's group is dissolved. 'deletedIds' lists the ids actually deleted, in the requested order.
 * @summary Bulk delete seed parcel lifecycles
 */
export const deleteBulk = (
    seedApplicationV2BulkDeleteTo: SeedApplicationV2BulkDeleteTo,
    params: DeleteBulkParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SeedApplicationV2BulkDeleteResultTo>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/v2/seed-applications/bulk-delete`,
      seedApplicationV2BulkDeleteTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Uses seed_application_v2 table instead of action-based seed applications.
 * @summary V2: Sends POR use report to eagri using seed_application_v2.
 */
export const sendPorUserReportToEagriV2 = (
    params: SendPorUserReportToEagriV2Params, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PlantProtectionPairingResultTo>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/v2/reports/eagri/por-usage`,
      undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Uses seed_application_v2 table instead of action-based seed applications.
 * @summary V2: Returns POR use report data using seed_application_v2. For testing purposes.
 */
export const getPorUseReportBodyV2 = (
    params: GetPorUseReportBodyV2Params, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PorUseBody>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/v2/reports/eagri/por-usage/dry`,
      undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary V2: Downloads POR use report XML for manual upload to eagri portal.
 */
export const downloadPorUseReportXmlV2 = (
    params: DownloadPorUseReportXmlV2Params, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Blob>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/v2/reports/eagri/por-usage/download`,
      undefined,{
        responseType: 'blob',
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Uses seed_application_v2 table for crop lifecycle data.
 * @summary V2: Sends fertilizer use report to eagri using seed_application_v2.
 */
export const sendFertilizerUseReportToEagriV2 = (
    eagriReportBody: EagriReportBody,
    params: SendFertilizerUseReportToEagriV2Params, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EagriReportResponse>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/v2/reports/eagri/fertilizer-usage`,
      eagriReportBody,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Uses seed_application_v2 table instead of action-based seed applications.
 * @summary V2: Returns fertilizer use report data using seed_application_v2. For testing purposes.
 */
export const getFertilizerUseReportBodyV2 = (
    eagriReportBody: EagriReportBody,
    params: GetFertilizerUseReportBodyV2Params, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FertiliserUseBody>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/v2/reports/eagri/fertilizer-usage/dry`,
      eagriReportBody,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getSeededAreasV2Report = (
    params: GetSeededAreasV2ReportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/v2/seeded-areas`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const postSeededAreasV2Report = (
    reportRequestTo: ReportRequestTo,
    params: PostSeededAreasV2ReportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/v2/seeded-areas`,
      reportRequestTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getSeedApplicationsV2Report = (
    params: GetSeedApplicationsV2ReportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/v2/seed-applications`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const postSeedApplicationsV2Report = (
    reportRequestTo: ReportRequestTo,
    params: PostSeedApplicationsV2ReportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/v2/seed-applications`,
      reportRequestTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getRevenuesV2Report = (
    params: GetRevenuesV2ReportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/v2/revenues`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const postRevenuesV2Report = (
    reportRequestTo: ReportRequestTo,
    params: PostRevenuesV2ReportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/v2/revenues`,
      reportRequestTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getPorUsageReport = (
    params: GetPorUsageReportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/plant-protection-usage`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const postPorUsageReport = (
    reportRequestTo: ReportRequestTo,
    params: PostPorUsageReportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/plant-protection-usage`,
      reportRequestTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getPorConsumptionByPPReport = (
    params: GetPorConsumptionByPPReportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/plant-protection-consumption`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const postPorConsumptionByPPReport = (
    reportRequestTo: ReportRequestTo,
    params: PostPorConsumptionByPPReportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/plant-protection-consumption`,
      reportRequestTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getPorConsumptionByCropReport = (
    params: GetPorConsumptionByCropReportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/plant-protection-consumption-crop`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const postPorConsumptionByCropReport = (
    reportRequestTo: ReportRequestTo,
    params: PostPorConsumptionByCropReportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/plant-protection-consumption-crop`,
      reportRequestTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getNonFieldPorUsageReport = (
    params: GetNonFieldPorUsageReportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/non-field-plant-protection-usage`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const postNonFieldPorUsageReport = (
    reportRequestTo: ReportRequestTo,
    params: PostNonFieldPorUsageReportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/non-field-plant-protection-usage`,
      reportRequestTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getFertilizerUsageReport = (
    params: GetFertilizerUsageReportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/fertilizer-usage`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const postFertilizerUsageReport = (
    reportRequestTo: ReportRequestTo,
    params: PostFertilizerUsageReportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/fertilizer-usage`,
      reportRequestTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getFertilizerOrganicReport = (
    params: GetFertilizerOrganicReportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/fertilizer-organic`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const postFertilizerOrganicReport = (
    reportRequestTo: ReportRequestTo,
    params: PostFertilizerOrganicReportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/fertilizer-organic`,
      reportRequestTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getFertilizerConsumptionReport = (
    params: GetFertilizerConsumptionReportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/fertilizer-consumption`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const postFertilizerConsumptionReport = (
    reportRequestTo: ReportRequestTo,
    params: PostFertilizerConsumptionReportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/fertilizer-consumption`,
      reportRequestTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getFertilizerConsumptionByCropReport = (
    params: GetFertilizerConsumptionByCropReportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/fertilizer-consumption-crop`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const postFertilizerConsumptionByCropReport = (
    reportRequestTo: ReportRequestTo,
    params: PostFertilizerConsumptionByCropReportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/fertilizer-consumption-crop`,
      reportRequestTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getActionsReport = (
    params: GetActionsReportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/actions`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const postActionsReport = (
    reportRequestTo: ReportRequestTo,
    params: PostActionsReportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/actions`,
      reportRequestTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Creates customer, new schema and imports shapefile
 */
export const registerWithShapeFile = (
    params: RegisterWithShapeFileParams,
    registerWithShapeFileBody?: RegisterWithShapeFileBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/registration/shapefile`,
      registerWithShapeFileBody,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Validates if shapefile contains all files
 */
export const validateShapefile = (
    params: ValidateShapefileParams,
    validateShapefileBody?: ValidateShapefileBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/registration/shapefile/validate`,
      validateShapefileBody,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary
            Submits and awaits an empty farm creation. This involves the following steps:
            - create a new customer
            - create an empty farm (i.e. farm without external data layers)
        "
 */
export const registerEmptyFarm = (
    params: RegisterEmptyFarmParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/registration/empty`,
      undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary
            Asynchronously submits a farm creation task and imports farm data from eAGRI. This involves the following steps:
            - create a customer
            - create an empty farm
            - request farm DPB data from the eAGRI portal and parse them into blocks + parcels
            - persist parsed data into database
        "
 */
export const registerWithEagri = (
    params: RegisterWithEagriParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/registration/eagri`,
      undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getParcelsSubtraction = (
    parcelId: string,
    restrictionTo: RestrictionTo,
    params: GetParcelsSubtractionParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SubtractionTo>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/${parcelId}/subtractions`,
      restrictionTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns zones with per-zone parcel statistics (count and total area). Statistics are computed from parcels valid at the given date (including already retired ones). Optional date parameter controls the reference date (defaults to today).
 * @summary Returns all zones
 */
export const getZones = (
    params: GetZonesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ZoneDetailTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/zones`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Creates new zone
 */
export const createZone = (
    zoneCreateTo: ZoneCreateTo,
    params: CreateZoneParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ZoneDetailTo>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/zones`,
      zoneCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const postParcelVegetationStrip = (
    parcelVegetationStripRequest: ParcelVegetationStripRequest[],
    params: PostParcelVegetationStripParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ParcelVegetationStripResponse[]>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/vegetation-strips`,
      parcelVegetationStripRequest,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @deprecated
 */
export const recountSubtractionsForAction = (
    recountSubtractionRequest: RecountSubtractionRequest,
    params: RecountSubtractionsForActionParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ParcelSubtractionResponse[]>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/subtractions`,
      recountSubtractionRequest,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getParcelSubtractionGeometry = (
    parcelRestrictionTo: ParcelRestrictionTo,
    params: GetParcelSubtractionGeometryParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ParcelGeometryResponse>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/subtractions/geometry`,
      parcelRestrictionTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Each subtraction of each parcel as its own geometry, together with the parcel geometry and the geometry left after the non-ignored subtractions. Meant for drawing the subtractions on a map. Send all parcels of the action: the boundary buffer is measured against their cluster.
 * @summary Parcel subtractions as separate geometries
 */
export const getParcelSubtractionGeometries = (
    parcelRestrictionRequestBody: ParcelRestrictionRequestBody,
    params: GetParcelSubtractionGeometriesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ParcelSubtractionGeometriesTo[]>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/subtractions/geometries`,
      parcelRestrictionRequestBody,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getParcelAreaAfterSubtraction = (
    parcelRestrictionRequestBody: ParcelRestrictionRequestBody,
    params: GetParcelAreaAfterSubtractionParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ParcelAreaTo[]>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/subtractions/area`,
      parcelRestrictionRequestBody,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Get available updates. Available updates have a certain TTL and will therefore be deleted after a certain period of time.
 */
export const getAvailableUpdates = (
    params: GetAvailableUpdatesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FarmUpdateChangesResponse>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/farms/eagri/available-updates`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Requests available farm update search. The search itself is done asynchronously; to retrieve search results, use the corresponding GET method. Please note there is a timeout period for which we try to download eAGRI data; if there are no data available after this period, this most likely means that eAGRI services are not available at the moment.
 */
export const requestAvailableUpdates = (
    params: RequestAvailableUpdatesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/farms/eagri/available-updates`,
      undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Facilities non-field actions are applied in. Sorted by name ascending unless sort-col is given; type and unit sort by their translation in the given language, ties are broken by name ascending.
 * @summary Returns farm facilities
 */
export const getFacilities = (
    params: GetFacilitiesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FacilityTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/facilities`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Creates a farm facility
 */
export const createFacility = (
    facilityCreateTo: FacilityCreateTo,
    params: CreateFacilityParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FacilityTo>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/facilities`,
      facilityCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Attempts to store eAGRI authentication credentials. Data are associated with the current user.
 */
export const storeAuthData = (
    eagriAuthDataValidationRequestTo: EagriAuthDataValidationRequestTo, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EagriAuthValidationResultTo>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/eagri-auth`,
      eagriAuthDataValidationRequestTo,options
    );
  }

/**
 * Returns farm seed catalogue.
 * @summary List seeds
 */
export const getSeeds = (
    params: GetSeedsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CropSeedTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/seeds`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 *
 *             <p>Adds seed to farm catalogue.</p>
 *             <ul>
 *                 <li>If seed with same variety name already exists, will just return the existing seed</li>
 *                 <li>If seed exist but is hidden, will un-hide it</li>
 *             </ul>
 * @summary Add seed
 */
export const postSeed = (
    cropSeedCreateTo: CropSeedCreateTo,
    params: PostSeedParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CropSeedTo>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/seeds`,
      cropSeedCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Creates plant protection product in PRIVATE catalogue.
 * @summary Create plant protection
 */
export const postPlantProtection = (
    plantProtectionCreateUpdateTo: PlantProtectionCreateUpdateTo,
    params: PostPlantProtectionParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PlantProtectionDetailTo>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protections`,
      plantProtectionCreateUpdateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Copies the product into the farm's PRIVATE catalogue as an exact copy (DEV-1747): every registration is reproduced 1:1 with its own decision id, registration number and holders, together with all of its applications, buffers, slope conditions, dosages, tank mix partners, active substances and eAgri metadata. Only registrations that can still be used are copied — usable_until in the future or unset, which includes the sell-off period. A product with none of them left copies as an empty one.
 * @summary Copy plant protection
 */
export const copyPlantProtection = (
    plantProtectionId: string,
    params: CopyPlantProtectionParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PlantProtectionDetailTo>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protections/${plantProtectionId}/copy`,
      undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Create a registration on a private POR
 */
export const createRegistration = (
    plantProtectionId: string,
    plantProtectionRegistrationCreateUpdateTo: PlantProtectionRegistrationCreateUpdateTo,
    params: CreateRegistrationParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PlantProtectionRegistrationTo>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protections/${plantProtectionId}/registrations`,
      plantProtectionRegistrationCreateUpdateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Create plant protection application
 */
export const postPlantProtectionRegistrationApplication = (
    plantProtectionId: string,
    plantProtectionApplicationCreateTo: PlantProtectionApplicationCreateTo,
    params: PostPlantProtectionRegistrationApplicationParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protections/${plantProtectionId}/applications`,
      plantProtectionApplicationCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Adds one or more crop×organism combinations (with dosage) to a private POR. Combinations already present on the product's registration are skipped and reported.
 * @summary Bulk add plant protection application combinations
 */
export const bulkCreatePlantProtectionRegistrationApplications = (
    plantProtectionId: string,
    plantProtectionApplicationBulkCreateTo: PlantProtectionApplicationBulkCreateTo,
    params: BulkCreatePlantProtectionRegistrationApplicationsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PlantProtectionApplicationBulkResultTo>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protections/${plantProtectionId}/applications/bulk`,
      plantProtectionApplicationBulkCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Only available for global farms. Possible csv headers, only name is required: name,externalId,isEco,bioFunction,activeSubstances,notes,isFavorite,usableUntil
 * @summary Import plant protections from CSV
 */
export const importPlantProtectionsFromCSV = (
    params: ImportPlantProtectionsFromCSVParams,
    importPlantProtectionsFromCSVBody?: ImportPlantProtectionsFromCSVBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protections/import`,
      importPlantProtectionsFromCSVBody,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Creates a plant protection product in the farm's PRIVATE catalogue together with a default registration that carries the active substances. Returns the new detail DTO.
 * @summary Create plant protection header (new detail editing)
 */
export const createPlantProtectionHeader = (
    plantProtectionCreateUpdateTo: PlantProtectionCreateUpdateTo,
    params: CreatePlantProtectionHeaderParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PlantProtectionDetailTo>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protections/header`,
      plantProtectionCreateUpdateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getOrganisms = (
    params: GetOrganismsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<OrganismTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protection/organisms`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const createOrganisms = (
    createOrganismRequestTo: CreateOrganismRequestTo,
    params: CreateOrganismsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<OrganismTo>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protection/organisms`,
      createOrganismRequestTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getActiveSubstances = (
    params: GetActiveSubstancesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ActiveSubstanceTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protection/active-substances`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const postActiveSubstance = (
    activeSubstanceCreateTo: ActiveSubstanceCreateTo,
    params: PostActiveSubstanceParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ActiveSubstanceTo>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protection/active-substances`,
      activeSubstanceCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns farm fertilizer catalogue.
 * @summary List fertilizers
 */
export const getFertilizers = (
    params: GetFertilizersParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FertilizerTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/fertilizers`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Adds fertilizer to farm catalogue.
 * @summary Add fertilizer
 */
export const postFertilizer = (
    fertilizerCreateTo: FertilizerCreateTo,
    params: PostFertilizerParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FertilizerDetailTo>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/fertilizers`,
      fertilizerCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Only available for global farms. Possible csv headers, only name is required: name, description, isOrganic, n, p2o5, k2o, cao, mgo, na2o, s, chlorides, combustibleContent, zn, cu, fe, b, mn, mo, se, phFrom, phTo, electricConductivity, catalogueId, commonUnitType, weightToVolumeCoefficient
 * @summary Import fertilizers from CSV
 */
export const importFertilizersFromCSV = (
    params: ImportFertilizersFromCSVParams,
    importFertilizersFromCSVBody?: ImportFertilizersFromCSVBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/fertilizers/import`,
      importFertilizersFromCSVBody,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns available crop catalogue.
 * @summary List crops
 */
export const getCrops = (
    params: GetCropsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CropTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/crops`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const postCrop = (
    cropCreateTo: CropCreateTo,
    params: PostCropParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CropTo>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/crops`,
      cropCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Get all crop products
 */
export const getCropProducts = (
    params: GetCropProductsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CropProductTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/crops/products`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Create a crop product
 */
export const postCropProduct = (
    cropProductCreateTo: CropProductCreateTo,
    params: PostCropProductParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CropProductTo>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/crops/products`,
      cropProductCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Only available for global farms. Possible csv headers, only name is required: name, color, text_color
 * @summary Import crops from CSV
 */
export const importCropsFromCSV = (
    params: ImportCropsFromCSVParams,
    importCropsFromCSVBody?: ImportCropsFromCSVBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/crops/import`,
      importCropsFromCSVBody,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Get crop use types
 */
export const getCropUseTypes = (
    params: GetCropUseTypesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CropUseTypeTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/crops/crop-use`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Create a farm-level crop use type
 */
export const postCropUseType = (
    cropUseTypeCreateTo: CropUseTypeCreateTo,
    params: PostCropUseTypeParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CropUseTypeTo>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/crops/crop-use`,
      cropUseTypeCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Attach an existing crop use type to a crop
 */
export const attachCropUseTypeToCrop = (
    id: string,
    cropId: string,
    params: AttachCropUseTypeToCropParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CropUseTypeTo>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/crops/crop-use/${id}/crop/${cropId}`,
      undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Removes the crop use type from the crop. Only allowed when no products remain on it; delete the products first.
 * @summary Detach an empty crop use type from a crop
 */
export const detachCropUseTypeFromCrop = (
    id: string,
    cropId: string,
    params: DetachCropUseTypeFromCropParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DetachCropUseTypeFromCrop204>> => {
    return axios.delete(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/crops/crop-use/${id}/crop/${cropId}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns crop groups visible to the farm: shared catalogue groups (eAgri) and the farm private groups.
 * @summary Get crop groups
 */
export const getCropGroups = (
    params: GetCropGroupsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CropGroupResponseTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/crops/crop-groups`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Create a farm private crop group
 */
export const postCropGroup = (
    cropGroupCreateTo: CropGroupCreateTo,
    params: PostCropGroupParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CropGroupResponseTo>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/crops/crop-groups`,
      cropGroupCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Expected file in .zip. Will return forbidden if file has more than one shapefile.As srid in .prj file might be wrong, specify srid of provided shp file explicitly
 * @summary Creates a new version of surface water protection zones geo layer
 */
export const importSurfaceWaterProtectionZones = (
    params: ImportSurfaceWaterProtectionZonesParams,
    importSurfaceWaterProtectionZonesBody?: ImportSurfaceWaterProtectionZonesBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/water-protection-zones/surface`,
      importSurfaceWaterProtectionZonesBody,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Accepts the VÚV ZIP exactly as downloaded from dibavod.cz. The backend splits features by VZ_KAT and routes them into the surface and/or ground table according to the `mode` query parameter (BOTH by default). `mode=BOTH` runs atomically — either both tables get the new version or neither does.
 * @summary Import the original VÚV ZIP (auto-splits OPVZ + OPVN by VZ_KAT)
 */
export const importFromVuvZip = (
    params: ImportFromVuvZipParams,
    importFromVuvZipBody?: ImportFromVuvZipBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WaterProtectionZonesImportResult>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/water-protection-zones/import`,
      importFromVuvZipBody,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Expected file in .zip. Will return forbidden if file has more than one shapefile. As srid in .prj file might be wrong, specify srid of provided shp file explicitly
 * @summary Creates a new version of ground water protection zones geo layer
 */
export const importGroundWaterProtectionZones = (
    params: ImportGroundWaterProtectionZonesParams,
    importGroundWaterProtectionZonesBody?: ImportGroundWaterProtectionZonesBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/water-protection-zones/ground`,
      importGroundWaterProtectionZonesBody,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Fetches the VÚV ISO 19115 metadata and compares its revision date against what we have stored. Publishes the new-version event (which triggers Slack) if VÚV is strictly newer than both DB and the last-notified revision. Returns the outcome so the admin can see what happened without waiting for the scheduled run.
 * @summary Manually trigger the update detector
 */
export const checkForUpdate = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WaterProtectionZonesUpdateCheckResult>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/water-protection-zones/check-update`,
      undefined,options
    );
  }

export const syncCounties = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/management/sync-counties`,
      undefined,options
    );
  }

/**
 * Updates nitrate vulnerable zones for on parcels on all CZ farms. Warning: it may take a 1 hour or more time to finish! It is preferable to run the update on farm by farm basis.
 * @summary Updates nitrate vulnerable flags
 */
export const updateNitrateVulnerable = (
    params?: UpdateNitrateVulnerableParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AdminFarmManagementTo[]>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/management/nitrate-vulnerable-zones`,
      undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns list of nitrate vulnerable status for all parcels on farm without updating the database.
 * @summary Returns nitrate vulnerable status
 */
export const getNitrateVulnerableOnFarm = (
    farmId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AdminNitrateVulnerableZoneTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/management/nitrate-vulnerable-zones/${farmId}`,options
    );
  }

/**
 * Updates nitrate vulnerable status for all parcels on farm.
 * @summary Updates nitrate vulnerable flags
 */
export const postNitrateVulnerableOnFarm = (
    farmId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AdminNitrateVulnerableZoneTo[]>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/management/nitrate-vulnerable-zones/${farmId}`,
      undefined,options
    );
  }

/**
 *
 *             The motivation behind having this endpoint is that after LPIS update, a lot of parcels
 *             appear unsown because sowings applicable to such parcels are attached to retired parcels;
 *             in reality, there might be no harvest on the retired parcel.
 * @summary Moves parcel validity according to the sowing of its predecessors and moves actions accordingly.
 */
export const moveParcelValiditiesToNewestSowing = (
    params: MoveParcelValiditiesToNewestSowingParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AdminParcelValidityMoveResult>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/management/farm/move-parcel-valid-from`,
      undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 *
 *             Action moving is done automatically as a part of update; this endpoint serves
 *             as a helper service for historical data which for some reason weren't moved.
 * @summary Moves actions after update.
 */
export const moveActionsAfterUpdate = (
    params: MoveActionsAfterUpdateParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AdminActionMoveResult>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/management/farm/move-actions`,
      undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Creates a new eAGRI farm using data from an eAGRI test user account.
 */
export const createTestEagriFarm = (
    adminEagriTestFarmCreateRequest: AdminEagriTestFarmCreateRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/management/farm/create-test-farm`,
      adminEagriTestFarmCreateRequest,options
    );
  }

/**
 * @summary Trigger manual landscape element synchronization
 */
export const triggerSync = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SyncStats>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/landscape/sync`,
      undefined,options
    );
  }

/**
 * @deprecated
 */
export const refreshFarmCache = (
    farmId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/geoserver/farm/${farmId}/refresh-farm-cache`,
      undefined,options
    );
  }

/**
 * Returns preview of LPIS block information for current versions of farm LPIS blocks from eAgri.
 * @summary Returns LPIS preview
 */
export const getLpisBlocks = (
    farmId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/farms/${farmId}/lpis`,options
    );
  }

/**
 * Synchronizes current versions of LPIS blocks with eAgri. It does not update LPIS block if they were retired.
 * @summary Updates LPIS info
 */
export const updateEagriFarm = (
    farmId: string,
    params?: UpdateEagriFarmParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/farms/${farmId}/lpis`,
      undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Synchronizes eAgri catalogue
 */
export const postSync = (
    catalogueType: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/catalogues/eagri/sync/${catalogueType}`,
      undefined,options
    );
  }

/**
 * Recalculates accountable nitrogen for fertilizer expenses being edited in the EPH form, before they are saved as an action. Sown area is taken from the referenced seed application V2.
 * @summary Get accountable nitrogen for edited fertilizer expenses (V2)
 */
export const getTargetSeedApplicationAccountableNitrogen = (
    targetSeedApplicationFertilizationV2RequestTo: TargetSeedApplicationFertilizationV2RequestTo,
    params: GetTargetSeedApplicationAccountableNitrogenParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ParcelAccountableNitrogenV2To[]>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/v2/target-seed-application/accountable-nitrogen`,
      targetSeedApplicationFertilizationV2RequestTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Splits an action into two separate actions using seed_application_v2. The original action keeps the remaining parcels, and a new action is created with the selected parcels. Material amounts are proportionally recalculated based on parcel areas.
 * @summary Split action (V2)
 */
export const splitAction = (
    splitActionRequest: SplitActionRequest,
    params: SplitActionParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SplitActionResponse>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/v2/split`,
      splitActionRequest,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Creates a new sowing action using seed_application_v2. Automatically creates seed application V2 records based on date and parcel.
 * @summary Create sowing action (V2)
 */
export const createSowingAction = (
    actionSowingCreateV2To: ActionSowingCreateV2To,
    params: CreateSowingActionParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ActionIdTo>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/v2/sowing`,
      actionSowingCreateV2To,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Creates an action that has no dedicated endpoint (e.g. plow, tillage, disking). When endSeedApplications is set, ends the ongoing seed application and shifts the start of the following seed application forward.
 * @summary Create other action (V2)
 */
export const createOtherAction = (
    actionOtherCreateTo: ActionOtherCreateTo,
    params: CreateOtherActionParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ActionIdTo>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/v2/other`,
      actionOtherCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Creates a plant protection application in a farm facility (storage, seed treatment station, greenhouse, other) instead of on parcels (DEV-2925). The action has no parcels; its extent and doses relate to the unit of the facility. No restrictions are evaluated.
 * @summary Create non-field plant protection action
 */
export const createNonFieldAction = (
    actionNonFieldCreateTo: ActionNonFieldCreateTo,
    params: CreateNonFieldActionParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ActionIdTo>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/v2/non-field`,
      actionNonFieldCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Creates a new mowing action using seed_application_v2. Works with existing seed application V2 records based on date and parcel.
 * @summary Create mowing action (V2)
 */
export const createMowingAction = (
    actionMowingCreateV2To: ActionMowingCreateV2To,
    params: CreateMowingActionParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ActionIdTo>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/v2/mowing`,
      actionMowingCreateV2To,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Creates a new harvest action using seed_application_v2. Automatically closes seed application V2 records based on date and parcel.
 * @summary Create harvest action (V2)
 */
export const createHarvestAction = (
    actionHarvestCreateV2To: ActionHarvestCreateV2To,
    params: CreateHarvestActionParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ActionIdTo>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/v2/harvest`,
      actionHarvestCreateV2To,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Creates a new EPH (fertilization/plant protection) action using seed_application_v2. Accepts targetCropId for form compatibility, but target crop is determined by date and parcel.
 * @summary Create EPH action (V2)
 */
export const createEPHAction = (
    actionEPHCreateV2To: ActionEPHCreateV2To,
    params: CreateEPHActionParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ActionIdTo>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/v2/eph`,
      actionEPHCreateV2To,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Validates legislative restrictions for EPH action using seed applications. Checks fertilization limits, restrictions and other legislative requirements.
 * @summary Validate EPH action restrictions (V2)
 */
export const validateEPHAction = (
    actionEPHCreateV2To: ActionEPHCreateV2To,
    params: ValidateEPHActionParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ValidationResponseTo>> => {
    return axios.post(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/v2/eph/restrictions`,
      actionEPHCreateV2To,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns parcel detail.
 * @summary Parcel detail
 */
export const getParcel = (
    parcelId: string,
    params: GetParcelParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ParcelDetailTo>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/${parcelId}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Updates parcel name or/and user yield grade.
 * @summary Update parcel
 */
export const patchParcel = (
    parcelId: string,
    parcelUpdateTo: ParcelUpdateTo,
    params: PatchParcelParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.patch(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/${parcelId}`,
      parcelUpdateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Moves the parcel's start in either direction. Backwards it opens the parcel up for records - a seed application above all - from a period before it was first imported; forwards it corrects a start that was set too early, as far as the day before the parcel's end (today for a parcel that has not been retired). Only the first version of a parcel can be moved: a later version starts where its predecessor was retired, so moving its start would break the sequence of versions. A forward move that would leave an existing seed application outside the parcel's validity is refused. Asking for the date the parcel already has changes nothing.
 * @summary Move the start of a parcel's validity
 */
export const patchParcelValidFrom = (
    parcelId: string,
    parcelValidFromUpdateTo: ParcelValidFromUpdateTo,
    params: PatchParcelValidFromParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ParcelValidityTo>> => {
    return axios.patch(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/${parcelId}/valid-from`,
      parcelValidFromUpdateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Deletes existing zone
 */
export const deleteZone = (
    zoneId: string,
    params: DeleteZoneParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/zones/${zoneId}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Updates existing zone
 */
export const updateZone = (
    zoneId: string,
    zoneCreateTo: ZoneCreateTo,
    params: UpdateZoneParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ZoneDetailTo>> => {
    return axios.patch(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/zones/${zoneId}`,
      zoneCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Get seed by id
 */
export const getSeed = (
    seedId: string,
    params: GetSeedParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CropSeedTo>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/seeds/${seedId}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Permanently deletes a seed. Allowed only for PRIVATE catalogue with OWNER role. If the seed is a variety, only that variety is removed. If the seed is the crop's no-variety seed, the whole crop is removed. Returns 409 if the seed/crop is referenced by a seed application, satellite prescription map, action or sowing plan (details include usedIn with the offending services), or if the crop still has varieties that must be deleted first.
 * @summary Delete seed (variety) or crop
 */
export const deleteSeed = (
    seedId: string,
    params: DeleteSeedParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DeleteSeed204>> => {
    return axios.delete(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/seeds/${seedId}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Updates seed variety name or sets/unsets seed hidden status. Hiding (isHidden=true) is rejected with 409 if the seed is referenced by a seed application or by satellite prescription maps; the response details include usedIn with the offending services.
 * @summary Update seed
 */
export const patchSeed = (
    seedId: string,
    cropSeedPatchTo: CropSeedPatchTo,
    params: PatchSeedParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CropSeedTo>> => {
    return axios.patch(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/seeds/${seedId}`,
      cropSeedPatchTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * DEV-1406: writes the "Voda" water/zone buffers and structured slope conditions on all given applications. DEV-1652: onlyFilledFields=true (default) merges buffers per row (type + driftReduction + protectionLevel) and keeps the stored slope conditions when slopeConditions is empty/omitted — a non-empty list is the new slope state, as slopes merge as one group; onlyFilledFields=false replaces buffers and slopes with the payload.
 * @summary Bulk update the water section of selected applications
 */
export const bulkUpdateWaterSection = (
    plantProtectionId: string,
    plantProtectionWaterSectionBulkTo: PlantProtectionWaterSectionBulkTo,
    params: BulkUpdateWaterSectionParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PlantProtectionApplicationSectionBulkResultTo>> => {
    return axios.patch(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protections/${plantProtectionId}/applications/bulk/water`,
      plantProtectionWaterSectionBulkTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * DEV-1406: writes the "Obyvatelstvo" buffers on all given applications. DEV-1652: onlyFilledFields=true (default) merges per buffer row — a supplied row overwrites the stored row with the same type + driftReduction + populationCategory + protectionLevel, stored rows the payload does not carry are kept; onlyFilledFields=false replaces the section's buffers with the payload.
 * @summary Bulk update the population-protection section of selected applications
 */
export const bulkUpdatePopulationSection = (
    plantProtectionId: string,
    plantProtectionBufferSectionBulkTo: PlantProtectionBufferSectionBulkTo,
    params: BulkUpdatePopulationSectionParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PlantProtectionApplicationSectionBulkResultTo>> => {
    return axios.patch(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protections/${plantProtectionId}/applications/bulk/population`,
      plantProtectionBufferSectionBulkTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * DEV-1406: writes the "Dávkování a použití" section (flat dose/usage fields) on all given applications. Buffers and slope conditions are kept. DEV-1652: onlyFilledFields=true (default) merges — an omitted (null) field keeps each application's stored value, omitted dosages/tankMixPartners keep the stored rows; onlyFilledFields=false replaces the section, so whatever the payload omits is cleared.
 * @summary Bulk update the dosage section of selected applications
 */
export const bulkUpdateDosageSection = (
    plantProtectionId: string,
    plantProtectionDosageSectionBulkTo: PlantProtectionDosageSectionBulkTo,
    params: BulkUpdateDosageSectionParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PlantProtectionApplicationSectionBulkResultTo>> => {
    return axios.patch(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protections/${plantProtectionId}/applications/bulk/dosage`,
      plantProtectionDosageSectionBulkTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * DEV-1406: writes the "Kraj pozemku" buffers on all given applications. DEV-1652: onlyFilledFields=true (default) merges per buffer row (type + driftReduction), keeping stored rows the payload does not carry; onlyFilledFields=false replaces the section's buffers with the payload.
 * @summary Bulk update the field-boundary section of selected applications
 */
export const bulkUpdateBoundarySection = (
    plantProtectionId: string,
    plantProtectionBufferSectionBulkTo: PlantProtectionBufferSectionBulkTo,
    params: BulkUpdateBoundarySectionParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PlantProtectionApplicationSectionBulkResultTo>> => {
    return axios.patch(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protections/${plantProtectionId}/applications/bulk/boundary`,
      plantProtectionBufferSectionBulkTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const patchCrop = (
    id: string,
    cropUpdateTo: CropUpdateTo,
    params: PatchCropParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CropTo>> => {
    return axios.patch(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/crops/${id}`,
      cropUpdateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Get public parcels by farm, zone and status, lang is used for language of current crop
 * @summary Get public parcels
 */
export const getParcelByArealName = (
    params: GetParcelByArealNameParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PublicParcelTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/public-api/parcels`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getLandingPage = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/internal/web`,{
        responseType: 'text',
    ...options,}
    );
  }

/**
 * Returns an HTML page with form and visualization.
 * @summary Seed Applications History
 */
export const getSeedApplicationV2DebugPage = (
    params?: GetSeedApplicationV2DebugPageParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/internal/web/seed-applications-v2`,{
        responseType: 'text',
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns just the visualization HTML content for AJAX loading.
 * @summary Parcel timeline content (AJAX)
 */
export const getVisualizationContent = (
    params: GetVisualizationContentParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/internal/web/seed-applications-v2/content`,{
        responseType: 'text',
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Plant Protection Debug — search + structure view
 */
export const getPlantProtectionDebugPage = (
    params?: GetPlantProtectionDebugPageParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/internal/web/plant-protections`,{
        responseType: 'text',
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary AJAX search endpoint — returns HTML fragment with result list
 */
export const searchPlantProtections = (
    params: SearchPlantProtectionsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/internal/web/plant-protections/search`,{
        responseType: 'text',
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary DEV-202 ext: list pending DAVKA texts from dose_text_lookup
 */
export const getPendingDoses = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/internal/web/plant-protections/pending-doses`,{
        responseType: 'text',
    ...options,}
    );
  }

/**
 * @summary Attachment provenance — stored value vs. the attachment text behind it
 */
export const getProvenancePage = (
    params?: GetProvenancePageParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/internal/web/attachment-provenance`,{
        responseType: 'text',
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary AJAX search — HTML fragment with matching products
 */
export const searchAttachmentProvenance = (
    params: SearchAttachmentProvenanceParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/internal/web/attachment-provenance/search`,{
        responseType: 'text',
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Completeness of dose data for products customers actually use
 */
export const getCompletenessPage = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/internal/web/attachment-provenance/completeness`,{
        responseType: 'text',
    ...options,}
    );
  }

/**
 * `size` seasons (default 4) from `startYear`, or the window around today when no start year is given. `earliestStartYear` is the season the farm's oldest parcel record begins in - there is nothing to show below it, because a row of the sowing plan is a parcel. Use it to bound a season picker instead of guessing.
 * @summary Returns the agricultural season window and how far back the farm reaches
 */
export const getDashboardSeasonWindow = (
    params: GetDashboardSeasonWindowParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SowingPlanSeasonWindowTo>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/sowing-plan/v3/seasons`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Counts the parcels the season actually held, retired ones included, with the versions of one parcel counted once - the same figures the sowing plan screen shows beside its table. Crops are attributed to the season they were sown into, so a winter crop harvested a few days past the turnover stays in the season it belongs to (DEV-1233).
 * @summary Returns what grew on the farm in one season, summed per crop
 */
export const getDashboardSeasonOverview = (
    params: GetDashboardSeasonOverviewParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SowingPlanV2OverviewTo>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/sowing-plan/v3/overview`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * <b>Deprecated</b> - use `POST /internal-api/sowing-plan/v3/parcel-versions/search`, which addresses the seasons by start year and serves retired versions too. A seed application is returned in every season its range overlaps. Parcels sown together arrive as one entry listing every member's parcel id. <b>`date-from` / `date-to` do not filter the returned data</b> - they only pick the agricultural seasons (July 1st - June 30th) the range touches, and the response then covers those whole seasons. The returned window is therefore always wider than the requested one:<ul><li>`date-from=2026-03-10&date-to=2026-05-20` returns the whole 2025/2026 season (2025-07-01 - 2026-06-30),</li><li>`date-from=2025-06-15&date-to=2026-07-05` returns three seasons (2024/2025, 2025/2026, 2026/2027), i.e. 2024-07-01 - 2027-06-30.</li></ul>Each returned season carries its own `dateStart` / `dateEnd`; use those, not the requested range, when mapping the result onto a timeline. `crop-ids` narrows which <b>parcels</b> come back (not what their seasons hold): a parcel is kept when one of the crops is attributed to any covered season - the season it was sown into, or a later one it carries over into while its harvest is unrecorded (DEV-1631). A crop that merely finishes in the first days of a covered season therefore does not keep a parcel on its own. `status` picks the parcel versions listed (default OPEN); retired versions are otherwise reachable only through the groups their seed applications belong to.
 * @deprecated
 * @summary Returns seed applications of the given parcels, grouped by agricultural season (V2 sowing plan)
 */
export const getSowingPlans = (
    params: GetSowingPlansParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ParcelWithSowingPlansV2To[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/sowing-plan/v2/parcels`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getSeedsInternal = (
    params: GetSeedsInternalParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<(InternalFertilizerTo | InternalMaterialToBase)[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/seeds`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns parcels valid in specified date range. By default, parcels valid on today's date are returned.
 * @summary Returns list of parcels
 */
export const getInternalParcels = (
    params: GetInternalParcelsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<InternalParcelTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/parcels`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns the details of a parcel by its id. The parcel's crop corresponds to the at-date parameter, which defaults to today's date.
 * @summary Returns parcel detail
 */
export const getParcelDetail = (
    parcelId: string,
    params: GetParcelDetailParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<InternalParcelTo>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/parcels/${parcelId}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getSeedApplications = (
    parcelId: string,
    params: GetSeedApplicationsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<InternalSeedApplicationTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/parcels/${parcelId}/seed-applications`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getSeedApplicationsByParcelIds = (
    params: GetSeedApplicationsByParcelIdsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<InternalSeedApplicationByParcelTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/parcels/current-seed-applications`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getFertilizersInternal = (
    params: GetFertilizersInternalParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<InternalFertilizerTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/fertilizers`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getInternalFertilizerMineralIntake = (
    fertilizerId: string,
    params: GetInternalFertilizerMineralIntakeParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<InternalFertilizerMineralIntakeResponse>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/fertilizers/${fertilizerId}/dose`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Returns farm detail.
 */
export const getInternalFarmDetail = (
    params: GetInternalFarmDetailParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<InternalFarmResponse>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/farms`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Search farms by farmId or name.
 */
export const searchFarms = (
    params?: SearchFarmsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<InternalFarmResponse[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/farms/search`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getCropsInternal = (
    params: GetCropsInternalParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<InternalCropTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/crops`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getCropInternal = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<InternalCropTo>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/crops/${id}`,options
    );
  }

/**
 * @summary Returns farm catalogue types
 */
export const getCropCatalogueType = (
    params: GetCropCatalogueTypeParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CatalogueType>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/internal-api/catalogues/crops`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Dry-run for the 'create action and end crop cultivation' flow. For the given parcels and action date returns which seed applications would be ended/shifted (changes) and which would be skipped, each with a machine-readable reason (e.g. parcel not the last in its group). Writes nothing; the FE calls this when parcels or the date change to warn the user about skipped parcels before saving.
 * @summary Preview ending seed applications by a terminal action
 */
export const previewTermination = (
    params: PreviewTerminationParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SeedApplicationTerminationPreviewTo>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/v2/seed-applications/termination/preview`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns a list of seed applications (individual or grouped) with parcel details that can be connected to the specified seed application or group. Either seed-application-id or group-id must be provided.
 *
 * Candidates must meet the following criteria:
 * - Have the same crop (seedId) and catch crop flag
 * - Be on parcels related to boundary parcels of the target group via event link (split/merge) and geometric intersection
 * - Be first or last on their parcel
 * - Not already in the same group
 * - Must have a crop (seedId cannot be NULL)
 *
 * Response includes parcel details: name, number, area, and validity period.
 * @summary Get connectable seed applications
 */
export const getConnectableSeedApplications = (
    params: GetConnectableSeedApplicationsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<(ConnectableSeedApplicationV2GroupTo | ConnectableSeedApplicationV2To)[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/v2/seed-applications/connectable`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns seed application V2 that was present at parcels at given date. Returns one seed application per parcel. Returns nothing for parcels without a crop at the given time. Uses date-based seed applications V2. The crop is determined solely by parcel and date; action-type is optional and informational only.
 * @summary Get seed applications at date (V2)
 */
export const getSeedApplicationsV2AtDate = (
    params: GetSeedApplicationsV2AtDateParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SeedApplicationV2To[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/v2/seed-applications/at-date`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary V2: Fetches report errors from eagri given guid. Saves artifacts (PDF, JSON) to S3 and sends Slack notification. Does not create report history.
 */
export const checkFertilizerUseReport = (
    params: CheckFertilizerUseReportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/v2/reports/eagri/fertilizer-usage/errors`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * The visible season window. By default it is derived from today's date and always starts one season before the current one so the previous season stays visible across the July 1st turnover; `size` (default 4) then covers previous + current + following seasons (dropping the far-future season the FE used to show). The FE takes this list instead of deriving the window itself (DEV-1357). `isCurrent` marks the season today falls into. Seasons are farm-agnostic (derived purely from the date).<br>`startYear` anchors the window elsewhere, so a window that has already ended can be requested (DEV-1786) - e.g. `startYear=2010&size=6` returns 2010/2011 - 2015/2016. No season of such a window is marked current. Feeding the same window into `/parcels` then returns the parcels as they stood back then, retired ones included.<br>With a farm given, `earliestStartYear` says how far back that farm has anything to show - the season its oldest parcel record begins in. There is nothing below it, because a sowing plan row is a parcel.
 * @summary Returns the agricultural seasons the V2 sowing plan should display
 */
export const getSeasons = (
    params?: GetSeasonsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SowingPlanSeasonWindowTo>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/sowing-plan/v2/seasons`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Exports the same parcels x seasons the `/parcels` endpoint returns (with the same parcel and per-season filters) as an .xlsx file. A parcel is expanded into as many rows as the highest number of seed applications it has in any single season; each season cell shows the crop and its date range, colored by the crop, with markers for catch crop, megaosev and an open lifecycle.
 * @summary Exports the V2 sowing plan to Excel
 */
export const getSeasonsExcel = (
    params: GetSeasonsExcelParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Blob>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/sowing-plan/v2/seasons/excel`,{
        responseType: 'blob',
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns open parcels with land use, center and their seed_application_v2 lifecycles mapped to agricultural seasons (July 1st - June 30th) derived from the start year. A seed application is returned in every season its date range overlaps, so a multi-year crop appears in multiple seasons and a season can hold multiple seed applications. Optionally filters parcels per season; all season filters are combined with logical AND, expressing a crop rotation condition (e.g. wheat in 2025/2026 AND rapeseed in 2026/2027):<ul><li>`season-crop` (repeatable, `<seasonStartYear>:<cropId>,<cropId>`) - the parcel had one of the given crops sown in the season,</li><li>`season-no-crop` (repeatable, `<seasonStartYear>`) - the parcel had no real crop sown in the season,</li><li>`season-crop-type` (repeatable, `<seasonStartYear>:<MAIN_CROP|CATCH_CROP>`) - the parcel had a main crop / catch crop sown in the season.</li></ul>Separately, the <b>shown</b> filter (DEV-1350) ORs across seasons instead of ANDing them, so a crop can be filtered without picking a season. It uses the same sown-into-season attribution as the filters above, so a winter crop harvested a few days into the next season stays in the season it was sown into; a crop whose harvest has not been recorded yet still carries over (DEV-1631):<ul><li>`shown-crop` (`<cropId>,<cropId>`) - the parcel has one of these crops (OR),</li><li>`shown-crop-type` (`<MAIN_CROP|CATCH_CROP>,...`) - the parcel has a real crop of one of these kinds (OR),</li><li>`shown-no-crop` (boolean) - the parcel has no real crop (empty across the window),</li><li>`shown-season` (`<startYear>,<startYear>`) - limits the shown filter to these seasons (OR); omitted = all displayed seasons.</li></ul><br>A window that has ended lists the parcels it held, retired ones included. The versions one parcel was cut into by LPIS updates collapse into a single row carrying what was sown on all of them, with the versions behind it in `mergedVersions` (DEV-1786). The Excel export keeps one row per version instead.Supports pagination with X-Total-Count header.
 * @summary Returns parcels with seed applications mapped to agricultural seasons (V2)
 */
export const getParcelsWithSowingPlans = (
    params: GetParcelsWithSowingPlansParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ParcelWithSowingPlansV2To[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/sowing-plan/v2/parcels`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Aggregates the crops attributed to the season (identified by startYear, agricultural year July 1st - June 30th) on the farm's open parcels: per crop the number of parcels and the area (ha), plus farm totals. A crop is attributed to the season it was sown into (a perennial carries over into a later empty season), the same lifespan-aware rule the per-season parcel filter uses, so clicking a crop filters the parcel table to exactly the reported parcels. Each crop carries its color.
 * @summary Returns the per-season crop summary of the V2 sowing plan
 */
export const getSeasonOverview = (
    params: GetSeasonOverviewParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SowingPlanV2OverviewTo>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/sowing-plan/v2/overview`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Aggregates the crops actually on the farm's parcels at the given date (today when `date` is omitted): per crop the number of parcels and the area (ha), plus farm totals, and a 'no crop' row for parcels with no active seed application. Offered as one option in the overview table next to the per-season overviews. Unlike `/overview` (which attributes a crop to a season by its real sowing date), this is a plain point-in-time snapshot that reconciles 1:1 with the parcel list, every parcel valid at the date counted once. Each crop carries its color.
 * @summary Returns the point-in-time current-state crop summary of the V2 sowing plan
 */
export const getCurrentStateOverview = (
    params: GetCurrentStateOverviewParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SowingPlanV2CurrentStateTo>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/sowing-plan/v2/overview/current-state`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns the nitrate balance report using V2 seed applications as a downloadable Excel file.
 * @summary Get the Nitrate Balance Report V2
 */
export const getNitrateBalanceV2Report = (
    params: GetNitrateBalanceV2ReportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Blob>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/v2/nitrate-balance`,{
        responseType: 'blob',
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 *
 *             Returns crop rotation restriction violations base on parcel LPIS codes.
 *             The validation includes validation of seed applications on historic parcels and validation of sowing plans
 *             on current parcels where seed applications are not yet available.
 * @summary Validates crop rotation restrictions
 */
export const getRestrictionsSowingReport = (
    params: GetRestrictionsSowingReportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ValidationResponseTo>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/restrictions/sowing`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getParcelsReport = (
    params: GetParcelsReportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Blob>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/parcels`,{
        responseType: 'blob',
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getReports = (
    params: GetReportsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ReportHistoryTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/history`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Streamed from our storage, so it stays available after the eAgri submission GUID expires.
 * @summary Downloads the eAgri error report (chybnik) PDF of a submitted report.
 */
export const downloadErrorReport = (
    id: string,
    params: DownloadErrorReportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Blob>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/history/${id}/error-report`,{
        responseType: 'blob',
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Downloads the eAgri confirmation of receipt PDF of a submitted report.
 */
export const downloadConfirmation = (
    id: string,
    params: DownloadConfirmationParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Blob>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/history/${id}/confirmation`,{
        responseType: 'blob',
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getFarmNitrogenReport = (
    params: GetFarmNitrogenReportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/farm-nitrogen`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getCvsReport = (
    params: GetCvsReportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/eagri/sowing-plan`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * MOCK and DISABLED mean a submission never reaches the ministry, so the app can say so before somebody tries.
 * @summary Whether this deployment files eAgri reports for real, mocks them, or refuses them.
 */
export const getSendingMode = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EagriReportSendingModeTo>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/reports/eagri/sending-mode`,options
    );
  }

/**
 * Returns list of parcels by filter criteria. By default, only OPEN parcels are returned.
 *             <h3>Filters</h3>
 *             <p>
 *                 All filters are optional. If value is not provided is null or empty, filter will not be applied.
 *                 Filters can be combined at will.
 *                 Use as query parameters.
 *             </p>
 * @summary Returns all parcels
 */
export const getParcels = (
    params: GetParcelsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ParcelTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary List parcel subtractions
 */
export const getParcelSubtractionHistory = (
    parcelId: string,
    params: GetParcelSubtractionHistoryParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SubtractionResponse[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/${parcelId}/subtractions-history`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Delete restriction from parcels history
 */
export const deleteParcelSubtraction = (
    parcelId: string,
    params: DeleteParcelSubtractionParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/${parcelId}/subtractions-history`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns the crop of the parcel's nearest seed application starting after today. [planned] is null when nothing is sown on the parcel in the future.
 * @summary Nearest planned crop
 */
export const getParcelPlannedCrop = (
    parcelId: string,
    params: GetParcelPlannedCropParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ParcelSeedApplicationWithPlanTo>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/${parcelId}/seed-applications/last-no-crop-with-planned`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns parcel predecessors.
 * @summary Parcel history
 */
export const getParcelPredecessors = (
    parcelId: string,
    params: GetParcelPredecessorsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ParcelPredecessorTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/${parcelId}/predecessors`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns list of parcels that were created when this parcel was retired (successors).
 * @summary Parcel following parcels
 */
export const getParcelFollowing = (
    parcelId: string,
    params: GetParcelFollowingParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ParcelPredecessorTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/${parcelId}/following`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns parcels that were active on the given date and geometrically intersect with the source parcel.
 * @summary Parcel exchange candidates
 */
export const getExchangeCandidates = (
    parcelId: string,
    params: GetExchangeCandidatesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ParcelToV2[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/${parcelId}/exchange-candidates`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns list of parcel restriction and available subsidies from eAgri.
 * @summary Parcel eAgri info
 */
export const getParcelRestrictions = (
    parcelId: string,
    params: GetParcelRestrictionsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ParcelEagriInfoTo>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/${parcelId}/eagri`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Closest distance from landwaterboundary
 */
export const getWaterParcelDistance = (
    params: GetWaterParcelDistanceParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ParcelWaterDistanceTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/water-distance`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns list of parcels with V2 seed applications. Uses seed_application_v2 table with UUID-based lifecycles. Seed applications can be individual or grouped (when parcel was split and lifecycle continued). Supports pagination with X-Total-Count header.
 * @summary Returns all parcels (V2)
 */
export const getParcelsV2 = (
    params: GetParcelsV2Params, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ParcelToV2[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/v2`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns parcel detail with SeedApplicationV2To instead of SeedApplicationTo.
 * @summary Parcel detail (V2)
 */
export const getParcelDetailV2 = (
    parcelId: string,
    params: GetParcelDetailV2Params, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ParcelDetailV2To>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/v2/${parcelId}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns seed applications list with fertilization and revenues. Uses V2 implementation with date-based seed_application_v2 lifecycles instead of action-based boundaries. Results can be either individual parcels or groups (when parcel was split and lifecycle continued). Each result includes a 'resultType' discriminator: 'individual' or 'group'. Individual results contain seedApplication + fertilization + revenue for one parcel. Group results contain aggregated data (total fertilization, total revenue) plus a list of individual parcel data.
 * @summary Parcel seeding history (V2)
 */
export const getSeedApplicationsV2 = (
    parcelId: string,
    params: GetSeedApplicationsV2Params, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<(ParcelSeedApplicationGroupToV2 | ParcelSeedApplicationToV2)[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/v2/${parcelId}/seed-applications`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns action overviews for a specific parcel filtered by V2 seed application IDs (UUIDs). Actions are filtered at database level to only include actions that contain this parcel. Each action's parcels list contains only the requested parcel. Expense amounts are recalculated for the requested parcel (dosePerUnit * parcelActionArea). Crops are narrowed to the crop active on the requested parcel (from its seed application interval). Uses optimized single-query approach with MULTISET for nested data.
 * @summary Get actions for parcel (V2)
 */
export const getActionsV2 = (
    parcelId: string,
    params: GetActionsV2Params, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ActionOverviewV2To[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/v2/${parcelId}/actions`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns statistics about parcels grouped by their crop at the given date using seed_application_v2. Shows count and total area for each crop based on lifecycles active at the date. Considers all parcels valid at the date (including already retired/historical ones). Optional date parameter controls the reference date (defaults to today); mirrors the parcel list at the same date. Includes overall parcel statistics.
 * @summary Returns farm statistics with crop distribution (V2)
 */
export const getParcelStatisticsV2 = (
    params: GetParcelStatisticsV2Params, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FarmStatisticsTo>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/v2/statistics`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns minimal parcel data for map display with V2 seed application colors and crop info. Includes isSowingPerformed flag indicating whether a sowing action exists for each parcel's current seed application. Optional date parameter controls the reference date for determining current seed applications and sowing status (defaults to today).
 * @summary Parcel map data (V2)
 */
export const getParcelMapDataV2 = (
    params: GetParcelMapDataV2Params, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ParcelMapToV2[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/v2/map`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns parcel map data coloured by the crop attributed to the agricultural season (July 1st - June 30th) identified by startYear, using the V2 sowing-plan attribution - so the map agrees with the sowing-plan table and its per-crop summary. Same flat shape as /map. Parcels with no crop attributed to the season are returned with a null crop (left uncoloured). The optional date disambiguates parcels holding more than one crop in the season: the crop present on the parcel at the date wins, otherwise the main crop.
 * @summary Parcel map data by season (V2)
 */
export const getParcelMapDataBySeasonV2 = (
    params: GetParcelMapDataBySeasonV2Params, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ParcelMapToV2[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/v2/map/seasons`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns list of parcels suggested by filter criteria. By default, only OPEN parcels are returned.
 *             <h3>Filters</h3>
 *             <p>
 *                 All filters are optional. If value is not provided is null or empty, filter will not be applied.
 *                 Filters can be combined at will.
 *                 Use as query parameters.
 *             </p>
 * @summary Returns simplified parcel list
 */
export const getParcelSuggestions = (
    params: GetParcelSuggestionsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ParcelSuggestionTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/suggestions`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns available land use.
 * @summary Get land use
 */
export const getLandUse = (
    params?: GetLandUseParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<LandUseResponse[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/land-use`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getParcelCurrentSeedApplications = (
    params: GetParcelCurrentSeedApplicationsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SeedApplicationV2To[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/current-seed-application`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Returns all centers
 */
export const getCenters = (
    params: GetCentersParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CenterTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/centers`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getActionsAndSeedAppsAtDetail = (
    params: GetActionsAndSeedAppsAtDetailParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ActionGeomOverviewTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/parcels/actions/geometry-overview`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns a list of farms  current user is authorized to.
 * @summary Returns current user farms
 */
export const getUserFarms = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FarmTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/farms`,options
    );
  }

/**
 * Returns detail of a farm user is authorized.
 * @summary Returns farm detail
 */
export const getFarmDetail = (
    farmId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FarmTo>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/farms/${farmId}`,options
    );
  }

export const getFarmUpdates = (
    params: GetFarmUpdatesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FarmUpdateFlatResponse[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/farms/updated`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Returns farm settings
 */
export const getFarmSettings = (
    farmId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FarmSettingsTo>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/farms/settings/${farmId}`,options
    );
  }

/**
 *
 *              Returns preview of all data available at LPIS.
 *
 *              NOTE:
 *              It is also possible to download eagri data of test accounts (preferably from localhost).
 *              To do so, set eAgri.url property in agroevidence to https://eagritest.cz/ssl/nosso-app/EPO/WS/v2Online/vOKOsrv.ashx?SERVICEID=
 *                  and then call /auth/eagri-auth endpoint with credentials of the test account.
 *              Once credentials are stored in common.lpis_auth_data, register a new farm (or manually assign LPIS auth to an existing farm if you know what you're doing).
 * @summary Returns detailed LPIS preview.
 */
export const getFullLpisDetail = (
    params: GetFullLpisDetailParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EagriDpbPair[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/farms/lpis-full`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns a farm name from eAGRI if user has already provided auth data (i.e. POST /eagri-auth went OK).
 */
export const eagriFarmName = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EagriAuthValidationResultTo>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/eagri-auth/name`,options
    );
  }

export const searchCountries = (
    params?: SearchCountriesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CountryTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/countries/supported`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary List farm catalogues
 */
export const getCatalogues = (
    params: GetCataloguesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CatalogueTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns seed suggestion sorted by favorites on top
 * @summary Get seed suggestions
 */
export const getSeedSuggestions = (
    params: GetSeedSuggestionsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CropSeedSuggestionTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/seeds/suggestions`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Returns farm primary catalogue type
 */
export const getCropsCatalogSource = (
    params: GetCropsCatalogSourceParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PrimaryCatalogueTo>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/primary`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getPlantProtectionDetail = (
    plantProtectionId: string,
    params: GetPlantProtectionDetailParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PlantProtectionDetailTo>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protections/${plantProtectionId}/detail`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 *
 *             DEV-1045: Registrations of a plant protection product for the new detail page.
 *             Exactly one registration is marked isCurrent — the one whose applications the EPH form currently offers.
 *             isValid says the product may still legally be applied under the registration today: either its eAgri
 *             decision is in force (dNabyloPrMoci..dPlatneDo cover today, reported separately as isLegallyValid) or the
 *             decision expired but the eAgri use-up period for existing stock still runs (useEnd = d_zas_skut, DEV-1637).
 *             It is NOT the product-level eAgri STAV. With only-valid=true returns only the valid ones; isCurrent is
 *             still derived from all of them. Validity dates come as legalEnd (end of the decision), marketEnd (end of
 *             placing on the market) and useEnd (last day stock may be applied) — useEnd is what "ukončení používání"
 *             means, legalEnd is not.
 * @summary List plant protection registrations (new detail page)
 */
export const getPlantProtectionDetailRegistrations = (
    plantProtectionId: string,
    params: GetPlantProtectionDetailRegistrationsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PlantProtectionDetailRegistrationTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protections/${plantProtectionId}/detail/registrations`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 *
 *             DEV-1045: Paged + sorted applications of a single registration for the new detail page.
 *             Single search param matches either the crop name OR the organism name (case- and
 *             accent-insensitive substring); plus standard paging params (page, per-page, sort-col,
 *             sort-dir); total count in X-Total-Count header.
 *             Sortable columns: cropName (default), organismName, maxDose, minBbch, legalEnd.
 * @summary List applications of a registration (new detail page)
 */
export const getPlantProtectionDetailApplicationRows = (
    plantProtectionId: string,
    registrationId: string,
    params: GetPlantProtectionDetailApplicationRowsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PlantProtectionDetailApplicationRowTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protections/${plantProtectionId}/detail/registrations/${registrationId}/applications`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getPlantProtectionDetailApplications = (
    plantProtectionId: string,
    params: GetPlantProtectionDetailApplicationsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PlantProtectionDetailRegistrationApplicationTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protections/${plantProtectionId}/detail/applications`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 *
 *             DEV-1045: Detail of a single application structured into sections:
 *             basic / dosage / population / water / fieldBoundary.
 * @summary Sectioned application detail (new detail page)
 */
export const getPlantProtectionApplicationSections = (
    plantProtectionId: string,
    applicationId: string,
    params: GetPlantProtectionApplicationSectionsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PlantProtectionApplicationSectionsTo>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protections/${plantProtectionId}/detail/applications/${applicationId}/sections`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getPlantProtectionApplications = (
    plantProtectionId: string,
    params: GetPlantProtectionApplicationsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PlantProtectionApplicationTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protections/${plantProtectionId}/applications`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary List plant protection suggestions
 */
export const getPlantProtectionSuggestions = (
    params: GetPlantProtectionSuggestionsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PlantProtectionSuggestionTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protections/suggestions`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns farm plant protection products catalogue
 * @summary List plant protection products
 */
export const getPlantProtections = (
    params: GetPlantProtectionsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PlantProtectionOverviewTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protections/overview`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns paginated list of sync reports with summary statistics. X-Total-Count header contains total count.
 * @summary List sync reports
 */
export const getPlantProtectionSyncReports = (
    params?: GetPlantProtectionSyncReportsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SyncReportSummaryResponse[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protection/sync-reports`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns sync report with statistics.
 * @summary Get sync report by ID
 */
export const getReport = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SyncReportDetailResponse>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protection/sync-reports/${id}`,options
    );
  }

/**
 * Returns paginated list of warnings. Optional filter by warning type. X-Total-Count header contains total count.
 * @summary Get warnings for sync report
 */
export const getReportWarnings = (
    id: string,
    params?: GetReportWarningsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SyncWarningResponse[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protection/sync-reports/${id}/warnings`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns paginated list of per-product statistics. Optional filter by product name. X-Total-Count header contains total count.
 * @summary Get per-product statistics for sync report
 */
export const getReportProductStats = (
    id: string,
    params?: GetReportProductStatsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ProductSyncStatsResponse[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protection/sync-reports/${id}/products`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns the most recent sync report with statistics.
 * @summary Get latest sync report
 */
export const getLatestReport = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SyncReportDetailResponse>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protection/sync-reports/latest`,options
    );
  }

export const getBioFunction = (
    params: GetBioFunctionParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/plant-protection/bio-function`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getFertilizerMineralIntake = (
    fertilizerId: string,
    params: GetFertilizerMineralIntakeParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FertilizerMineralIntakeResponse>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/fertilizers/${fertilizerId}/dose`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns fertilizers suggestions sorted by favorites on top
 * @summary Get fertilizer suggestions
 */
export const getFertilizerSuggestions = (
    params: GetFertilizerSuggestionsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FertilizerSuggestionTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/fertilizers/suggestions`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getEagriFertilizerNitrogenCategoryType = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EnumEntriesEagriFertilizerNitrogenCategory>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/fertilizers/eagri-nitrogen-category`,options
    );
  }

/**
 * @summary Režim registrace hnojiva
 */
export const getFertilizerRegistratinType = (
    params?: GetFertilizerRegistratinTypeParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EagriFertilizerRegistrationTypeTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/eagri/fertilizer-registration-type`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Číselník kategorie hnojiva z pohledu obsahu dusíku
 */
export const getFertilizerNitrogenCategory = (
    params?: GetFertilizerNitrogenCategoryParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EagriFertilizerNitrogenCategoryTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/eagri/fertilizer-nitrogen-categories`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Číselník druhů hnojiva
 */
export const getFertilizerTypes = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EagriFertilizerKindTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/eagri/fertilizer-kind`,options
    );
  }

/**
 * Products are sorted by sort-col and sort-dir; defaults to productName ascending.
 * @summary Crop detail
 */
export const getCrop = (
    cropId: string,
    params: GetCropParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CropDetailTo>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/crops/${cropId}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Not available for EAGRI or PPA_SK farms. Possible csv headers, only name is required: name
 * @summary Export crops catalogue as CSV
 */
export const exportCropsToCSV = (
    params: ExportCropsToCSVParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Blob>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/crops/export`,{
        responseType: 'blob',
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns the active revision date and feature count from both tables, plus the feature counts the detector last observed on the VÚV side. No network call is made — purely DB read, suitable for an admin dashboard.
 * @summary Current state of the water-protection-zones data
 */
export const status = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WaterProtectionZonesStatusTo>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/water-protection-zones/status`,options
    );
  }

/**
 * Returns statistics for the selected farm.
 * @summary Get farm statistics
 */
export const getFarmStatistics = (
    params: GetFarmStatisticsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<StatisticsTo>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/management/statistics`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns information about the last successful sync and the most recent sync attempt. Use this to check when data was last updated and if there were any recent failures.
 * @summary Get landscape synchronization status
 */
export const getSyncStatus = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<LandscapeSyncStatusTo>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/landscape/sync/status`,options
    );
  }

export const getAllFarms = (
    params?: GetAllFarmsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AdminFarmTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/farms`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 *
 *              Returns preview of all data available at LPIS.
 *
 *              NOTE:
 *              It is also possible to download eagri data of test accounts (preferably from localhost).
 *              To do so, set eAgri.url property in agroevidence to https://eagritest.cz/ssl/nosso-app/EPO/WS/v2Online/vOKOsrv.ashx?SERVICEID=
 *                  and then call /auth/eagri-auth endpoint with credentials of the test account.
 *              Once credentials are stored in common.lpis_auth_data, register a new farm (or manually assign LPIS auth to an existing farm if you know what you're doing).
 * @summary Returns detailed LPIS preview.
 */
export const getAdminFullLpisDetail = (
    farmId: string,
    params?: GetAdminFullLpisDetailParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EagriDpbPair[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/farms/${farmId}/lpis-full`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Runs all enabled farm dependency checks. Empty list means the farm can be soft-deleted; non-empty lists every active service.
 * @summary List active services for selected farm.
 */
export const getActiveServices = (
    farmId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FarmDeletionBlocker[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/farms/${farmId}/active-services`,options
    );
  }

/**
 * Also lists the mocked submissions and how many times their evaluation has been fetched.
 * @summary Current behaviour of the mocked eAgri report endpoints.
 */
export const getState = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EagriReportMockStateTo>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/eagri-reports/mock`,options
    );
  }

/**
 * @summary Returns eAgri services sync status
 */
export const getEagriSyncStatus = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EagriServiceSyncStatusTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/admin/catalogues/eagri/sync`,options
    );
  }

/**
 * Returns action detail using seed_application_v2 (date-based). For sowing actions, retrieves cropUseType and seedApplicationType from V2 seed applications.
 * @summary Get action detail (V2)
 */
export const getActionV2 = (
    actionId: string,
    params: GetActionV2Params, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ActionEPHDetailTo | ActionNonFieldDetailTo | ActionOtherDetailTo | ActionRevenueDetailTo | ActionSowingDetailTo>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/v2/${actionId}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns V2 seed applications for given parcels at a specific date with target crop. Used in EPH (fertilization) forms to determine which seed application to target.
 * @summary Get target seed application V2 for EPH action
 */
export const getTargetSeedApplication = (
    params: GetTargetSeedApplicationParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TargetSeedApplicationV2ResponseTo>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/v2/target-seed-application`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns action overviews filtered by V2 seed application IDs (UUIDs). Uses optimized single-query approach with MULTISET for nested data. Sorting is controlled by sort-col and sort-dir; defaults to date, newest first.
 * @summary Get action overviews (V2)
 */
export const getActionsOverviewV2 = (
    params: GetActionsOverviewV2Params, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ActionOverviewV2To[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/v2/overview`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getUsedSeeds = (
    params: GetUsedSeedsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CropSeedSuggestionTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/used-materials/seeds`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getUsedPlantProtections = (
    params: GetUsedPlantProtectionsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PlantProtectionSuggestionTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/used-materials/plant-protections`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getUsedFertilizers = (
    params: GetUsedFertilizersParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FertilizerSuggestionTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/used-materials/fertilizers`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns list of CropGrowthStage enum values.
 * @summary List available crop stage variants
 */
export const getCropGrowthStages = (
    params: GetCropGrowthStagesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CropGrowthStageTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/crop-growth-stages`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getActionTypes = (
    params?: GetActionTypesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ActionTypeTo[]>> => {
    return axios.get(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/action-types`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Sets the seed application's group_id to NULL, removing it from its current group. If only 1 member remains in the group after removal, that member's group_id is also automatically set to NULL (groups must have 2+ members).
 * @summary Remove seed application from its group
 */
export const removeFromGroup = (
    id: string,
    params: RemoveFromGroupParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `${window.ENV.AGROEVIDENCE_URL}/api/v2/seed-applications/${id}/group`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Removes a single product from the crop use type on the crop. Rejected when the product is used in sowing or harvest.
 * @summary Delete a product from a crop use type on a crop
 */
export const deleteProductFromCropUse = (
    id: string,
    cropId: string,
    productId: string,
    params: DeleteProductFromCropUseParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DeleteProductFromCropUse204>> => {
    return axios.delete(
      `${window.ENV.AGROEVIDENCE_URL}/api/catalogues/crops/crop-use/${id}/crop/${cropId}/product/${productId}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const deleteActions = (
    params: DeleteActionsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const deleteAction = (
    actionId: string,
    params: DeleteActionParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `${window.ENV.AGROEVIDENCE_URL}/api/actions/${actionId}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export type UpdateCentersResult = AxiosResponse<InternalCenterTo[]>
export type UpdateSeedApplicationV2Result = AxiosResponse<SeedApplicationV2To>
export type DeleteSeedApplicationV2Result = AxiosResponse<void>
export type UpdateSeedApplicationV2GroupResult = AxiosResponse<SeedApplicationV2GroupToV2>
export type DisbandGroupResult = AxiosResponse<void>
export type UpdateFarmFromShapefileResult = AxiosResponse<unknown>
export type GetEagriAuthResult = AxiosResponse<EagriAuthDataValidationResponseTo>
export type PutEagriAuthResult = AxiosResponse<EagriAuthDataValidationResponseTo>
export type UpdateFarmResult = AxiosResponse<void>
export type GetFacilityResult = AxiosResponse<FacilityTo>
export type UpdateFacilityResult = AxiosResponse<FacilityTo>
export type DeleteFacilityResult = AxiosResponse<void>
export type PutPlantProtectionResult = AxiosResponse<PlantProtectionDetailTo>
export type PatchPlantProtectionResult = AxiosResponse<void>
export type UpdateRegistrationResult = AxiosResponse<PlantProtectionRegistrationTo>
export type UpdatePlantProtectionHeaderResult = AxiosResponse<PlantProtectionDetailTo>
export type PutPlantProtectionRegistrationApplicationResult = AxiosResponse<void>
export type DeletePlantProtectionRegistrationApplicationResult = AxiosResponse<void>
export type GetFertilizerResult = AxiosResponse<FertilizerDetailTo>
export type PutFertilizerResult = AxiosResponse<FertilizerDetailTo>
export type HideFertilizerResult = AxiosResponse<FertilizerDetailTo>
export type UpdateCropProductsResult = AxiosResponse<void>
export type PutCropProductResult = AxiosResponse<CropProductTo>
export type PutCropUseTypeResult = AxiosResponse<CropUseTypeTo>
export type PutCropGroupResult = AxiosResponse<CropGroupResponseTo>
export type DeleteCropGroupResult = AxiosResponse<void>
export type UpdateSkeagisFarmResult = AxiosResponse<SkeagisFarmUpdateResult>
export type GetAdminFarmDetailResult = AxiosResponse<AdminFarmTo>
export type PutFarmResult = AxiosResponse<AdminFarmTo>
export type DeleteFarmResult = AxiosResponse<AdminFarmTo>
export type UpdateFarmCurrentParcelsResult = AxiosResponse<void>
export type UpdateAllFarmsCurrentParcelsResult = AxiosResponse<void>
export type ResaveActionStoreTransactionsResult = AxiosResponse<void>
export type UpdateSkeagisStateResult = AxiosResponse<FarmIntegrationResponse>
export type CreateNewSkeagisIntegrationResult = AxiosResponse<FarmIntegrationResponse>
export type SetScenarioResult = AxiosResponse<EagriReportMockStateTo>
export type ResetScenarioResult = AxiosResponse<EagriReportMockStateTo>
export type UpdateSowingActionResult = AxiosResponse<ActionIdTo>
export type UpdateOtherActionResult = AxiosResponse<ActionIdTo>
export type UpdateNonFieldActionResult = AxiosResponse<ActionIdTo>
export type UpdateMowingActionResult = AxiosResponse<ActionIdTo>
export type UpdateHarvestActionResult = AxiosResponse<ActionIdTo>
export type UpdateEPHActionResult = AxiosResponse<ActionIdTo>
export type GetDebugPageResult = AxiosResponse<string>
export type SetScenario1Result = AxiosResponse<string>
export type ResetScenario1Result = AxiosResponse<string>
export type WriteSeedApplicationBatchResult = AxiosResponse<InternalSeedApplicationBatchResultTo>
export type SearchDashboardSowingPlansResult = AxiosResponse<ParcelWithSowingPlansV2To[]>
export type SearchParcelVersionSowingPlansResult = AxiosResponse<ParcelWithSowingPlansV2To[]>
export type WriteSeedApplicationsResult = AxiosResponse<InternalSeedApplicationBatchResultTo>
export type SearchSowingPlansResult = AxiosResponse<ParcelWithSowingPlansV2To[]>
export type GetPlantProtectionsInternalResult = AxiosResponse<(InternalFertilizerTo | InternalMaterialToBase)[]>
export type GetParcelsWithSuccessorsResult = AxiosResponse<InternalParcelWithSuccessorsTo[]>
export type SearchInternalParcelsResult = AxiosResponse<InternalParcelTo[]>
export type GetParcelIntersectionsResult = AxiosResponse<InternalParcelTo[]>
export type GetInternationalParcelIntersectionsResult = AxiosResponse<InternalIntersectionParcelTo[]>
export type GetOpenParcelsIntersectingByParcelsResult = AxiosResponse<InternalParcelIntersectionTo[]>
export type GetActionInfoResult = AxiosResponse<InternalActionInfo[]>
export type CreateDraftActionResult = AxiosResponse<InternalActionIdResponse>
export type BulkDeleteActionsResult = AxiosResponse<InternalBulkDeleteResult>
export type GetSeedApplicationV2sResult = AxiosResponse<(SeedApplicationV2GroupToV2 | SeedApplicationV2To)[]>
export type CreateSeedApplicationV2Result = AxiosResponse<SeedApplicationV2To>
export type CreateSeedApplicationV2GroupResult = AxiosResponse<SeedApplicationV2GroupToV2>
export type CreateBulkResult = AxiosResponse<SeedApplicationV2BulkResultTo>
export type PreviewBulkCreateResult = AxiosResponse<SeedApplicationV2BulkPreviewTo>
export type EditBulkResult = AxiosResponse<SeedApplicationV2BulkEditResultTo>
export type PreviewBulkEditResult = AxiosResponse<SeedApplicationV2BulkPreviewTo>
export type DeleteBulkResult = AxiosResponse<SeedApplicationV2BulkDeleteResultTo>
export type SendPorUserReportToEagriV2Result = AxiosResponse<PlantProtectionPairingResultTo>
export type GetPorUseReportBodyV2Result = AxiosResponse<PorUseBody>
export type DownloadPorUseReportXmlV2Result = AxiosResponse<Blob>
export type SendFertilizerUseReportToEagriV2Result = AxiosResponse<EagriReportResponse>
export type GetFertilizerUseReportBodyV2Result = AxiosResponse<FertiliserUseBody>
export type GetSeededAreasV2ReportResult = AxiosResponse<string>
export type PostSeededAreasV2ReportResult = AxiosResponse<string>
export type GetSeedApplicationsV2ReportResult = AxiosResponse<string>
export type PostSeedApplicationsV2ReportResult = AxiosResponse<string>
export type GetRevenuesV2ReportResult = AxiosResponse<string>
export type PostRevenuesV2ReportResult = AxiosResponse<string>
export type GetPorUsageReportResult = AxiosResponse<string>
export type PostPorUsageReportResult = AxiosResponse<string>
export type GetPorConsumptionByPPReportResult = AxiosResponse<string>
export type PostPorConsumptionByPPReportResult = AxiosResponse<string>
export type GetPorConsumptionByCropReportResult = AxiosResponse<string>
export type PostPorConsumptionByCropReportResult = AxiosResponse<string>
export type GetNonFieldPorUsageReportResult = AxiosResponse<string>
export type PostNonFieldPorUsageReportResult = AxiosResponse<string>
export type GetFertilizerUsageReportResult = AxiosResponse<string>
export type PostFertilizerUsageReportResult = AxiosResponse<string>
export type GetFertilizerOrganicReportResult = AxiosResponse<string>
export type PostFertilizerOrganicReportResult = AxiosResponse<string>
export type GetFertilizerConsumptionReportResult = AxiosResponse<string>
export type PostFertilizerConsumptionReportResult = AxiosResponse<string>
export type GetFertilizerConsumptionByCropReportResult = AxiosResponse<string>
export type PostFertilizerConsumptionByCropReportResult = AxiosResponse<string>
export type GetActionsReportResult = AxiosResponse<string>
export type PostActionsReportResult = AxiosResponse<string>
export type RegisterWithShapeFileResult = AxiosResponse<unknown>
export type ValidateShapefileResult = AxiosResponse<unknown>
export type RegisterEmptyFarmResult = AxiosResponse<unknown>
export type RegisterWithEagriResult = AxiosResponse<unknown>
export type GetParcelsSubtractionResult = AxiosResponse<SubtractionTo>
export type GetZonesResult = AxiosResponse<ZoneDetailTo[]>
export type CreateZoneResult = AxiosResponse<ZoneDetailTo>
export type PostParcelVegetationStripResult = AxiosResponse<ParcelVegetationStripResponse[]>
export type RecountSubtractionsForActionResult = AxiosResponse<ParcelSubtractionResponse[]>
export type GetParcelSubtractionGeometryResult = AxiosResponse<ParcelGeometryResponse>
export type GetParcelSubtractionGeometriesResult = AxiosResponse<ParcelSubtractionGeometriesTo[]>
export type GetParcelAreaAfterSubtractionResult = AxiosResponse<ParcelAreaTo[]>
export type GetAvailableUpdatesResult = AxiosResponse<FarmUpdateChangesResponse>
export type RequestAvailableUpdatesResult = AxiosResponse<void>
export type GetFacilitiesResult = AxiosResponse<FacilityTo[]>
export type CreateFacilityResult = AxiosResponse<FacilityTo>
export type StoreAuthDataResult = AxiosResponse<EagriAuthValidationResultTo>
export type GetSeedsResult = AxiosResponse<CropSeedTo[]>
export type PostSeedResult = AxiosResponse<CropSeedTo>
export type PostPlantProtectionResult = AxiosResponse<PlantProtectionDetailTo>
export type CopyPlantProtectionResult = AxiosResponse<PlantProtectionDetailTo>
export type CreateRegistrationResult = AxiosResponse<PlantProtectionRegistrationTo>
export type PostPlantProtectionRegistrationApplicationResult = AxiosResponse<void>
export type BulkCreatePlantProtectionRegistrationApplicationsResult = AxiosResponse<PlantProtectionApplicationBulkResultTo>
export type ImportPlantProtectionsFromCSVResult = AxiosResponse<void>
export type CreatePlantProtectionHeaderResult = AxiosResponse<PlantProtectionDetailTo>
export type GetOrganismsResult = AxiosResponse<OrganismTo[]>
export type CreateOrganismsResult = AxiosResponse<OrganismTo>
export type GetActiveSubstancesResult = AxiosResponse<ActiveSubstanceTo[]>
export type PostActiveSubstanceResult = AxiosResponse<ActiveSubstanceTo>
export type GetFertilizersResult = AxiosResponse<FertilizerTo[]>
export type PostFertilizerResult = AxiosResponse<FertilizerDetailTo>
export type ImportFertilizersFromCSVResult = AxiosResponse<void>
export type GetCropsResult = AxiosResponse<CropTo[]>
export type PostCropResult = AxiosResponse<CropTo>
export type GetCropProductsResult = AxiosResponse<CropProductTo[]>
export type PostCropProductResult = AxiosResponse<CropProductTo>
export type ImportCropsFromCSVResult = AxiosResponse<void>
export type GetCropUseTypesResult = AxiosResponse<CropUseTypeTo[]>
export type PostCropUseTypeResult = AxiosResponse<CropUseTypeTo>
export type AttachCropUseTypeToCropResult = AxiosResponse<CropUseTypeTo>
export type DetachCropUseTypeFromCropResult = AxiosResponse<DetachCropUseTypeFromCrop204>
export type GetCropGroupsResult = AxiosResponse<CropGroupResponseTo[]>
export type PostCropGroupResult = AxiosResponse<CropGroupResponseTo>
export type ImportSurfaceWaterProtectionZonesResult = AxiosResponse<void>
export type ImportFromVuvZipResult = AxiosResponse<WaterProtectionZonesImportResult>
export type ImportGroundWaterProtectionZonesResult = AxiosResponse<void>
export type CheckForUpdateResult = AxiosResponse<WaterProtectionZonesUpdateCheckResult>
export type SyncCountiesResult = AxiosResponse<void>
export type UpdateNitrateVulnerableResult = AxiosResponse<AdminFarmManagementTo[]>
export type GetNitrateVulnerableOnFarmResult = AxiosResponse<AdminNitrateVulnerableZoneTo[]>
export type PostNitrateVulnerableOnFarmResult = AxiosResponse<AdminNitrateVulnerableZoneTo[]>
export type MoveParcelValiditiesToNewestSowingResult = AxiosResponse<AdminParcelValidityMoveResult>
export type MoveActionsAfterUpdateResult = AxiosResponse<AdminActionMoveResult>
export type CreateTestEagriFarmResult = AxiosResponse<void>
export type TriggerSyncResult = AxiosResponse<SyncStats>
export type RefreshFarmCacheResult = AxiosResponse<void>
export type GetLpisBlocksResult = AxiosResponse<unknown>
export type UpdateEagriFarmResult = AxiosResponse<unknown>
export type PostSyncResult = AxiosResponse<void>
export type GetTargetSeedApplicationAccountableNitrogenResult = AxiosResponse<ParcelAccountableNitrogenV2To[]>
export type SplitActionResult = AxiosResponse<SplitActionResponse>
export type CreateSowingActionResult = AxiosResponse<ActionIdTo>
export type CreateOtherActionResult = AxiosResponse<ActionIdTo>
export type CreateNonFieldActionResult = AxiosResponse<ActionIdTo>
export type CreateMowingActionResult = AxiosResponse<ActionIdTo>
export type CreateHarvestActionResult = AxiosResponse<ActionIdTo>
export type CreateEPHActionResult = AxiosResponse<ActionIdTo>
export type ValidateEPHActionResult = AxiosResponse<ValidationResponseTo>
export type GetParcelResult = AxiosResponse<ParcelDetailTo>
export type PatchParcelResult = AxiosResponse<void>
export type PatchParcelValidFromResult = AxiosResponse<ParcelValidityTo>
export type DeleteZoneResult = AxiosResponse<void>
export type UpdateZoneResult = AxiosResponse<ZoneDetailTo>
export type GetSeedResult = AxiosResponse<CropSeedTo>
export type DeleteSeedResult = AxiosResponse<DeleteSeed204>
export type PatchSeedResult = AxiosResponse<CropSeedTo>
export type BulkUpdateWaterSectionResult = AxiosResponse<PlantProtectionApplicationSectionBulkResultTo>
export type BulkUpdatePopulationSectionResult = AxiosResponse<PlantProtectionApplicationSectionBulkResultTo>
export type BulkUpdateDosageSectionResult = AxiosResponse<PlantProtectionApplicationSectionBulkResultTo>
export type BulkUpdateBoundarySectionResult = AxiosResponse<PlantProtectionApplicationSectionBulkResultTo>
export type PatchCropResult = AxiosResponse<CropTo>
export type GetParcelByArealNameResult = AxiosResponse<PublicParcelTo[]>
export type GetLandingPageResult = AxiosResponse<string>
export type GetSeedApplicationV2DebugPageResult = AxiosResponse<string>
export type GetVisualizationContentResult = AxiosResponse<string>
export type GetPlantProtectionDebugPageResult = AxiosResponse<string>
export type SearchPlantProtectionsResult = AxiosResponse<string>
export type GetPendingDosesResult = AxiosResponse<string>
export type GetProvenancePageResult = AxiosResponse<string>
export type SearchAttachmentProvenanceResult = AxiosResponse<string>
export type GetCompletenessPageResult = AxiosResponse<string>
export type GetDashboardSeasonWindowResult = AxiosResponse<SowingPlanSeasonWindowTo>
export type GetDashboardSeasonOverviewResult = AxiosResponse<SowingPlanV2OverviewTo>
export type GetSowingPlansResult = AxiosResponse<ParcelWithSowingPlansV2To[]>
export type GetSeedsInternalResult = AxiosResponse<(InternalFertilizerTo | InternalMaterialToBase)[]>
export type GetInternalParcelsResult = AxiosResponse<InternalParcelTo[]>
export type GetParcelDetailResult = AxiosResponse<InternalParcelTo>
export type GetSeedApplicationsResult = AxiosResponse<InternalSeedApplicationTo[]>
export type GetSeedApplicationsByParcelIdsResult = AxiosResponse<InternalSeedApplicationByParcelTo[]>
export type GetFertilizersInternalResult = AxiosResponse<InternalFertilizerTo[]>
export type GetInternalFertilizerMineralIntakeResult = AxiosResponse<InternalFertilizerMineralIntakeResponse>
export type GetInternalFarmDetailResult = AxiosResponse<InternalFarmResponse>
export type SearchFarmsResult = AxiosResponse<InternalFarmResponse[]>
export type GetCropsInternalResult = AxiosResponse<InternalCropTo[]>
export type GetCropInternalResult = AxiosResponse<InternalCropTo>
export type GetCropCatalogueTypeResult = AxiosResponse<CatalogueType>
export type PreviewTerminationResult = AxiosResponse<SeedApplicationTerminationPreviewTo>
export type GetConnectableSeedApplicationsResult = AxiosResponse<(ConnectableSeedApplicationV2GroupTo | ConnectableSeedApplicationV2To)[]>
export type GetSeedApplicationsV2AtDateResult = AxiosResponse<SeedApplicationV2To[]>
export type CheckFertilizerUseReportResult = AxiosResponse<void>
export type GetSeasonsResult = AxiosResponse<SowingPlanSeasonWindowTo>
export type GetSeasonsExcelResult = AxiosResponse<Blob>
export type GetParcelsWithSowingPlansResult = AxiosResponse<ParcelWithSowingPlansV2To[]>
export type GetSeasonOverviewResult = AxiosResponse<SowingPlanV2OverviewTo>
export type GetCurrentStateOverviewResult = AxiosResponse<SowingPlanV2CurrentStateTo>
export type GetNitrateBalanceV2ReportResult = AxiosResponse<Blob>
export type GetRestrictionsSowingReportResult = AxiosResponse<ValidationResponseTo>
export type GetParcelsReportResult = AxiosResponse<Blob>
export type GetReportsResult = AxiosResponse<ReportHistoryTo[]>
export type DownloadErrorReportResult = AxiosResponse<Blob>
export type DownloadConfirmationResult = AxiosResponse<Blob>
export type GetFarmNitrogenReportResult = AxiosResponse<string>
export type GetCvsReportResult = AxiosResponse<void>
export type GetSendingModeResult = AxiosResponse<EagriReportSendingModeTo>
export type GetParcelsResult = AxiosResponse<ParcelTo[]>
export type GetParcelSubtractionHistoryResult = AxiosResponse<SubtractionResponse[]>
export type DeleteParcelSubtractionResult = AxiosResponse<void>
export type GetParcelPlannedCropResult = AxiosResponse<ParcelSeedApplicationWithPlanTo>
export type GetParcelPredecessorsResult = AxiosResponse<ParcelPredecessorTo[]>
export type GetParcelFollowingResult = AxiosResponse<ParcelPredecessorTo[]>
export type GetExchangeCandidatesResult = AxiosResponse<ParcelToV2[]>
export type GetParcelRestrictionsResult = AxiosResponse<ParcelEagriInfoTo>
export type GetWaterParcelDistanceResult = AxiosResponse<ParcelWaterDistanceTo[]>
export type GetParcelsV2Result = AxiosResponse<ParcelToV2[]>
export type GetParcelDetailV2Result = AxiosResponse<ParcelDetailV2To>
export type GetSeedApplicationsV2Result = AxiosResponse<(ParcelSeedApplicationGroupToV2 | ParcelSeedApplicationToV2)[]>
export type GetActionsV2Result = AxiosResponse<ActionOverviewV2To[]>
export type GetParcelStatisticsV2Result = AxiosResponse<FarmStatisticsTo>
export type GetParcelMapDataV2Result = AxiosResponse<ParcelMapToV2[]>
export type GetParcelMapDataBySeasonV2Result = AxiosResponse<ParcelMapToV2[]>
export type GetParcelSuggestionsResult = AxiosResponse<ParcelSuggestionTo[]>
export type GetLandUseResult = AxiosResponse<LandUseResponse[]>
export type GetParcelCurrentSeedApplicationsResult = AxiosResponse<SeedApplicationV2To[]>
export type GetCentersResult = AxiosResponse<CenterTo[]>
export type GetActionsAndSeedAppsAtDetailResult = AxiosResponse<ActionGeomOverviewTo[]>
export type GetUserFarmsResult = AxiosResponse<FarmTo[]>
export type GetFarmDetailResult = AxiosResponse<FarmTo>
export type GetFarmUpdatesResult = AxiosResponse<FarmUpdateFlatResponse[]>
export type GetFarmSettingsResult = AxiosResponse<FarmSettingsTo>
export type GetFullLpisDetailResult = AxiosResponse<EagriDpbPair[]>
export type EagriFarmNameResult = AxiosResponse<EagriAuthValidationResultTo>
export type SearchCountriesResult = AxiosResponse<CountryTo[]>
export type GetCataloguesResult = AxiosResponse<CatalogueTo[]>
export type GetSeedSuggestionsResult = AxiosResponse<CropSeedSuggestionTo[]>
export type GetCropsCatalogSourceResult = AxiosResponse<PrimaryCatalogueTo>
export type GetPlantProtectionDetailResult = AxiosResponse<PlantProtectionDetailTo>
export type GetPlantProtectionDetailRegistrationsResult = AxiosResponse<PlantProtectionDetailRegistrationTo[]>
export type GetPlantProtectionDetailApplicationRowsResult = AxiosResponse<PlantProtectionDetailApplicationRowTo[]>
export type GetPlantProtectionDetailApplicationsResult = AxiosResponse<PlantProtectionDetailRegistrationApplicationTo[]>
export type GetPlantProtectionApplicationSectionsResult = AxiosResponse<PlantProtectionApplicationSectionsTo>
export type GetPlantProtectionApplicationsResult = AxiosResponse<PlantProtectionApplicationTo[]>
export type GetPlantProtectionSuggestionsResult = AxiosResponse<PlantProtectionSuggestionTo[]>
export type GetPlantProtectionsResult = AxiosResponse<PlantProtectionOverviewTo[]>
export type GetPlantProtectionSyncReportsResult = AxiosResponse<SyncReportSummaryResponse[]>
export type GetReportResult = AxiosResponse<SyncReportDetailResponse>
export type GetReportWarningsResult = AxiosResponse<SyncWarningResponse[]>
export type GetReportProductStatsResult = AxiosResponse<ProductSyncStatsResponse[]>
export type GetLatestReportResult = AxiosResponse<SyncReportDetailResponse>
export type GetBioFunctionResult = AxiosResponse<string[]>
export type GetFertilizerMineralIntakeResult = AxiosResponse<FertilizerMineralIntakeResponse>
export type GetFertilizerSuggestionsResult = AxiosResponse<FertilizerSuggestionTo[]>
export type GetEagriFertilizerNitrogenCategoryTypeResult = AxiosResponse<EnumEntriesEagriFertilizerNitrogenCategory>
export type GetFertilizerRegistratinTypeResult = AxiosResponse<EagriFertilizerRegistrationTypeTo[]>
export type GetFertilizerNitrogenCategoryResult = AxiosResponse<EagriFertilizerNitrogenCategoryTo[]>
export type GetFertilizerTypesResult = AxiosResponse<EagriFertilizerKindTo[]>
export type GetCropResult = AxiosResponse<CropDetailTo>
export type ExportCropsToCSVResult = AxiosResponse<Blob>
export type StatusResult = AxiosResponse<WaterProtectionZonesStatusTo>
export type GetFarmStatisticsResult = AxiosResponse<StatisticsTo>
export type GetSyncStatusResult = AxiosResponse<LandscapeSyncStatusTo>
export type GetAllFarmsResult = AxiosResponse<AdminFarmTo[]>
export type GetAdminFullLpisDetailResult = AxiosResponse<EagriDpbPair[]>
export type GetActiveServicesResult = AxiosResponse<FarmDeletionBlocker[]>
export type GetStateResult = AxiosResponse<EagriReportMockStateTo>
export type GetEagriSyncStatusResult = AxiosResponse<EagriServiceSyncStatusTo[]>
export type GetActionV2Result = AxiosResponse<ActionEPHDetailTo | ActionNonFieldDetailTo | ActionOtherDetailTo | ActionRevenueDetailTo | ActionSowingDetailTo>
export type GetTargetSeedApplicationResult = AxiosResponse<TargetSeedApplicationV2ResponseTo>
export type GetActionsOverviewV2Result = AxiosResponse<ActionOverviewV2To[]>
export type GetUsedSeedsResult = AxiosResponse<CropSeedSuggestionTo[]>
export type GetUsedPlantProtectionsResult = AxiosResponse<PlantProtectionSuggestionTo[]>
export type GetUsedFertilizersResult = AxiosResponse<FertilizerSuggestionTo[]>
export type GetCropGrowthStagesResult = AxiosResponse<CropGrowthStageTo[]>
export type GetActionTypesResult = AxiosResponse<ActionTypeTo[]>
export type RemoveFromGroupResult = AxiosResponse<void>
export type DeleteProductFromCropUseResult = AxiosResponse<DeleteProductFromCropUse204>
export type DeleteActionsResult = AxiosResponse<void>
export type DeleteActionResult = AxiosResponse<void>
